// src/data.ts
var JOB_FIT_QUESTIONS = {
  promote: "Promote, sell, and network",
  "set clear goals": "Set clear goals, develop plans, organize workflow activities",
  innovate: "Innovate and generate new ideas",
  "work with numbers": "Work with numbers, data, or financial figures",
  "perform clerical": "Perform clerical tasks and administrative duties",
  "work with technology": "Work with technology and computers",
  focus: "Focus on details, work accurately and correctly",
  manage: "Manage and lead individuals or groups of workers",
  determine: "Determine the pace of work and decide when to finish a piece of work",
  gather: "Gather information and write reports",
  "work closely": "Work closely with other people and interact",
  think: "Think independently / make decisions without much supervision",
  switch: "Switch between different tasks and perform a variety of duties",
  "work on projects": "Work on projects from beginning to end",
  learn: "Learn new skills and improve knowledge",
  follow: "Follow set procedures and ways of work",
  "perform manual-labor": "Perform manual-labor or operate machinery",
  solve: "Solve new problems or issues with no obvious correct answer"
};
var CULTURE_FIT_QUESTIONS = {
  "innovative|cautious": [
    [
      "Innovative",
      "The work environment is dynamic and creative. Employees are encouraged to be innovative and experiment with new ideas."
    ],
    [
      "Risk Averse",
      "The work environment is controlled and regulated. Employees are encouraged to use tried and tested ways of work."
    ]
  ],
  "process|outcome": [
    [
      "Process Driven",
      "The work environment places high importance on performing work in the correct manner, even if deadlines are missed or profits are constrained."
    ],
    [
      "Outcomes Driven",
      "The work environment places high importance on achieving results, even if shortcuts are taken."
    ]
  ],
  "task centred|employee centred": [
    [
      "Task Centered",
      "The work environment emphasises task accomplishment over the personal and social needs of workers."
    ],
    [
      "People Centered",
      "The work environment emphasises the personal and social needs of workers over task accomplishment."
    ]
  ],
  "collective|individual": [
    [
      "Collectivist",
      "The work environment emphasises group or team achievements over individual achievements. Recognition and rewards are allocated to groups or teams as a whole."
    ],
    [
      "Individualist",
      "The work environment emphasises individual achievements over team or group achievements. Individuals are singled out for recognition or rewards."
    ]
  ],
  "centralised control|delegated control": [
    [
      "Centralised Control",
      "The work environment restricts decision-making authority to management. Employees do not have autonomy to make business decisions."
    ],
    [
      "Delegated Control",
      "The work environment empowers employees at any level to make business decisions. Decision-making authority is widespread."
    ]
  ],
  "hierarchical structure|horizontal structure": [
    ["Hierarchical Structure", "The work environment has many layers of management."],
    ["Flat Structure", "The work environment has few or no layers of management."]
  ],
  "ad-hoc|planned": [
    [
      "Responsive",
      "The work environment places emphasis on dealing with day-to-day or recent issues over longer-term strategic goals. It is important that all problems are responded to quickly."
    ],
    [
      "Planned",
      "The work environment places emphasis on achieving longer-term strategic goals. When recent events and problems are discussed it is usually in terms of their impact on the long-term strategy."
    ]
  ],
  "conformity|individuality": [
    ["Conformity", "The work environment requires employees to follow rules and procedures."],
    [
      "Individuality",
      "The work environment gives employees personal freedom. They are not required to follow rules and procedures."
    ]
  ],
  "accepting|questioning": [
    [
      "Accepting",
      "The work environment requires employees to do as they are told and not question management directives."
    ],
    [
      "Questioning",
      "The work environment encourages employees to speak-up and challenge management directives."
    ]
  ],
  "cooperation|competition": [
    [
      "Cooperation",
      "The work environment emphasises team spirit and collaboration. Team members are considered as trusted colleagues in a common cause."
    ],
    [
      "Competition",
      "The work environment emphasises competition between peers. Team members are considered competitors for scarce resources or customers."
    ]
  ],
  "external|internal": [
    [
      "Customer Focused",
      "The work environment emphasises customer satisfaction and service quality over the improvement of internal processes or cost reductions."
    ],
    [
      "Internal Effectiveness",
      "The work environment emphasises the improvement of internal processes or cost reductions over customer satisfaction and service quality."
    ]
  ],
  "formalised|informal": [
    [
      "Formal",
      "The work environment has many formal policies and procedures to help justify decision making and action taking."
    ],
    [
      "Informal",
      "The work environment has relatively few or no formal policies and procedures to help guide decision-making and action taking."
    ]
  ]
};
var PERSONALITY_FIT_1_QUESTIONS = {
  "i generally talk": {
    text: "I generally talk more than others when working in a group.",
    options: ["E", "I"]
  },
  "i tend": {
    text: "I tend to make decisions based on instinct rather than the facts and details of a problem.",
    options: ["N", "S"]
  },
  "i am forthright": {
    text: "I am forthright and to the point. I prefer to keep personal feelings and emotions to a minimum.",
    options: ["T", "F"]
  },
  "i am generally": {
    text: "I am generally prepared and on time.",
    options: ["J", "P"]
  },
  "i find": {
    text: "I find it easy to start conversations with others, including strangers.",
    options: ["E", "I"]
  },
  "i enjoy": {
    text: "I enjoy philosophical conversations and thinking about abstract ideas.",
    options: ["N", "S"]
  },
  "i struggle": {
    text: "I struggle to tell people unpleasant things.",
    options: ["F", "T"]
  },
  "i prefer": {
    text: "I prefer to take things as they come and not to have set plans.",
    options: ["P", "J"]
  },
  "i would": {
    text: "I would much rather work alone than in a group.",
    options: ["I", "E"]
  },
  "i pay": {
    text: "I pay little attention to the facts and details of a problem and prefer to focus on the bigger picture.",
    options: ["N", "S"]
  },
  "i make": {
    text: "I make most decisions on compassion rather than objectivity.",
    options: ["F", "T"]
  },
  "i don't": {
    text: "I don't mind changing plans at the last minute.",
    options: ["P", "J"]
  },
  "i am quiet": {
    text: "I am quiet, reserved, and introspective.",
    options: ["I", "E"]
  },
  "i like living": {
    text: "I like living in the moment. I have little interest in visualising and dreaming about what the future could be like.",
    options: ["S", "N"]
  },
  "i am more": {
    text: "I am more influenced by other people's views of what is right and wrong than by hard facts or evidence.",
    options: ["F", "T"]
  },
  "i generally have": {
    text: "I generally have to rush to get things done the last minute.",
    options: ["P", "J"]
  },
  "i openly": {
    text: "I openly share personal information with others.",
    options: ["E", "I"]
  },
  "i am always": {
    text: "I am always coming up with new ideas that challenge the way things are normally done.",
    options: ["N", "S"]
  },
  "i place": {
    text: "I place greater value on opinions and personal views than rationality and analysis.",
    options: ["F", "T"]
  },
  "i like to": {
    text: "I like to leave things open, to gather more information.",
    options: ["P", "J"]
  }
};
var PERSONALITY_FIT_2_QUESTIONS = {
  "Quiet|Chatty": {
    options: ["I", "E"]
  },
  "Ideas|Facts": {
    options: ["N", "S"]
  },
  "Support|Critique": {
    options: ["F", "T"]
  },
  "Spontaneous|Organised": {
    options: ["P", "J"]
  },
  "Outgoing|Reserved": {
    options: ["E", "I"]
  },
  "Details|Overview": {
    options: ["S", "N"]
  },
  "Fair|Kind-hearted": {
    options: ["T", "F"]
  },
  "Planned|Unplanned": {
    options: ["J", "P"]
  },
  "Outward|Inward": {
    options: ["E", "I"]
  },
  "Present|Future": {
    options: ["S", "N"]
  },
  "Proficient|Caring": {
    options: ["T", "F"]
  },
  "Control|Explore": {
    options: ["J", "P"]
  },
  "Detached|Sociable": {
    options: ["I", "E"]
  },
  "Real|Imagine": {
    options: ["S", "N"]
  },
  "Feelings|Examination": {
    options: ["F", "T"]
  },
  "Action|Information": {
    options: ["J", "P"]
  },
  "Private|People": {
    options: ["I", "E"]
  },
  "Vision|Concrete": {
    options: ["N", "S"]
  },
  "Understand|Analyse": {
    options: ["F", "T"]
  },
  "Conclusions|Options": {
    options: ["J", "P"]
  },
  "Share|Private": {
    options: ["E", "I"]
  },
  "Understand|Evaluate": {
    options: ["F", "T"]
  },
  "Input|Aspirations": {
    options: ["S", "N"]
  },
  "Destination|Journey": {
    options: ["J", "P"]
  }
};

// src/utils/cultureDimensions.ts
var CULTURE_DIMENSIONS = [
  "innovative|cautious",
  "process|outcome",
  "task centred|employee centred",
  "collective|individual",
  "centralised control|delegated control",
  "hierarchical structure|horizontal structure",
  "ad-hoc|planned",
  "conformity|individuality",
  "accepting|questioning",
  "cooperation|competition",
  "external|internal",
  "formalised|informal"
];
var ENGAGEMENT_DIMENSIONS = [
  "financial",
  "operational",
  "learningGrowth",
  "customerQuality",
  "jobEngagement",
  "jobSatisfaction",
  "turnoverIntention",
  "workMotivation",
  "overallClimate"
];
var PERSONAL_CLIMATE_QUESTIONS = [
  "jobEngagement",
  "jobSatisfaction",
  "turnoverIntention",
  "workMotivation",
  "overallClimate"
];
var COMPANY_CLIMATE_QUESTIONS = [
  "financial",
  "operational",
  "learningGrowth",
  "customerQuality"
];
var CULTURE_ENTITY_TYPES = [
  "DIVISION",
  "GROUP",
  "LOCATION",
  "TENURE_BAND",
  "JOB_LEVEL"
];
var culturePoleLabels = (dimension) => {
  const asked = askedPoles(dimension);
  if (asked)
    return asked;
  const [low = dimension, high = dimension] = dimension.split("|");
  return { low, high };
};
var askedPoles = (dimension) => {
  const questions = CULTURE_FIT_QUESTIONS;
  const [low, high] = questions[dimension]?.map(([label]) => label) ?? [];
  if (!low || !high)
    return null;
  return { low, high };
};

// src/utils/personality_type.ts
function calculatePersonalityType(answers) {
  const counters = { I: 0, E: 0, N: 0, S: 0, T: 0, F: 0, J: 0, P: 0 };
  answers.forEach(({ answer }) => counters[answer]++);
  const { I, E, N, S, T, F, J, P } = counters;
  return [
    I > E ? "I" : "E",
    N > S ? "N" : "S",
    T > F ? "T" : "F",
    J > P ? "J" : "P"
  ].join("");
}
var PERSONALITY_FIT_QUESTION_COUNT = Object.keys(PERSONALITY_FIT_1_QUESTIONS).length + Object.keys(PERSONALITY_FIT_2_QUESTIONS).length;
var campaigner = {
  title: "The Campaigner",
  personalityTypes: ["ENTP", "ENFJ"],
  catchPhrase: "Let's sell the dream",
  characteristics: [
    "Negotiator, seller, promoter.",
    "People-oriented, enthusiastic.",
    "Draws people in, attracts audiences.",
    "Inspiring, persuading & influential.",
    "Big picture thinker, imaginative"
  ],
  workPreferences: [
    "Prefers variety and excitement over routine.",
    "Enjoys networking and building relationships.",
    "Thrives on persuading and influencing others.",
    "Prefers strategic creative ideation.",
    "Enjoys the thrill of the chase."
  ],
  blindSpots: [
    "May overlook details for broader vision.",
    "Can prioritise popularity over practicality.",
    "Risk of overcommitting or overpromising.",
    "Might neglect routine or structured tasks."
  ],
  dos: [
    "Do set clear, measurable goals to focus their energy.",
    "Do provide platforms for their creativity and expression.",
    "Do encourage them to delegate detail-oriented tasks.",
    "Do use structured feedback to guide their enthusiasm."
  ],
  donts: [
    "Don't confine them to routine, repetitive tasks.",
    "Don't criticise their ideas without offering constructive alternatives.",
    "Don't limit their interaction with others.",
    "Don't ignore their need for personal expression and visibility."
  ]
};
var evaluator = {
  title: "The Evaluator",
  personalityTypes: ["ENTJ", "ESTP"],
  catchPhrase: "Let's weigh up our options",
  characteristics: [
    "Logical, critical, realistic.",
    "Objective risk evaluator.",
    "Investigative, analytical, critiquing.",
    "Action oriented, deliberate, & prudent.",
    "Outgoing yet individualistic."
  ],
  workPreferences: [
    "Enjoys testing ideas and weighing-up alternatives.",
    "Likes to experiment and problem-solve.",
    "Prefers variety over routine in problem-solving.",
    "Prefers data-driven decision-making.",
    "Likes strategic risk management."
  ],
  blindSpots: [
    "Perceived as overly critical.",
    "Desire for detailed analysis can delay decision-making.",
    "May dismiss intuitive or less rational ideas.",
    "Can be confrontational in discussions.",
    "Often sceptical of unproven concepts."
  ],
  dos: [
    "Do provide opportunities for analytical challenges.",
    "Do use their skills in strategic planning and risk assessment.",
    "Do encourage open and constructive expression of thoughts.",
    "Do balance their critique with positive reinforcement."
  ],
  donts: [
    "Don't dismiss their need for data and thorough analysis.",
    "Don't rush them into decisions without proper evaluation.",
    "Don't sideline them in brainstorming that values quantity over quality.",
    "Don't ignore their insights on potential risks and drawbacks."
  ]
};
var coordinator = {
  title: "The Coordinator",
  personalityTypes: ["ESTJ", "INTJ"],
  catchPhrase: "Let's make a plan",
  characteristics: [
    "Organised, prepared, dependable.",
    "Deliberate and quick to make decisions.",
    "Determined and persistent.",
    "Action and results oriented.",
    "Analytical and objective."
  ],
  workPreferences: [
    "Sets priorities, implements targets, enforces deadlines.",
    "Enjoys developing procedures and systems.",
    "Works methodically towards goals.",
    "Values efficiency and effectiveness.",
    "Prefers structured and planned environments."
  ],
  blindSpots: [
    "Struggles with flexibility and spontaneous changes.",
    "May be overly rigid in processes and systems.",
    "Can prioritise process over people.",
    "Sometimes dismisses unconventional ideas."
  ],
  dos: [
    "Do clearly define roles and expectations for them.",
    "Do provide them authority to enforce standards and procedures.",
    "Do regularly update goals and seek their input on plans.",
    "Do encourage them to consider and evaluate alternative approaches."
  ],
  donts: [
    "Don't expect spontaneous decision-making without preparation.",
    "Don't frequently change plans or goals without consultation.",
    "Don't overlook the importance they place on structure and order.",
    "Don't devalue their methodical approach to problem-solving."
  ]
};
var doer = {
  title: "The Doer",
  personalityTypes: ["ESFJ", "ISTJ"],
  catchPhrase: "Let's get it done",
  characteristics: [
    "Dependable, consistent performer.",
    "Efficient and results-driven.",
    "Practical and task oriented.",
    "Direct and straightforward communicator.",
    "Focused on facts, details, and present moment."
  ],
  workPreferences: [
    "Enjoys routine and tried and true methods.",
    "Emphasises meeting deadlines and achieving outcomes.",
    "Prefers clear, concrete tasks.",
    "Values predictability and stability in workflow.",
    "Dedicated to quality and precision."
  ],
  blindSpots: [
    "Resistant to new methodologies.",
    "Can become overly focused on tasks at the expense of innovation.",
    "May lack flexibility in dynamic environments.",
    "Often sceptical of speculative or abstract ideas."
  ],
  dos: [
    "Do establish clear and consistent routines.",
    "Do set specific, quantifiable objectives.",
    "Do introduce changes gradually, with clear reasoning.",
    "Do provide regular feedback on performance and results."
  ],
  donts: [
    "Don't push for innovation without providing a stable framework.",
    "Don't overlook the need for clear instructions and outcomes.",
    "Don't burden them with ambiguous or poorly defined tasks.",
    "Don't disregard their need for predictability and reliability in workflows."
  ]
};
var auditor = {
  title: "The Auditor",
  personalityTypes: ["ISTP", "ISFJ"],
  catchPhrase: "Let's focus on the details",
  characteristics: [
    "Thorough, accurate, and exacting.",
    "Reserved, reflective, and contemplative.",
    "Prefers facts and detail-oriented tasks.",
    "Patient and persistent",
    "Cautious and risk-averse"
  ],
  workPreferences: [
    "Enjoys scrutinising and inspecting.",
    "Prefers to focus on present details and precision.",
    "Enforces standards, procedures, and control mechanisms.",
    "Values thoroughness and accuracy in all tasks.",
    "Finds satisfaction in maintaining order and compliance."
  ],
  blindSpots: [
    "May become overly focused on minor details, missing the bigger picture.",
    "Can be slow in decision-making due to excessive deliberation.",
    "Might resist quick or innovative changes that disrupt established methods.",
    "Occasionally struggles with tasks requiring high levels of creativity."
  ],
  dos: [
    "Do provide specific, detailed instructions for best results.",
    "Do allow time for thorough review and quality control.",
    "Do recognise their contributions to precision and accuracy.",
    "Do use their strengths in tasks requiring meticulous attention to detail."
  ],
  donts: [
    "Don't rush them through tasks that require careful analysis.",
    "Don't undervalue their focus on standards and procedures.",
    "Don't overlook their need for clear and structured guidelines.",
    "Don't dismiss their caution in decision-making as unnecessary delay."
  ]
};
var helper = {
  title: "The Helper",
  personalityTypes: ["INFJ", "ISFP"],
  catchPhrase: "Let's support each other",
  characteristics: [
    "Empathetic, persuasive, and perceptive of others' feelings.",
    "Reserved, reflective, and contemplative",
    "Considerate and enjoys helping and supporting others.",
    "Driven by personal values and beliefs.",
    "Approachable, nurturing, and inclusive."
  ],
  workPreferences: [
    "Values building supportive and harmonious relationships.",
    "Service oriented tasks and collaborative group focus. ",
    "Seeks roles that allow active contribution to team well-being.",
    "Enjoys tasks that involve interpersonal communication.",
    "Finds motivation in roles that align with personal ethics."
  ],
  blindSpots: [
    "May avoid confrontations, even when necessary.",
    "Could struggle with tasks requiring aggressive or competitive actions.",
    "Might prioritise relationships over task completion.",
    "Occasionally overlooks analytical or data-driven decision-making."
  ],
  dos: [
    "Do involve them in team-building and collaborative projects.",
    "Do provide opportunities for them to mentor or support others.",
    "Do value their empathetic approach and people-focused skills.",
    "Do encourage their input in defining team and organisational values."
  ],
  donts: [
    "Don't isolate them or limit their interaction with team members.",
    "Don't overlook their need for personal connection in the workplace.",
    "Don't undervalue their role in maintaining group morale and support.",
    "Don't push them into situations where confrontation is likely without support."
  ]
};
var advisor = {
  title: "The Advisor",
  personalityTypes: ["INFP", "ESFP"],
  catchPhrase: "Let's investigate the problem",
  characteristics: [
    "Collaborator, mentor, and counsellor.",
    "Open-ended and flexible.",
    "Seeks to understand and is tolerant.",
    "Diplomatic and encouraging.",
    "Easy to share with and likeable."
  ],
  workPreferences: [
    "Enjoys gathering information, sharing knowledge.",
    "Values roles that use their knowledge-sharing capabilities.",
    "Prefers environments that allow for intellectual exploration.",
    "Appreciates being consulted on complex issues.",
    "Finds motivation in helping others develop and grow."
  ],
  blindSpots: [
    "Can be overly accommodating, affecting decisiveness.",
    "May spend too much time exploring all possible options.",
    "Might avoid taking firm stances in conflicts.",
    "Occasionally lacks urgency in time-sensitive situations."
  ],
  dos: [
    "Do use their ability to gather and analyse information.",
    "Do encourage their role as a consultant or mentor within the team.",
    "Do provide flexibility in their approach to solving problems.",
    "Do support their desire to understand and tolerate diverse perspectives."
  ],
  donts: [
    "Don't restrict their access to information they might find useful.",
    "Don't dismiss their need for thorough investigation before decision-making.",
    "Don't force them into quick conclusions without proper analysis.",
    "Don't ignore their potential in roles that require diplomacy and mediation."
  ]
};
var pioneer = {
  title: "The Pioneer",
  personalityTypes: ["ENFP", "INTP"],
  catchPhrase: "Let's do it differently",
  characteristics: [
    "Innovator and conceptual thinker.",
    "Spontaneous, flexible, open-ended.",
    "Unplanned and future oriented.",
    "Creative, imaginative, and conceptually abstract.",
    "Risk taking and enjoys complexity."
  ],
  workPreferences: [
    "Driven by a need to innovate and initiate change.",
    "Enjoys challenging the status quo and generating new ideas.",
    "Seeks roles that challenge traditional methods.",
    "Values independence and autonomy in tasks.",
    "Thrives in dynamic and evolving environments."
  ],
  blindSpots: [
    "Can overlook established processes that still hold value.",
    "Might ignore details in favour of overarching theories.",
    "Occasionally disrupts team harmony with radical ideas.",
    "May struggle with tasks that require routine and consistency."
  ],
  dos: [
    "Do channel their innovative tendencies into structured brainstorming.",
    "Do provide opportunities for them to lead projects that require new ideas.",
    "Do encourage their visionary and future-oriented thinking.",
    "Do support their spontaneous and flexible approach to work."
  ],
  donts: [
    "Don't confine them to traditional methods without room for innovation.",
    "Don't underestimate their need to challenge the status quo.",
    "Don't ignore their suggestions for radical improvements or changes.",
    "Don't stifle their creativity with too many restrictions or rigid guidelines"
  ]
};
var workPreferenceTypes = [
  campaigner,
  evaluator,
  coordinator,
  doer,
  auditor,
  helper,
  advisor,
  pioneer
];
var workPreferences = {
  campaigner,
  evaluator,
  coordinator,
  doer,
  auditor,
  helper,
  advisor,
  pioneer
};
var personalityFit = (candidateQuizAnswers) => {
  const personalityTypes = candidateQuizAnswers?.length === PERSONALITY_FIT_QUESTION_COUNT ? [calculatePersonalityType(candidateQuizAnswers)] : [];
  if (personalityTypes.length > 0) {
    return workPreferenceTypes.find(
      (t) => t.personalityTypes.includes(personalityTypes[0])
    );
  }
  return void 0;
};

// src/utils/individualPreferences.ts
var balancedPreferences = {
  summary: "By implementing these strategies, groups can capitalise on the strengths of a diverse personality composition, ensuring a dynamic, innovative, and highly effective collaboration.",
  tips: [
    {
      heading: "Leverage individual strengths",
      text: "Regularly assess and leverage the unique strengths and preferences of each team member. Tailor tasks and projects to align with these strengths, thereby maximising productivity and job satisfaction."
    },
    {
      heading: "Encourage skill development",
      text: "Promote continuous learning and skill development to ensure that team members are not only confined to their areas of preference but can also competently handle tasks outside their comfort zones. This broadens the team's skill set and prepares it for unexpected challenges."
    },
    {
      heading: "Rotate roles",
      text: "Consider rotating roles or responsibilities occasionally to give team members exposure to different aspects of the work. This can enhance empathy within the team, reduce monotony, and spark new interests."
    },
    {
      heading: "Implement collaborative decision-making",
      text: "Engage the group in collaborative decision-making processes. This approach not only harnesses the diverse strengths of the group but also ensures buy-in and commitment to the decisions made."
    },
    {
      heading: "Adapt leadership styles",
      text: "Be flexible in your leadership approach to meet the varying needs of team members. A leader who can adapt their style to motivate and engage members effectively, based on their work preferences, can drive the group towards achieving its collective goals more efficiently."
    }
  ],
  preview: "<p>On the personality wheel, each <strong>dot</strong> represents a group member\u2019s <strong>dominant</strong> preference for performing one of 8 key work types. The <strong>closer</strong> other work types are to the member's dominant preference, the higher their motivation to perform and engage in that work. Conversely, the more <strong>distant</strong> these work types are from the member's dominant preference, the lower their motivation and enthusiasm for doing that work...</p>",
  description: "<p>On the personality wheel, each <strong>dot</strong> represents a group member\u2019s <strong>dominant</strong> preference for performing one of 8 key work types. The <strong>closer</strong> other work types are to the member's dominant preference, the higher their motivation to perform and engage in that work. Conversely, the more <strong>distant</strong> these work types are from the member's dominant preference, the lower their motivation and enthusiasm for doing that work.</p> <p>Based on the personality types of its members, this group exhibits a balanced dominance across all eight key work types, laying the foundation for a high-performing team. Each member's dominant preference aligns with one of these key work types, ensuring the possibility for well-rounded and effective group collaboration.</p> <p>Building on the foundation of a group that displays an even distribution of dominant preferences for all eight key work types, here are additional strategies to maximise effectiveness and foster a thriving group environment:</p>"
};
var singularPreferences = {
  summary: "<p>Addressing these issues requires thoughtful leadership and strategic planning. It is crucial to foster an environment that values diversity and flexibility. Encouraging members to develop capabilities and skills outside their dominant preferences, creating mixed-function teams for projects, and ensuring equitable task distribution can help mitigate conflicts. Recognising and valuing the contributions of all dominant work types, promoting open communication, and facilitating conflict resolution training are also key to maintaining a harmonious and effective team dynamic.</p><p>In essence, recognising and actively managing the implications of overrepresented and underrepresented work types is vital for nurturing a productive, innovative, and cohesive team environment.</p>",
  tips: [
    {
      heading: "Increased potential for conflict",
      text: "Underrepresentation of certain work types can lead to conflicts over task allocation and responsibilities. Members may compete for preferred tasks while avoiding less desired ones, causing friction and dissatisfaction."
    },
    {
      heading: "Neglect of key functions",
      text: "Essential functions associated with underrepresented work types may not be adequately addressed, risking the neglect of tasks critical to the team's success. This imbalance can compromise the group's performance and its ability to achieve objectives efficiently."
    },
    {
      heading: "Strain on group dynamics",
      text: "The overrepresentation of certain preferences might create groupthink, stifling innovation and critical thinking. At the same time, members with underrepresented preferences may feel isolated or undervalued, affecting team cohesion and morale."
    },
    {
      heading: "Overburdening of certain members",
      text: "A few members might end up shouldering tasks associated with underrepresented work types, leading to burnout and resentment. This imbalance can disrupt work-life balance and reduce overall job satisfaction."
    }
  ],
  preview: "<p>On the personality wheel, each <strong>dot</strong> represents a group member\u2019s <strong>dominant</strong> preference for performing one of 8 key work types. The <strong>closer</strong> other work types are to the member's dominant preference, the higher their motivation to perform and engage in that work. Conversely, the more <strong>distant</strong> these work types are from the member's dominant preference, the lower their motivation and enthusiasm for doing that work...</p>",
  description: "<p>On the personality wheel, each <strong>dot</strong> represents a group member\u2019s <strong>dominant</strong> preference for performing one of 8 key work types. The <strong>closer</strong> other work types are to the member's dominant preference, the higher their motivation to perform and engage in that work. Conversely, the more <strong>distant</strong> these work types are from the member's dominant preference, the lower their motivation and enthusiasm for doing that work.</p> <p>Based on the personality types of its members, this group exhibits a dominant preference for performing <strong>only</strong> 1 of the 8 key work types ([workType]) essential for high-performing teams.</p><p>While an even distribution across each of the 8 key work types typically enhances the group's overall motivation, focus, and productivity, an <strong>imbalance</strong>, where certain work types are <strong>overrepresented</strong> and others are <strong>underrepresented</strong>, can lead to various challenges:</p>"
};
var incompleteBalancedPreferences = {
  summary: "Addressing the absence of dominant preferences in certain key work types requires deliberate planning and the willingness to adapt, ensuring the team remains dynamic, versatile, and well-equipped to meet various challenges and opportunities.",
  tips: [
    {
      heading: "Potential for conflict",
      text: "The lack of representation for certain work types may lead to internal conflict when these areas require attention. Members might feel overextended or out of their depth when forced to take on roles and tasks that do not align with their dominant preferences."
    },
    {
      heading: "Challenges in addressing underrepresented work types",
      text: "Tasks associated with underrepresented work types might not be performed with the same level of expertise or enthusiasm, potentially affecting the group's overall performance."
    },
    {
      heading: "Opportunity for external collaboration",
      text: "This gap in preferences offers an opportunity to hire and/or collaborate with others outside the group who possess a strong inclination towards the underrepresented work types, fostering partnerships and expanding the group\u2019s capabilities."
    },
    {
      heading: "Development and training",
      text: "Recognising these gaps, the group can prioritise development and training in the underrepresented areas, promoting personal growth and increasing the team's versatility."
    },
    {
      heading: "Strategic role allocation",
      text: "Leaders can strategically allocate roles or projects to encourage members to explore and develop skills in less preferred but key work types, thus gradually reducing the gap in the team's capabilities."
    }
  ],
  preview: "<p>On the personality wheel, each <strong>dot</strong> represents a group member\u2019s <strong>dominant</strong> preference for performing one of 8 key work types. The <strong>closer</strong> other work types are to the member's dominant preference, the higher their motivation to perform and engage in that work. Conversely, the more <strong>distant</strong> these work types are from the member's dominant preference, the lower their motivation and enthusiasm for doing that work...</p>",
  description: "<p>On the personality wheel, each <strong>dot</strong> represents a group member\u2019s <strong>dominant</strong> preference for performing one of 8 key work types. The <strong>closer</strong> other work types are to the member's dominant preference, the higher their motivation to perform and engage in that work. Conversely, the more <strong>distant</strong> these work types are from the member's dominant preference, the lower their motivation and enthusiasm for doing that work.</p> <p>Based on the personality types of its members, this group exhibits a balanced dominance for performing [notEmptyCount]  of the 8 key work types essential for high-performing teams. However, no group member has a dominant preference for performing the key work types of [empty].</p> <p>Despite not having a dominant preference for these [emptyCount] key work types, the even distribution and balance across the dominant preferences prevent any single work type from overshadowing others and helps to ensure diverse viewpoints and constructive feedback, reducing the risk of groupthink and fostering a more well-rounded approach to tasks. Yet, it also brings forth potential for the following issues:</p>"
};
var unbalancedPreferences = {
  summary: "Addressing these issues requires thoughtful leadership and strategic planning. It is crucial to foster an environment that values diversity and flexibility. Encouraging members to develop capabilities and skills outside their dominant preferences, creating mixed-function teams for projects, and ensuring equitable task distribution can help mitigate conflicts. Recognising and valuing the contributions of all dominant work types, promoting open communication, and facilitating conflict resolution training are also key to maintaining a harmonious and effective team dynamic. In essence, recognising and actively managing the implications of overrepresented and underrepresented work types is vital for nurturing a productive, innovative, and cohesive team environment.",
  tips: [
    {
      heading: "Increased potential for conflict",
      text: "Underrepresentation of certain work types can lead to conflicts over task allocation and responsibilities. Members may compete for preferred tasks while avoiding less desired ones, causing friction and dissatisfaction."
    },
    {
      heading: "Neglect of key functions",
      text: "Essential functions associated with underrepresented work types may not be adequately addressed, risking the neglect of tasks critical to the team's success. This imbalance can compromise the group's performance and its ability to achieve objectives efficiently."
    },
    {
      heading: "Strain on group dynamics",
      text: "The overrepresentation of certain preferences might create groupthink, stifling innovation and critical thinking. At the same time, members with underrepresented preferences may feel isolated or undervalued, affecting team cohesion and morale."
    },
    {
      heading: "Overburdening of certain members",
      text: "A few members might end up shouldering tasks associated with underrepresented work types, leading to burnout and resentment. This imbalance can disrupt work-life balance and reduce overall job satisfaction."
    }
  ],
  preview: "<p>On the personality wheel, each <strong>dot</strong> represents a group member\u2019s <strong>dominant</strong> preference for performing one of 8 key work types. The <strong>closer</strong> other work types are to the member's dominant preference, the higher their motivation to perform and engage in that work. Conversely, the more <strong>distant</strong> these work types are from the member's dominant preference, the lower their motivation and enthusiasm for doing that work...</p>",
  description: "<p>On the personality wheel, each <strong>dot</strong> represents a group member\u2019s <strong>dominant</strong> preference for performing one of 8 key work types. The <strong>closer</strong> other work types are to the member's dominant preference, the higher their motivation to perform and engage in that work. Conversely, the more <strong>distant</strong> these work types are from the member's dominant preference, the lower their motivation and enthusiasm for doing that work.</p> <p>Based on the personality types of its members, this group exhibits an uneven preference for the 8 key work types essential for high performing teams. <p>This group has the following dominant work preferences:</p>[preferences]There are no group members that have a dominant preference for [empty].<p>While an even distribution across each of the 8 key work types typically enhances the group's overall motivation, focus and productivity, an <strong>imbalance</strong>, where certain work types are <strong>overrepresented</strong> and others are <strong>underrepresented</strong>, can lead to various challenges:</p>"
};
var individualPreferences = {
  singular: singularPreferences,
  balanced: balancedPreferences,
  incompleteBalanced: incompleteBalancedPreferences,
  unbalanced: unbalancedPreferences
};

// src/utils/groupPreferences.ts
var equalCoverage = {
  text: "<p>Beyond an individual\u2019s dominant work type preference (based on their personality type), a critical aspect of working in a group is understanding the varying degrees by which members are <strong>collectively motivated</strong> (or demotivated) to perform each of the work types.</p> <p>As individuals come together to <strong>form a group</strong>, there is an <strong>interplay</strong> between everyone\u2019s dominant and less dominant work type preferences. This gives you an insight into how the group is collectively motivated to perform each of the 8 key types of work.</p> <p>On the personality wheel, that interplay is represented by the varying shades of blue across the key work type preferences. This is calculated as a percentage and is based on all preferences (dominant and less dominant) for the whole group. When there is only one shade of blue, it indicates that the group has an equal preference for performing all the eight key work types.</p> <p>Based on your group\u2019s work type preferences, this group collectively shares an equal preference and motivation for performing each of the 8 key work types.</p> <p>To continue building the group\u2019s performance and it\u2019s ability to deliver, it is important that the group regularly analyse the most important things to STOP, START, and CONTINUE to do across each of the 8 key types of work.</p> <p>Examples of this might include the following:</p>",
  note: "",
  campaigner: {
    heading: 'Campaigning: "Let\u2019s sell the dream\u201D',
    tips: [
      {
        heading: "STOP",
        text: "Avoiding routine tasks or detailed work that may seem mundane but are crucial for the completion of group projects."
      },
      {
        heading: "START",
        text: "Implementing a structured approach to tasks to ensure that the enthusiasm for new ideas translates into actionable and completed projects."
      },
      {
        heading: "CONTINUE",
        text: "Leveraging natural enthusiasm to drive group motivation and engagement in projects, ensuring the group remains inspired throughout the project lifecycle."
      }
    ]
  },
  evaluator: {
    heading: 'Evaluating: "Let\u2019s weigh up our options"',
    tips: [
      {
        heading: "STOP",
        text: "Overanalysing to the point of decision paralysis. While it's important to evaluate options, excessive deliberation can hinder group progress."
      },
      {
        heading: "START",
        text: "Prioritising decisions based on their impact, allowing for faster movement on less critical issues."
      },
      {
        heading: "CONTINUE",
        text: "Analysing and critiquing processes to improve efficiency and effectiveness."
      }
    ]
  },
  coordinator: {
    heading: 'Coordinating: "Let\u2019s make a plan"',
    tips: [
      {
        heading: "STOP",
        text: "Over-planning without leaving room for flexibility. It's important to adapt to changes and unexpected challenges."
      },
      {
        heading: "START",
        text: "Encouraging group input in planning processes to foster ownership and collaboration."
      },
      {
        heading: "CONTINUE",
        text: "Developing organised systems and procedures to keep group projects on track and ensure deadlines are met."
      },
      ,
    ]
  },
  doer: {
    heading: 'Doing: "Let\u2019s get it done"',
    tips: [
      {
        heading: "STOP",
        text: "Prioritising task completion over strategic alignment, which may lead to working hard on tasks that don\u2019t contribute to the main goals."
      },
      {
        heading: "START",
        text: "Seeking opportunities for improvement in routine tasks to increase efficiency and effectiveness."
      },
      {
        heading: "CONTINUE",
        text: "Being reliable and efficient in completing tasks, ensuring that projects progress smoothly."
      }
    ]
  },
  auditor: {
    heading: 'Auditing: "Let\u2019s focus on the details"',
    tips: [
      {
        heading: "STOP",
        text: "Focusing solely on fault-finding without providing constructive solutions that can help move projects forward."
      },
      {
        heading: "START",
        text: "Implementing regular quality checks throughout project lifecycles, not just at the end, to ensure ongoing excellence and adherence to standards."
      },
      {
        heading: "CONTINUE",
        text: "Maintaining high standards for accuracy and quality in all outputs, ensuring the group\u2019s work meets or exceeds expectations."
      }
    ]
  },
  helper: {
    heading: 'Helping: "Let\u2019s support each other"',
    tips: [
      {
        heading: "STOP",
        text: "Dedicating resources to support initiatives that don\u2019t directly contribute to the group\u2019s objectives or strategic goals."
      },
      {
        heading: "START",
        text: "Establishing mentorship and support structures that encourage personal and professional development within the context of group\u2019s goals."
      },
      {
        heading: "CONTINUE",
        text: "Fostering a collaborative and supportive group environment that values the contributions of all members."
      }
    ]
  },
  advisor: {
    heading: 'Advising: "Let\u2019s investigate the problem"',
    tips: [
      {
        heading: "STOP",
        text: "Spending too much time in the consultation  / analysis phase without moving forward with actionable solutions."
      },
      {
        heading: "START",
        text: "Focusing on actionable advice and practical solutions to encourage progress and problem resolution."
      },
      {
        heading: "CONTINUE",
        text: "Sharing knowledge and expertise to build group capability, ensuring the group can effectively address similar challenges in the future."
      }
    ]
  },
  pioneer: {
    heading: 'Pioneering: "Let\u2019s do it differently"',
    tips: [
      {
        heading: "STOP",
        text: "Constantly shifting directions with new ideas without fully exploring or implementing the current initiatives."
      },
      {
        heading: "START",
        text: "Balancing innovative ideas with practical implementation strategies to ensure ideas are actionable."
      },
      {
        heading: "CONTINUE",
        text: "Challenging the status quo and encouraging a group culture of creativity and forward-thinking."
      }
    ]
  }
};
var almostEqualCoverage = {
  text: "<p>Beyond an individual\u2019s dominant work type preference (based on their personality type), a critical aspect of working in a group is understanding the varying degrees by which members are <strong>collectively motivated</strong> (or demotivated) to perform each of the work types.</p> <p>As individuals come together to <strong>form a group</strong>, there is an <strong>interplay</strong> between everyone\u2019s dominant and less dominant work type preferences. This gives you an insight into how the group is collectively motivated to perform each of the 8 key types of work.</p> <p>On the personality wheel, that interplay is represented by the varying shades of blue across the key work type preferences. This is calculated as a percentage and is based on all preferences (dominant and less dominant) for the whole group. When there is only one shade of blue, it indicates that the group has an equal preference for performing all the eight key work types.</p> <p>Based on your group\u2019s work type preferences, this group is <strong>approaching</strong> an equal preference and motivation for performing each of the 8 key work types.</p> <p>To continue building the group\u2019s performance and it\u2019s ability to deliver, it is important that the group regularly analyse the most important things to STOP, START, and CONTINUE to do across each of the 8 key types of work.</p> <p>Examples of this might include the following:</p>",
  note: "",
  campaigner: {
    heading: 'Campaigning: "Let\u2019s sell the dream\u201D',
    tips: [
      {
        heading: "STOP",
        text: "Avoiding routine tasks or detailed work that may seem mundane but are crucial for the completion of group projects."
      },
      {
        heading: "START",
        text: "Implementing a structured approach to tasks to ensure that the enthusiasm for new ideas translates into actionable and completed projects."
      },
      {
        heading: "CONTINUE",
        text: "Leveraging natural enthusiasm to drive group motivation and engagement in projects, ensuring the group remains inspired throughout the project lifecycle."
      }
    ]
  },
  evaluator: {
    heading: 'Evaluating: "Let\u2019s weigh up our options"',
    tips: [
      {
        heading: "STOP",
        text: "Overanalysing to the point of decision paralysis. While it's important to evaluate options, excessive deliberation can hinder group progress."
      },
      {
        heading: "START",
        text: "Prioritising decisions based on their impact, allowing for faster movement on less critical issues."
      },
      {
        heading: "CONTINUE",
        text: "Analysing and critiquing processes to improve efficiency and effectiveness."
      }
    ]
  },
  coordinator: {
    heading: 'Coordinating: "Let\u2019s make a plan"',
    tips: [
      {
        heading: "STOP",
        text: "Over-planning without leaving room for flexibility. It's important to adapt to changes and unexpected challenges."
      },
      {
        heading: "START",
        text: "Encouraging group input in planning processes to foster ownership and collaboration."
      },
      {
        heading: "CONTINUE",
        text: "Developing organised systems and procedures to keep group projects on track and ensure deadlines are met."
      },
      ,
    ]
  },
  doer: {
    heading: 'Doing: "Let\u2019s get it done"',
    tips: [
      {
        heading: "STOP",
        text: "Prioritising task completion over strategic alignment, which may lead to working hard on tasks that don\u2019t contribute to the main goals."
      },
      {
        heading: "START",
        text: "Seeking opportunities for improvement in routine tasks to increase efficiency and effectiveness."
      },
      {
        heading: "CONTINUE",
        text: "Being reliable and efficient in completing tasks, ensuring that projects progress smoothly."
      }
    ]
  },
  auditor: {
    heading: 'Auditing: "Let\u2019s focus on the details"',
    tips: [
      {
        heading: "STOP",
        text: "Focusing solely on fault-finding without providing constructive solutions that can help move projects forward."
      },
      {
        heading: "START",
        text: "Implementing regular quality checks throughout project lifecycles, not just at the end, to ensure ongoing excellence and adherence to standards."
      },
      {
        heading: "CONTINUE",
        text: "Maintaining high standards for accuracy and quality in all outputs, ensuring the group\u2019s work meets or exceeds expectations."
      }
    ]
  },
  helper: {
    heading: 'Helping: "Let\u2019s support each other"',
    tips: [
      {
        heading: "STOP",
        text: "Dedicating resources to support initiatives that don\u2019t directly contribute to the group\u2019s objectives or strategic goals."
      },
      {
        heading: "START",
        text: "Establishing mentorship and support structures that encourage personal and professional development within the context of group\u2019s goals."
      },
      {
        heading: "CONTINUE",
        text: "Fostering a collaborative and supportive group environment that values the contributions of all members."
      }
    ]
  },
  advisor: {
    heading: 'Advising: "Let\u2019s investigate the problem"',
    tips: [
      {
        heading: "STOP",
        text: "Spending too much time in the consultation  / analysis phase without moving forward with actionable solutions."
      },
      {
        heading: "START",
        text: "Focusing on actionable advice and practical solutions to encourage progress and problem resolution."
      },
      {
        heading: "CONTINUE",
        text: "Sharing knowledge and expertise to build group capability, ensuring the group can effectively address similar challenges in the future."
      }
    ]
  },
  pioneer: {
    heading: 'Pioneering: "Let\u2019s do it differently"',
    tips: [
      {
        heading: "STOP",
        text: "Constantly shifting directions with new ideas without fully exploring or implementing the current initiatives."
      },
      {
        heading: "START",
        text: "Balancing innovative ideas with practical implementation strategies to ensure ideas are actionable."
      },
      {
        heading: "CONTINUE",
        text: "Challenging the status quo and encouraging a group culture of creativity and forward-thinking."
      }
    ]
  }
};
var unequalCoverage = {
  text: "<p>Beyond an individual\u2019s dominant work type preference (based on their personality type), a critical aspect of working in a group is understanding the varying degrees by which members are <strong>collectively motivated</strong> (or demotivated) to perform each of the work types.</p> <p>As individuals come together to <strong>form a group</strong>, there is an <strong>interplay</strong> between everyone\u2019s dominant and less dominant work type preferences. This gives you an insight into how the group is collectively motivated to perform each of the 8 key types of work.</p> <p>On the personality wheel, that interplay is represented by the varying shades of blue across the key work type preferences. This is calculated as a percentage and is based on all preferences (dominant and less dominant) for the whole group. When there is only one shade of blue, it indicates that the group has an equal preference for performing all the eight key work types.</p> <p>Based on your group\u2019s work type preferences, members are collectively most likely motivated to perform the key work type(s) of [strong].</p> <p>Conversely, the group is collectively least likely to be motivated to perform the key work type(s) of [weak]. And as such the group might be inclined to avoid these types of work.</p> <p>To bridge the preferences gaps and ensure that all 8 key types of work are performed, this group should consider the following tactics:</p> <ol><li>Hire / Restructure*: Bring new members into the group that are specifically motivated to perform the least preferred types of work.</li> <li>Understand the leader\u2019s dominant work type preference and how this might impact or influence the types of work the team collectively focusses on / or avoids.</li> <li>Drive group performance and focus by establishing transparent management systems, operational mechanisms, streamlined processes, and specific performance indicators tailored to each type of work. This approach guarantees that tasks are effectively tracked and completed, embodying the principle that \u201Cwhat gets measured, gets done.\u201D For example. in this group, initiatives to provide greater coverage to the least preferred types of work might include:</li></ol> ",
  note: "<i>* Note that hiring or restructuring the group and/or implementing new initiatives and approaches may impact group dynamics, including how the group manages conflict, problem solving and communication.</i>",
  campaigner: {
    heading: "Campaigning Work:",
    tips: [
      {
        heading: "Networking challenges",
        text: "Create challenges that encourage group members to build external relationships and networks, enhancing the group\u2019s outreach and connection capabilities."
      },
      {
        heading: "Idea pitching",
        text: "Implement an internal platform where group members can pitch new ideas and projects, fostering a culture of enthusiasm and creative thinking"
      },
      {
        heading: "Collaborative partnerships",
        text: "Form alliances with other groups to share resources and expertise, maximising effectiveness in securing resources and promoting initiatives."
      },
      {
        heading: "Resourcing strategy workshops",
        text: "Hold strategy sessions to plan how to get the additional people, funds, and/or equipment needed, focusing on networking and finding budget. The objective is to garner support from higher management for the group\u2019s work and projects."
      }
    ]
  },
  evaluator: {
    heading: "Evaluating Work:",
    tips: [
      {
        heading: "Analytical skills workshops",
        text: "Provide workshops to enhance group members' analytical skills, teaching them how to critically evaluate options and make informed decisions."
      },
      {
        heading: "Risk assessment training",
        text: "Train the group in risk assessment techniques to improve their ability to objectively evaluate and mitigate potential threats to projects."
      },
      {
        heading: "Critical thinking group discussions",
        text: "Organise regular group discussions focused on critical thinking and problem-solving, encouraging a more evaluative approach to work."
      },
      {
        heading: "Scenario planning sessions",
        text: "Conduct scenario planning sessions to help the group prepare for various business scenarios, enhancing their strategic thinking and planning skills."
      }
    ]
  },
  coordinator: {
    heading: "Coordinating Work:",
    tips: [
      {
        heading: "Strategy workshops",
        text: "Host workshops to establish clear goals and objectives, ensuring alignment with organisational priorities and deadlines."
      },
      {
        heading: "Task assignment and tracking",
        text: "Set group meetings to assign tasks, clarify responsibilities, and define deadlines, using project management tools to track progress and ensure accountability."
      },
      {
        heading: "Regular progress reviews",
        text: "Conduct regular progress reviews to assess the status of tasks and projects, identify any obstacles or challenges, and take corrective action as needed to stay on track."
      },
      {
        heading: "Budget monitoring and control",
        text: "Implement budget monitoring and control mechanisms to track expenditures and ensure adherence to financial constraints, adjusting plans as necessary to optimise resource utilisation."
      }
    ]
  },
  doer: {
    heading: "Doing Work:",
    tips: [
      {
        heading: "Productivity tools training",
        text: "Introduce and train the group on productivity tools and apps to streamline workflow and enhance efficiency."
      },
      {
        heading: "Task prioritisation",
        text: "Hold regular sessions to help group members prioritise tasks effectively, focusing on results-driven strategies."
      },
      {
        heading: "Recognition programs",
        text: "Implement a system to track and recognise individual and team achievements, encouraging a results-oriented culture."
      },
      {
        heading: "Efficiency workshop",
        text: "Share and discuss 'efficiency hacks' within the group, promoting a culture of practical and efficient work habits"
      }
    ]
  },
  auditor: {
    heading: "Auditing Work:",
    tips: [
      {
        heading: "Customer feedback and satisfaction surveys",
        text: "Gather feedback from customers or clients through surveys or feedback mechanisms to assess satisfaction levels and identify areas for improvement. Use this feedback to make informed decisions and enhance customer experience."
      },
      {
        heading: "Quality assurance framework",
        text: "Develop a quality assurance framework that includes checklists and standards for all projects, ensuring thoroughness and accuracy."
      },
      {
        heading: "Quality audits",
        text: "Conduct regular quality audits of products or services to ensure they meet established standards and customer expectations. This could involve reviewing processes, inspecting outputs, and gathering feedback from customers or clients to identify areas for improvement."
      },
      {
        heading: "Safety and security inspections",
        text: "Conduct safety and security inspections to assess and mitigate potential risks within the work environment. This could involve inspecting equipment, facilities, and procedures to ensure compliance with safety regulations and protocols."
      },
      {
        heading: "Legal compliance checks",
        text: "Regularly review and ensure compliance with legal requirements and regulations relevant to your group\u2019s work. This could include assessing contracts, agreements, and policies to ensure adherence to legal standards and mitigate legal risks."
      }
    ]
  },
  helper: {
    heading: "Helping Work:",
    tips: [
      {
        heading: "Peer support program",
        text: "Establish a peer support program that pairs team members for mutual guidance and support, fostering a collaborative environment."
      },
      {
        heading: "Continuous improvement culture",
        text: "Foster a culture of continuous improvement within the group, encouraging group members to proactively identify opportunities for process enhancement and innovation."
      },
      {
        heading: "Documentation and standardisation",
        text: "Ensure that group processes are well-documented and standardised to promote consistency and clarity. This could involve creating process manuals, templates, or guidelines to guide team members in executing tasks and workflows."
      },
      {
        heading: "Regular process audits",
        text: "Conduct periodic audits of group processes to ensure they align with organisational goals and industry standards. This could involve reviewing workflows, documentation, and procedures to identify areas for improvement or compliance issues."
      }
    ]
  },
  advisor: {
    heading: "Advising Work:",
    tips: [
      {
        heading: "Problem-solving workshops",
        text: "Conduct workshops that focus on problem-solving techniques, encouraging a consultative and advisory approach among group members."
      },
      {
        heading: "Continuous improvement initiatives",
        text: "Establish a culture of continuous improvement within the group, where members are encouraged to regularly review and evaluate their practices, seek feedback, and implement changes to enhance efficiency and effectiveness in advising work."
      },
      {
        heading: "Knowledge sharing sessions",
        text: "Organise regular sessions where group members can share insights, experiences, and best practices related to their areas of expertise. This could involve presentations, workshops, or informal discussions to facilitate learning and information exchange"
      },
      {
        heading: "Peer mentoring program",
        text: "Establish a mentoring program where group members can seek advice and guidance from more experienced colleagues within the organisation. This could involve pairing individuals based on their areas of interest or expertise to facilitate knowledge transfer and skill development."
      },
      {
        heading: "Resource repository",
        text: "Create a centralised repository or database containing articles, reports, books, and other relevant resources related to the group\u2019s work. Ensure easy access and encourage team members to contribute new resources or updates regularly."
      }
    ]
  },
  pioneer: {
    heading: "Pioneering Work:",
    tips: [
      {
        heading: "Technology awareness training",
        text: "Provide training sessions or seminars to keep group members informed about emerging technologies and trends relevant to their work, inspiring them to embrace innovation in their approach."
      },
      {
        heading: "Innovation competitions",
        text: "Organise internal competitions for the most innovative project ideas, encouraging unconventional thinking and creativity."
      },
      {
        heading: "Idea incubator programs",
        text: "Create an idea incubator program within the group to nurture and develop innovative projects, providing resources and support for experimental ideas."
      },
      {
        heading: "Creative brainstorming spaces",
        text: "Designate physical or virtual spaces specifically for creative brainstorming, encouraging group members to think outside the box and challenge the status quo."
      }
    ]
  }
};
var groupPreferences = {
  equalCoverage,
  almostEqualCoverage,
  unequalCoverage
};

// src/utils/cultureObservations.ts
var observations = [
  {
    pk: "STD$1",
    sk: "OBS$accepting|questioning",
    messages: {
      left: {
        heading: "Follow without question",
        text: "Employees have no voice to question management directives and must do as they are told at all times. The emphasis is on management always knowing what to do and being 'right'.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly accepting work environment",
        consTitle: "Pitfalls of a highly accepting work environment",
        learnMoreTitle: "Highly accepting work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Efficient decision-making: Minimising employee input allows management to make faster decisions, enhancing efficiency.",
          "Enhanced productivity: With employees following directives without question, there is less time wasted on debates, boosting productivity.",
          "Clear expectations and consistency: Expecting adherence to management directives sets clear expectations and promotes consistent policies, facilitating effective accountability."
        ],
        fullCons: [
          "Decreased morale: Undervalued employee opinions and ideas lead to disengagement and low morale.",
          "Stifled creativity: Restricting questioning and challenging directives hampers unique perspectives and stifles innovation.",
          "Diminished job satisfaction: Limited autonomy and control over work result in dissatisfaction and potential turnover."
        ],
        tips: [
          "Lead by example: Managers should demonstrate a balanced approach, being transparent and open to different perspectives.",
          "Establish clear guidelines: Set guidelines for respectful and constructive questioning of management directives.",
          "Foster open communication: Create a culture that values diverse perspectives, encourages feedback, and provides opportunities for employee engagement."
        ],
        tipsTitle: "Tips for balancing an accepting and questioning work environments"
      },
      slightLeft: {
        heading: "Question with caution",
        text: 'Candour is not typically tolerated and employees rarely question management directives. Management is expected to know what to do most of the time and provide the "right" solutions. Employees are rarely asked for input.',
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly accepting work environment",
        consTitle: "Pitfalls of a mostly accepting work environment",
        learnMoreTitle: "Mostly accepting work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Improved efficiency: In an accepting work environment, decisions are trusted and accepted, leading to enhanced productivity and streamlined processes.",
          "Reduced conflict: Acceptance of management's decisions minimises tensions and conflicts, promoting a harmonious and collaborative workplace.",
          "Streamlined execution: With an accepting work environment, employees can focus on task execution, resulting in swift implementation of initiatives and organisational achievements."
        ],
        fullCons: [
          "Unclear boundaries: Without clear guidelines, employees may struggle to discern when it is appropriate to question or challenge management directives, leading to potential conflicts.",
          "Inconsistent decision-making: A lack of established processes can result in inconsistent management actions, causing inefficiencies.",
          "Misinterpretation and mistrust: Some employees may perceive the ability to question or challenge management directives as a sign of weakness, leading to confusion and mistrust."
        ],
        tips: [
          "Lead by example: Managers should demonstrate a balanced approach, being transparent and open to different perspectives.",
          "Establish clear guidelines: Set guidelines for respectful and constructive questioning of management directives.",
          "Foster open communication: Create a culture that values diverse perspectives, encourages feedback, and provides opportunities for employee engagement."
        ],
        tipsTitle: "Tips for balancing an accepting and questioning work environments"
      },
      middle: {
        heading: "Democracy constrained",
        text: "Employees can challenge management directives to some degree and provide their input. However, there are situations where candour is not appreciated and management directives must be followed without question.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of both an accepting and questioning work environment",
        consTitle: "Pitfalls of both an accepting and questioning work environment",
        learnMoreTitle: "Both accepting and questioning work environments",
        learnMoreLink: "Learn more",
        fullPros: [
          "Clear expectations: Establishing guidelines for questioning management directives sets behaviour and communication expectations.",
          "Enhanced trust: Valuing employee opinions fosters trust and respect between employees and management.",
          "Better decision-making: Employee input enables informed decisions and promotes innovation."
        ],
        fullCons: [
          "Struggle to find balance: Establishing a harmonious balance between candour and following management directives is a challenge that requires time and effort.",
          "Potential confusion and tension: Unclear guidelines and communication channels may cause uncertainty about when it is appropriate to question or challenge management directives, leading to confusion and tension.",
          "Undermining management authority: Excessive or aggressive questioning and challenging of management directives can foster mistrust and undermine management's authority."
        ],
        tips: [
          "Lead by example: Managers should demonstrate a balanced approach, being transparent and open to different perspectives.",
          "Establish clear guidelines: Set guidelines for respectful and constructive questioning of management directives.",
          "Foster open communication: Create a culture that values diverse perspectives, encourages feedback, and provides opportunities for employee engagement."
        ],
        tipsTitle: "Tips for balancing an accepting and questioning work environments"
      },
      slightRight: {
        heading: "Open to questioning",
        text: "Candour is celebrated and employees can challenge most management directives. There is a general sense of shared ownership and responsibility amongst employees. Employee input is regularly required and only on occasion does management provide directives without consultation.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly questioning work environment",
        consTitle: "Pitfalls of a mostly questioning work environment",
        learnMoreTitle: "Mostly questioning work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Learning culture and empowerment: Encouraging questions and involvement fosters a culture of continuous learning and empowers employees.",
          "Trust and collaboration: Valuing employee opinions builds trust and fosters collaboration between employees and management.",
          "Enhanced innovation: Open communication and freedom to challenge directives promote innovation and better decision-making."
        ],
        fullCons: [
          "Limited business understanding: Employees may lack the necessary knowledge to ask informed and strategic questions.",
          "Negative culture and division: Excessive questioning can create a divisive 'us vs them' mentality within the organisation.",
          "Decision-making based on popularity: When questions dominate, decisions may be driven by popular opinion rather than strategic considerations."
        ],
        tips: [
          "Lead by example: Managers should demonstrate a balanced approach, being transparent and open to different perspectives.",
          "Establish clear guidelines: Set guidelines for respectful and constructive questioning of management directives.",
          "Foster open communication: Create a culture that values diverse perspectives, encourages feedback, and provides opportunities for employee engagement."
        ],
        tipsTitle: "Tips for balancing an accepting and questioning work environments"
      },
      right: {
        heading: "Speak up freely",
        text: "Candour is celebrated at all times and employees can challenge any management directive. Employees are always consulted and there is a true sense of shared ownership and responsibility throughout the business.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly questioning work environment",
        consTitle: "Pitfalls of a highly questioning work environment",
        learnMoreTitle: "Highly questioning work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Informed decision-making: Allowing employees to question and challenge management decisions leads to more well-rounded and informed choices.",
          "Fostering innovation: Empowering employees to challenge directives fosters a culture of creativity and generates fresh ideas.",
          "Enhanced employee engagement: Valuing employee input and involving them in decision-making processes increases their engagement and commitment to the organisation's success."
        ],
        fullCons: [
          "Decision-making delays: Frequent questioning and debate can slow down the decision-making process, potentially causing inefficiencies.",
          "Erosion of management authority: Excessive or aggressive questioning of all management decisions can undermine trust and authority, leading to a breakdown in effective leadership.",
          "Negative culture and misinterpretation: Unconstructive or excessive questioning may create a negative culture, fostering confusion, mistrust, and a perception of weakness or lack of direction."
        ],
        tips: [
          "Lead by example: Managers should demonstrate a balanced approach, being transparent and open to different perspectives.",
          "Establish clear guidelines: Set guidelines for respectful and constructive questioning of management directives.",
          "Foster open communication: Create a culture that values diverse perspectives, encourages feedback, and provides opportunities for employee engagement."
        ],
        tipsTitle: "Tips for balancing an accepting and questioning work environments"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$ad-hoc|planned",
    messages: {
      left: {
        heading: "Daily objectives",
        text: "Only day-to-day issues are a priority. The focus is on making sure that current issues are responded to as quickly as possible. Longer-term strategic goals are either not defined or are not considered a priority.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of daily objectives",
        consTitle: "Pitfalls of daily objectives",
        learnMoreTitle: "Daily objectives",
        learnMoreLink: "Learn more",
        fullPros: [
          "Quick problem-solving: Daily objectives enable the organisation to swiftly identify and address issues, ensuring efficient problem-solving and minimising disruptions.",
          "Adaptability to market changes: Focusing on current issues allows the organisation to respond quickly to market or industry changes, maintaining competitiveness and customer satisfaction.",
          "Enhanced productivity: By promptly addressing daily issues, employees can concentrate on their work, leading to increased productivity and overall efficiency."
        ],
        fullCons: [
          "Lack of long-term direction: Without emphasis on long-term goals, the organisation may lack direction and miss growth opportunities.",
          "Limited planning ability: Daily objectives may hinder long-term planning and informed decision-making.",
          "Reduced focus on innovation: Daily objectives may prioritise short-term tasks over long-term innovation and competitiveness."
        ],
        tips: [
          "Prioritise and align: Clearly prioritise and align daily goals with long-term objectives, ensuring immediate actions contribute to overarching goals.",
          "Regular review and adjustment: Continuously review progress towards goals and make adjustments as needed to maintain alignment and responsiveness.",
          "Effective communication: Clearly communicate objectives and goals, fostering understanding and engagement throughout the organisation."
        ],
        tipsTitle: "Tips for balancing responsiveness and planning"
      },
      slightLeft: {
        heading: "Weekly to monthly objectives",
        text: "Strategic plans, targets, and budgets are set weekly to monthly. Issues that impact these timeframes are considered important to manage.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of weekly to monthly objectives",
        consTitle: "Pitfalls of weekly to monthly objectives",
        learnMoreTitle: "Weekly to monthly objectives",
        learnMoreLink: "Learn more",
        fullPros: [
          "Short-term focus: Setting objectives on a weekly to monthly basis allows the organisation to concentrate on short-term goals and adapt quickly to market changes.",
          "Flexibility and alignment: Shorter timeframes for objectives provide greater flexibility and enable better alignment with current market conditions, ensuring competitiveness and a positive customer experience.",
          "Progress tracking and resource allocation: Weekly to monthly objectives facilitate progress tracking, performance evaluation, and effective resource allocation, leading to improved efficiency and productivity."
        ],
        fullCons: [
          "Limited long-term planning: Overemphasising short-term objectives limits long-term planning and hampers the organisation's ability to anticipate future challenges.",
          "Missed growth opportunities: Focusing on short-term objectives may cause the organisation to overlook long-term goals and growth opportunities.",
          "Reduced innovation focus: Excessive emphasis on short-term objectives may limit innovation and hinder the organisation's ability to explore new avenues for growth."
        ],
        tips: [
          "Prioritise and align: Clearly prioritise and align daily goals with long-term objectives, ensuring immediate actions contribute to overarching goals.",
          "Regular review and adjustment: Continuously review progress towards goals and make adjustments as needed to maintain alignment and responsiveness.",
          "Effective communication: Clearly communicate objectives and goals, fostering understanding and engagement throughout the organisation."
        ],
        tipsTitle: "Tips for balancing responsiveness and planning"
      },
      middle: {
        heading: "Monthly to quarterly objectives",
        text: "Strategic plans, targets, and budgets are set monthly to quarterly. Issues that impact these timeframes are considered important to manage.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of monthly to quarterly objectives",
        consTitle: "Pitfalls of monthly to quarterly objectives",
        learnMoreTitle: "Monthly to quarterly objectives",
        learnMoreLink: "Learn more",
        fullPros: [
          "Market-aligned strategic plans: Setting monthly to quarterly objectives ensures alignment with market conditions, supporting competitiveness and customer satisfaction.",
          "Agility for innovation: Regular plan reviews enable a dedicated focus on innovation, fostering growth and seizing opportunities.",
          "Timely feedback and agile decision-making: Shorter timeframes promote prompt feedback, accountability, and agile decision-making for effective responses to change."
        ],
        fullCons: [
          "Short-term focus: Excessive emphasis on short-term goals may hinder long-term strategic planning and growth.",
          "Limited adaptability: Monthly to quarterly objectives may lack the flexibility to quickly respond to market changes or seize emerging opportunities.",
          "Potential oversight of long-term priorities: The focus on shorter timeframes may result in a lack of attention to important long-term objectives and initiatives."
        ],
        tips: [
          "Prioritise and align: Clearly prioritise and align daily goals with long-term objectives, ensuring immediate actions contribute to overarching goals.",
          "Regular review and adjustment: Continuously review progress towards goals and make adjustments as needed to maintain alignment and responsiveness.",
          "Effective communication: Clearly communicate objectives and goals, fostering understanding and engagement throughout the organisation."
        ],
        tipsTitle: "Tips for balancing responsiveness and planning"
      },
      slightRight: {
        heading: "One to three year objectives",
        text: "Strategic plans, targets, and budgets are set 1 to 3 years out. The focus is on achieving these longer-term strategic goals as opposed to reacting to day-to-day issues.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of one to three year objectives",
        consTitle: "Pitfalls of one to three year objectives",
        learnMoreTitle: "One to three year objectives",
        learnMoreLink: "Learn more",
        fullPros: [
          "Clear direction and focus: Long-term objectives establish the organisation's mission, vision, and roadmap.",
          "Anticipation of market dynamics: Setting strategic goals 1 to 3 years in advance enables proactive responses to opportunities and threats.",
          "Effective resource allocation and adaptability: Long-term objectives support optimal resource allocation, budgeting, and adaptability to the changing external environment."
        ],
        fullCons: [
          "Uncertain forecasts: Long-term objectives rely on uncertain forecasts, which can lead to resource misallocation and misalignment.",
          "Limited adaptability: Long-term objectives may hinder the organisation's ability to respond swiftly to unforeseen events or emerging opportunities.",
          "Complex progress measurement: Measuring progress towards long-term objectives can be challenging and resource-intensive."
        ],
        tips: [
          "Prioritise and align: Clearly prioritise and align daily goals with long-term objectives, ensuring immediate actions contribute to overarching goals.",
          "Regular review and adjustment: Continuously review progress towards goals and make adjustments as needed to maintain alignment and responsiveness.",
          "Effective communication: Clearly communicate objectives and goals, fostering understanding and engagement throughout the organisation."
        ],
        tipsTitle: "Tips for balancing responsiveness and planning"
      },
      right: {
        heading: "Three to five year objectives",
        text: "Strategic plans, targets, and budgets are set 3 - 5 years out. The focus is on achieving these longer-term strategic goals as opposed to reacting to day-to-day issues.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of three to five year objectives",
        consTitle: "Pitfalls of three to five year objectives",
        learnMoreTitle: "Three to five year objectives",
        learnMoreLink: "Learn more",
        fullPros: [
          "Strategic planning and vision alignment: Setting 3-5 year objectives facilitates strategic planning, ensuring alignment with the organisations vision and long-term goals.",
          "Clear targets for progress measurement: Specific and measurable objectives provide clear targets for tracking progress and evaluating success.",
          "Effective resource allocation and budgeting: Objectives guide resource allocation and budget planning, optimising the use of resources to achieve long-term goals."
        ],
        fullCons: [
          "Limited adaptability: Long-term plans may lack the flexibility to respond effectively to unforeseen changes or seize new opportunities.",
          "Difficulty in measuring progress: Tracking progress towards long-term objectives can be challenging, particularly within a 3-5 year timeframe.",
          "Risk of neglecting short-term priorities: Excessive focus on long-term objectives may divert attention and resources from pressing short-term issues and emerging opportunities."
        ],
        tips: [
          "Prioritise and align: Clearly prioritise and align daily goals with long-term objectives, ensuring immediate actions contribute to overarching goals.",
          "Regular review and adjustment: Continuously review progress towards goals and make adjustments as needed to maintain alignment and responsiveness.",
          "Effective communication: Clearly communicate objectives and goals, fostering understanding and engagement throughout the organisation."
        ],
        tipsTitle: "Tips for balancing responsiveness and planning"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$centralised control|delegated control",
    messages: {
      left: {
        heading: "Centralised decision-making above all",
        text: "Decision-making is restricted to management only. Employees are not delegated to and not given authority.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly centralised work environment",
        consTitle: "Pitfalls of highly centralised work environment",
        learnMoreTitle: "Highly Centralised work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Strong control and direction: Clear chain of command and centralised vision ensure effective management and alignment.",
          "Consistency and uniformity: Decisions and policies are consistently implemented across the organisation, promoting stability and coherence.",
          "Efficient decision making: Streamlined decision-making process enables quick responses to challenges and opportunities."
        ],
        fullCons: [
          "Dictatorial leadership: A highly centralised work environment can lead to dictatorial leadership, limiting autonomy and creativity.",
          "Implementation delays: Centralised decision-making can cause delays in implementation, slowing down progress.",
          "Decreased employee engagement: Lack of empowerment and limited opportunities for contribution can result in decreased employee engagement and productivity."
        ],
        tips: [
          "Assess control needs: Evaluate tasks to determine appropriate control levels. Strategic decisions may require centralised control, while routine tasks can be delegated.",
          "Foster clear communication: Communicate roles, responsibilities, and decision-making processes to ensure understanding and contribution.",
          "Cultivate trust and accountability: Build trust and hold individuals accountable, fostering ownership and responsibility."
        ],
        tipsTitle: "Tips for balancing centralised control and delegated control"
      },
      slightLeft: {
        heading: "Centralised decisions over delegation",
        text: "Decision-making is mainly reserved for management. Employees are rarely given authority and management approval is generally needed before enacting change.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly centralised work environment",
        consTitle: "Pitfalls of mostly centralised work environment",
        learnMoreTitle: "Mostly centralised work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Improve efficiency and engagement: Delegating at the job level and centralising certain functions at the organisational level can help improve efficiency, communication, decision-making and engagement.",
          "Specialisation and quality: Allowing employees to specialise in specific areas leads to higher-quality work and improved outcomes.",
          "Strong control and consistency: Transparent chain of command, centralised vision, and strong control ensure consistent decision making and policies throughout the organisation."
        ],
        fullCons: [
          "Communication breakdowns: Lack of effective communication between employees and management, or among different teams, can lead to errors and misunderstandings.",
          "Dependence on management: Employees relying heavily on management for decision-making can result in delays and hinder organisational agility.",
          "Limited creativity and innovation: Without empowerment to make decisions, employees may feel constrained in contributing unique perspectives and ideas, stifling creativity and innovation."
        ],
        tips: [
          "Assess control needs: Evaluate tasks to determine appropriate control levels. Strategic decisions may require centralised control, while routine tasks can be delegated.",
          "Foster clear communication: Communicate roles, responsibilities, and decision-making processes to ensure understanding and contribution.",
          "Cultivate trust and accountability: Build trust and hold individuals accountable, fostering ownership and responsibility."
        ],
        tipsTitle: "Tips for balancing centralised control and delegated control"
      },
      middle: {
        heading: "Layered authority and delegation",
        text: "Levels of decision-making authority are defined and separated at the job level. Employees are delegated to within the boundaries of their formal role definitions.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of both a centralised and delegated work environment",
        consTitle: "Pitfalls of both a centralised and delegated work environment",
        learnMoreTitle: "Centralised and delegated work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Consistency and coherence: Centralised decision-making ensures consistency and coherence in decision making and policies.",
          "Local knowledge and adaptability: Delegating decision-making authority incorporates local knowledge and enhances adaptability.",
          "Motivation, innovation, and ownership: Allowing employee input in decision making promotes motivation, encourages innovation, and fosters ownership."
        ],
        fullCons: [
          "Complexity: Balancing centralisation and delegation requires coordination and communication across different levels, adding complexity.",
          "Slower decision making: A hybrid approach can be slower as decisions need coordination across levels.",
          "Role clarity and accountability: Defining clear roles and accountability becomes challenging in a hybrid approach with mixed decision-making methods."
        ],
        tips: [
          "Assess control needs: Evaluate tasks to determine appropriate control levels. Strategic decisions may require centralised control, while routine tasks can be delegated.",
          "Foster clear communication: Communicate roles, responsibilities, and decision-making processes to ensure understanding and contribution.",
          "Cultivate trust and accountability: Build trust and hold individuals accountable, fostering ownership and responsibility."
        ],
        tipsTitle: "Tips for balancing centralised control and delegated control"
      },
      slightRight: {
        heading: "Delegation over centralisation",
        text: "Employees are empowered to make most types of business decisions. Relatively few decisions are restricted to management.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly delegated work environment",
        consTitle: "Pitfalls of a mostly delegated work environment",
        learnMoreTitle: "Mostly delegated work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Expertise utilisation: Delegating decisions to employees with relevant expertise leads to better outcomes and leverages their knowledge and experience.",
          "Greater ownership and accountability: When employees are able to make decisions, they may feel a greater sense of ownership and accountability for their work.",
          "Enhanced engagement: Granting employees decision-making authority and new responsibilities fosters higher levels of engagement and investment in their work."
        ],
        fullCons: [
          "Risk of boundary overstepping: Employees may exceed their authority and make decisions beyond their expertise, leading to potential negative outcomes.",
          "Poor decision-making: Without proper oversight, guidance, and checks, employees may make suboptimal decisions that can impact the company negatively.",
          "Coordination challenges: Lack of clear communication and decision-making authority can hinder effective coordination among different teams or departments."
        ],
        tips: [
          "Assess control needs: Evaluate tasks to determine appropriate control levels. Strategic decisions may require centralised control, while routine tasks can be delegated.",
          "Foster clear communication: Communicate roles, responsibilities, and decision-making processes to ensure understanding and contribution.",
          "Cultivate trust and accountability: Build trust and hold individuals accountable, fostering ownership and responsibility."
        ],
        tipsTitle: "Tips for balancing centralised control and delegated control"
      },
      right: {
        heading: "Delegation above all",
        text: "Decision-making is decentralised throughout the organisation and delegation is widespread. Decision making authority is not restricted to management.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly delegated work environment",
        consTitle: "Pitfalls of a highly delegated work environment",
        learnMoreTitle: "Highly delegated work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Local knowledge integration: Delegated decision-making incorporates expertise and firsthand knowledge of individuals familiar with local needs.",
          "Motivation and innovation boost: Involving employees in decision-making enhances motivation and encourages innovative ideas.",
          "Increased flexibility: A highly delegated structure enables quick adaptation to changing circumstances and new opportunities."
        ],
        fullCons: [
          "Lack of consistency: Delegated decision-making can result in inconsistency and variation in decision-making and policies across the organisation.",
          "Slower coordination: Coordinating decisions across multiple levels and teams may lead to delays in the decision-making process.",
          "Decreased control and alignment: Delegating decision-making authority may result in reduced control and alignment with organisational goals and objectives."
        ],
        tips: [
          "Assess control needs: Evaluate tasks to determine appropriate control levels. Strategic decisions may require centralised control, while routine tasks can be delegated.",
          "Foster clear communication: Communicate roles, responsibilities, and decision-making processes to ensure understanding and contribution.",
          "Cultivate trust and accountability: Build trust and hold individuals accountable, fostering ownership and responsibility."
        ],
        tipsTitle: "Tips for balancing centralised control and delegated control"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$collective|individual",
    messages: {
      left: {
        heading: "Team recognition above all",
        text: "Recognition and rewards (or reprimand) only focus on team performance. Individual contributions are never singled out.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly collectivist work environment",
        consTitle: "Pitfalls of a highly collectivist work environment",
        learnMoreTitle: "Highly collectivist work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Enhanced team camaraderie: Recognising team performance fosters a stronger bond among members, promoting collaboration and support.",
          "Motivated teamwork: Individuals are motivated to work harder for the collective benefit, valuing the success of the team over individual recognition.",
          "Synergy and cooperation: Collaboration and mutual assistance break down silos, allowing for greater synergy and the shared accomplishment of goals."
        ],
        fullCons: [
          "Social Loafing and unequal contributions: Some team members rely on others, leading to uneven effort.",
          "Challenging performance management: Identifying poor performers is difficult within the team's collective achievements.",
          "Limited recognition for exceptional individuals: Individual talents may be overlooked, demotivating high performers."
        ],
        tips: [
          "Recognise both individual and team achievements: Ensure that team members feel acknowledged for their contributions while motivating the team as a whole to work effectively together.",
          "Establish clear goals and expectations: Set transparent goals and expectations for both individual and team performance, enabling team members to understand their role in contributing to the team's success.",
          "Evaluate and improve your recognition program: Monitor the effectiveness of your recognition program and gather feedback from employees to make necessary improvements and ensure it aligns with their needs and preferences."
        ],
        tipsTitle: "Tips on balancing team and individual recognition and rewards"
      },
      slightLeft: {
        heading: "Team over individual recognition",
        text: "Recognition and rewards (or reprimand) mainly focus on team performance. Individuals are rarely singled.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly collectivist work environment",
        consTitle: "Pitfalls of a mostly collectivist work environment",
        learnMoreTitle: "Mostly collectivist work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Greater camaraderie and motivation: Recognising team performance fosters strong bonds and motivates members to work harder for the collective good.",
          "Balanced focus on team and individuals: While team performance is prioritised, individual contributions are occasionally acknowledged, ensuring a fair balance between collective goals and individual achievements.",
          "Synergy and collaboration: Cooperation between individuals builds synergy, breaks down silos, and encourages mutual support and collaboration."
        ],
        fullCons: [
          "Social loafing risk: Rewarding unmotivated individuals who rely on others can undermine individual accountability and overall performance.",
          "Challenges with poor performers: Addressing performance issues and providing feedback becomes difficult as poor performers can hide within the team.",
          "Pressure on lower-performing members: Those who struggle to keep up with high performers face increased stress, impacting their well-being and ability to contribute effectively."
        ],
        tips: [
          "Recognise both individual and team achievements: Ensure that team members feel acknowledged for their contributions while motivating the team as a whole to work effectively together.",
          "Establish clear goals and expectations: Set transparent goals and expectations for both individual and team performance, enabling team members to understand their role in contributing to the team's success.",
          "Evaluate and improve your recognition program: Monitor the effectiveness of your recognition program and gather feedback from employees to make necessary improvements and ensure it aligns with their needs and preferences."
        ],
        tipsTitle: "Tips on balancing team and individual recognition and rewards"
      },
      middle: {
        heading: "Team and individual recognition",
        text: "Recognition and rewards (or reprimand) focus on both team and individual performance. Teams are rewarded to motivate people to collectively achieve objectives. Individuals are singled-out who go the extra mile in achieving objectives.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of team and individualist recognition and rewards work environment",
        consTitle: "Pitfalls of team and individualist recognition and rewards work environment",
        learnMoreTitle: "Team and individualist work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Addressing freeloaders and motivating lesser contributors: Balancing recognition and rewards helps tackle the issue of freeloaders and motivates underperforming individuals.",
          "Boosting motivation and engagement: Recognising both individual and team contributions enhances motivation and engagement, conveying the value of their efforts and their significance within the team.",
          "Enhanced retention: Recognising and rewarding contributions fosters a sense of value and support, leading to improved retention rates."
        ],
        fullCons: [
          "Increased complexity: Balancing individual and team recognition adds complexity, requiring careful consideration of contributions. This can require extra time and effort for effective implementation.",
          "Risk of resentment: Inadequate recognition can lead to resentment and demotivation among team members. Fair and appropriate recognition is important to maintain team morale.",
          "Potential unintended consequences: Balancing rewards may foster competition, undermining teamwork and impacting overall team performance."
        ],
        tips: [
          "Recognise both individual and team achievements: Ensure that team members feel acknowledged for their contributions while motivating the team as a whole to work effectively together.",
          "Establish clear goals and expectations: Set transparent goals and expectations for both individual and team performance, enabling team members to understand their role in contributing to the team's success.",
          "Evaluate and improve your recognition program: Monitor the effectiveness of your recognition program and gather feedback from employees to make necessary improvements and ensure it aligns with their needs and preferences."
        ],
        tipsTitle: "Tips on balancing team and individual recognition and rewards"
      },
      slightRight: {
        heading: "Individual over team recognition",
        text: "Recognition and reward (or reprimand) mainly focus on individual contributions and not the collective performance of the team. Teams and the work they do are rarely singled out.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly individualist work environment",
        consTitle: "Pitfalls of a mostly individualist work environment",
        learnMoreTitle: "Mostly individualist work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Motivation and incentives: Recognising and rewarding individual contributions motivates employees to improve their performance.",
          "Acknowledging exceptional teamwork: Team achievements are occasionally recognised, reinforcing the value of collaboration.",
          "Clarity and accountability: Clear expectations for behaviours and outcomes promote accountability in individual work."
        ],
        fullCons: [
          "Unhealthy competition and limited collaboration: Overemphasis on individual recognition undermines collaboration and fosters unhealthy competition.",
          "Acceptance of toxic behaviour: High-performing individuals may engage in toxic behaviour without repercussions, creating a negative work environment and disregarding company values.",
          "Lack of social support and camaraderie: The absence of a strong support system and camaraderie diminishes employee well-being and team morale."
        ],
        tips: [
          "Recognise both individual and team achievements: Ensure that team members feel acknowledged for their contributions while motivating the team as a whole to work effectively together.",
          "Establish clear goals and expectations: Set transparent goals and expectations for both individual and team performance, enabling team members to understand their role in contributing to the team's success.",
          "Evaluate and improve your recognition program: Monitor the effectiveness of your recognition program and gather feedback from employees to make necessary improvements and ensure it aligns with their needs and preferences."
        ],
        tipsTitle: "Tips on balancing team and individual recognition and rewards"
      },
      right: {
        heading: "Individual recognition above all",
        text: "Recognition and reward (reprimand) focus only on individual performance. Teams and the work they do are never singled out.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly individualist work environment",
        consTitle: "Pitfalls of a highly individualist work environment:",
        learnMoreTitle: "Highly individualist work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Motivation and incentives: Recognising and rewarding individual contributions fosters motivation and drives individuals to excel in their performance.",
          "Role modelling and inspiration: High-performing individuals serve as role models, inspiring others to improve their own individual performance.",
          "Accountability and performance management: No social loafing enables better performance management and accountability."
        ],
        fullCons: [
          "Unhealthy competition and lack of collaboration: Recognising and rewarding individuals may create a competitive environment, hindering collaboration and fostering secrecy, distrust, and Machiavellian behaviour.",
          "Misalignment with company values: Individual goals may overshadow team and company goals, causing a misalignment with organisational values and purpose.",
          "Lack of teamwork and camaraderie: Silo working and a focus on individual success result in a workplace lacking social support and camaraderie."
        ],
        tips: [
          "Recognise both individual and team achievements: Ensure that team members feel acknowledged for their contributions while motivating the team as a whole to work effectively together.",
          "Establish clear goals and expectations: Set transparent goals and expectations for both individual and team performance, enabling team members to understand their role in contributing to the team's success.",
          "Evaluate and improve your recognition program: Monitor the effectiveness of your recognition program and gather feedback from employees to make necessary improvements and ensure it aligns with their needs and preferences."
        ],
        tipsTitle: "Tips on balancing team and individual recognition and rewards"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$conformity|individuality",
    messages: {
      left: {
        heading: "Group conformity",
        text: "The group identity is strong and clearly defined. In order to fit in, employees must conform to group norms, values, rules, and ways-of-work. Group pressure is very high.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of complete group conformity",
        consTitle: "Pitfalls of complete group conformity",
        learnMoreTitle: "Complete group conformity",
        learnMoreLink: "Learn more",
        fullPros: [
          "Increased efficiency: Adhering to established group norms and ways of work enhances collaboration, streamlines processes, and boosts efficiency in achieving shared goals.",
          "Consistency and quality: Group compliance promotes uniformity, ensuring consistent output and maintaining a high level of quality in the group's work.",
          "Cohesion and accountability: Compliance with group guidelines strengthens the sense of belonging, fosters camaraderie, and promotes mutual support and accountability among members."
        ],
        fullCons: [
          "Limited creativity and innovation: Group compliance can stifle individual creativity and hinder the generation of unique ideas (lead to group think).",
          "Diminished individuality: Conforming to group norms can result in the suppression of individual perspectives and ideas, leading to a loss of individuality.",
          "Reduced autonomy and decision-making: Group compliance may limit individual autonomy and decision-making, as individuals are expected to conform to the group's decisions and actions."
        ],
        tips: [
          "Foster open communication: Encourage honest and open communication between employees and management, fostering trust, satisfaction, and engagement.",
          "Embrace diversity: Recognise and respect the diversity of your workforce, creating an inclusive environment where employees feel valued and empowered to be themselves.",
          "Establish clear processes: Define a decision-making process and establish deadlines to ensure efficient evaluation and selection of the best course of action."
        ],
        tipsTitle: "Tips for balancing group conformity and individuality"
      },
      slightLeft: {
        heading: "Group conformity over individuality",
        text: "The group identity is mostly strong and clearly defined. In order to fit in, employees must conform to most group norms, values, rules, and ways-of-work at all times. Group pressure is typically high.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of group conformity over individuality",
        consTitle: "Pitfalls of group conformity over individuality",
        learnMoreTitle: "Group conformity over individuality",
        learnMoreLink: "Learn more",
        fullPros: [
          "Enhanced teamwork: Group compliance promotes teamwork and collaboration, leading to improved overall performance.",
          "Increased productivity: By following the same guidelines, tasks are completed more efficiently, resulting in higher productivity.",
          "Balance between conformity and innovation: Group compliance allows for individual expression within the group, fostering creativity and innovation."
        ],
        fullCons: [
          "Limited creativity and diversity of thought: Emphasising group compliance can stifle individual creativity and limit the range of perspectives and ideas within the group.",
          "Suppressed dissent and independent thinking: Group compliance can discourage individuals from expressing differing opinions and engaging in critical thinking, hindering constructive debate and problem-solving.",
          "Reduced individual accountability: When the focus is on group compliance, individuals may feel less personally responsible for their actions, potentially leading to a diffusion of responsibility and a lack of ownership."
        ],
        tips: [
          "Foster open communication: Encourage honest and open communication between employees and management, fostering trust, satisfaction, and engagement.",
          "Embrace diversity: Recognise and respect the diversity of your workforce, creating an inclusive environment where employees feel valued and empowered to be themselves.",
          "Establish clear processes: Define a decision-making process and establish deadlines to ensure efficient evaluation and selection of the best course of action."
        ],
        tipsTitle: "Tips for balancing group conformity and individuality"
      },
      middle: {
        heading: "Conformity meets individuality",
        text: "The group identity is not clearly defined but some group norms, values, rules, and ways-of-work exist that employees must follow in order to fit in. Some group pressure exists.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of both group conformity and individuality",
        consTitle: "Pitfalls of both group conformity and individuality",
        learnMoreTitle: "Both group conformity and individuality",
        learnMoreLink: "Learn more",
        fullPros: [
          "Greater acceptance of diversity: When individuality is encouraged within group compliance, individuals may be more accepting of diversity and inclusivity in the workplace.",
          "Increased employee satisfaction: Valuing individual ideas within group compliance fosters higher employee satisfaction.",
          "Improved accountability: Allowing individuals autonomy promotes greater accountability and ownership of actions."
        ],
        fullCons: [
          "Risk of compromising group values or goals: Allowing personal freedom may jeopardise group values/goals if individuals prioritise personal agenda over the group's.",
          "Increased conflict and decision-making complexity: Encouraging individuality may lead to more conflicts and longer decision-making processes due to diverse perspectives and opinions.",
          "Challenges in ensuring compliance and maintaining cohesion: Managing adherence to rules and values becomes more challenging when individuality is emphasised, potentially impacting group cohesion."
        ],
        tips: [
          "Foster open communication: Encourage honest and open communication between employees and management, fostering trust, satisfaction, and engagement.",
          "Embrace diversity: Recognise and respect the diversity of your workforce, creating an inclusive environment where employees feel valued and empowered to be themselves.",
          "Establish clear processes: Define a decision-making process and establish deadlines to ensure efficient evaluation and selection of the best course of action."
        ],
        tipsTitle: "Tips for balancing group conformity and individuality"
      },
      slightRight: {
        heading: "Individuality over conformity",
        text: "The group identify is mostly weak and undefined. There are relatively few group norms, values, rules, and ways-of-work that employees must follow in order to fit in. Little group pressure exists.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of individuality over group conformity",
        consTitle: "Pitfalls of individuality over group conformity",
        learnMoreTitle: "Individuality over group conformity",
        learnMoreLink: "Learn more",
        fullPros: [
          "Enhanced critical thinking: Encouraging individuality reduces groupthink, promoting independent and critical analysis of decisions.",
          "Increased openness to diverse perspectives: Embracing individuality fosters inclusivity, reducing bias and enabling a wider range of perspectives.",
          "Greater adaptability and innovation: Emphasising individuality allows for flexibility and unique ideas, fostering adaptability and innovation."
        ],
        fullCons: [
          "Lack of direction and alignment: Without clear group identity and shared goals, employees may struggle to understand the overall direction and purpose of the group.",
          "Increased conflict and inefficiency: Differing individual perspectives can lead to conflicts and delays in decision-making, reducing overall efficiency.",
          "Lack of accountability and ownership: Without clear expectations and rules, it can be challenging to hold individuals accountable for their actions and ensure collective responsibility for group goals."
        ],
        tips: [
          "Foster open communication: Encourage honest and open communication between employees and management, fostering trust, satisfaction, and engagement.",
          "Embrace diversity: Recognise and respect the diversity of your workforce, creating an inclusive environment where employees feel valued and empowered to be themselves.",
          "Establish clear processes: Define a decision-making process and establish deadlines to ensure efficient evaluation and selection of the best course of action."
        ],
        tipsTitle: "Tips for balancing group conformity and individuality"
      },
      right: {
        heading: "Complete individuality",
        text: "The group identify is weak or non-existent. There are few or no group norms, values, rules, and ways-of-work that employees must follow in order to fit in. Group pressure is not tolerated.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of complete individuality",
        consTitle: "Pitfalls of complete individuality",
        learnMoreTitle: "Complete individuality",
        learnMoreLink: "Learn more",
        fullPros: [
          "Greater diversity and inclusion: Total individuality promotes diverse perspectives, reduces bias and discrimination, and creates a more inclusive work environment.",
          "Enhanced critical thinking: Encouraging personal freedom reduces groupthink, fostering independent thinking and critical analysis of decisions.",
          "Increased creativity and innovation: Embracing individuality allows for unrestricted thinking, leading to unique and innovative ideas."
        ],
        fullCons: [
          "Lack of structure and clarity: Without clear rules and norms, employees may struggle to understand their roles, leading to confusion and inefficiency.",
          "Limited suitability for all organisations and employees: Total individuality may not be suitable for all organisations or employees, as some require more structure and guidance.",
          "Challenges in achieving shared goals: Without shared purpose, goals, and guidelines, collaboration and alignment can be difficult, hindering organisational success."
        ],
        tips: [
          "Foster open communication: Encourage honest and open communication between employees and management, fostering trust, satisfaction, and engagement.",
          "Embrace diversity: Recognise and respect the diversity of your workforce, creating an inclusive environment where employees feel valued and empowered to be themselves.",
          "Establish clear processes: Define a decision-making process and establish deadlines to ensure efficient evaluation and selection of the best course of action."
        ],
        tipsTitle: "Tips for balancing group conformity and individuality"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$cooperation|competition",
    messages: {
      left: {
        heading: "Cooperation above all",
        text: "Team members are at all times united in a common cause. The focus is on building trust, cooperation and sharing goals between members. Team members never consider each other competitors for scarce resources or customers.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly cooperative work environment",
        consTitle: "Pitfalls of a highly cooperative work environment",
        learnMoreTitle: "Highly cooperative work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Increased motivation and productivity: Cooperative work environments foster a positive culture, unity, and shared goals, boosting motivation and productivity.",
          "Synergy and innovation: Collaboration enables resource pooling, sparking creativity and driving innovation within the team.",
          "Efficient resource utilisation and goal achievement: Cooperation optimises resource use, leading to cost savings and efficient achievement of shared goals."
        ],
        fullCons: [
          "Reduced innovation and creativity: Overemphasis on cooperation can stifle individual creativity and limit the generation of new and unique ideas.",
          "Dependence and lack of initiative: Excessive focus on cooperation may lead to team members relying too heavily on others, resulting in a lack of individual initiative and ownership.",
          "Potential for decreased performance: Lack of competition among team members can lead to complacency and reduced motivation to improve, potentially resulting in lower individual and team performance."
        ],
        tips: [
          "Clearly define goals and objectives to focus the team on a common cause and minimise unnecessary competition.",
          "Encourage open communication, teamwork, and collaboration to foster a cooperative work environment and build trust among team members.",
          "Use competition strategically, aligning it with organisational goals, to motivate and inspire excellence while maintaining a supportive and cohesive team dynamic."
        ],
        tipsTitle: "Tips for balancing cooperation and competition"
      },
      slightLeft: {
        heading: "Cooperation over competition",
        text: "Team members are mostly united in a common cause. The main focus is on building trust, cooperation and sharing goals between members. Rarely do team members consider each other competitors for scarce resources or customers.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly cooperative work environment",
        consTitle: "Pitfalls of a mostly cooperative work environment",
        learnMoreTitle: "Mostly cooperative work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Increased motivation and productivity: Limited competition drives team members to improve performance, increasing motivation and productivity.",
          "Improved performance and growth: Controlled competition identifies leaders and promotes advancement, enhancing performance and growth opportunities.",
          "Encourages creativity and adaptability: Limited competition fosters creativity, learning, and adaptability, promoting innovation and agility."
        ],
        fullCons: [
          "Difficulty in managing competition: Striking the right balance of competition can be challenging, potentially leading to negative effects on team dynamics, motivation, and collaboration.",
          "Risk of unhealthy competition: Poorly managed competition may create an uneven playing field, unhealthy rivalries, and a focus on winning at all costs, rather than fostering fairness and teamwork.",
          "Negative impact on team dynamics and atmosphere: Mismanaged competition can result in demotivation of under-performers, a negative work environment, decreased collaboration and trust."
        ],
        tips: [
          "Clearly define goals and objectives to focus the team on a common cause and minimise unnecessary competition.",
          "Encourage open communication, teamwork, and collaboration to foster a cooperative work environment and build trust among team members.",
          "Use competition strategically, aligning it with organisational goals, to motivate and inspire excellence while maintaining a supportive and cohesive team dynamic."
        ],
        tipsTitle: "Tips for balancing cooperation and competition"
      },
      middle: {
        heading: "Team and self interests",
        text: "At times team members are considered trusted colleagues in a common cause and at other times competitors for scarce resources or customers. Depending on what\u2019s at stake, team members will oscillate between a 'win-lose' and a 'serve' mentality.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a both cooperative and competitive work environment",
        consTitle: "Pitfalls of a both cooperative and competitive work environment",
        learnMoreTitle: "Both cooperative and competitive work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Increased motivation and productivity: Balancing competition and cooperation drives team members to work harder and improve performance, resulting in increased motivation and productivity.",
          "Enhanced performance and growth: The combination of balanced competition and cooperation identifies leaders, fosters achievement, and provides growth opportunities for team members.",
          "The balanced blend of competition and cooperation encourages creativity, innovation, adaptability, and efficient resource utilisation."
        ],
        fullCons: [
          "Difficulty in maintaining balance: Striking the right balance between competition and cooperation can be challenging, leading to confusion, lack of direction, and decreased engagement.",
          "Risk of resentment and mistrust: Balancing competition and cooperation may lead to resentment and decreased trust among team members.",
          "Decreased collaboration and communication: Emphasising both competition and cooperation can hinder effective collaboration and communication within the team."
        ],
        tips: [
          "Clearly define goals and objectives to focus the team on a common cause and minimise unnecessary competition.",
          "Encourage open communication, teamwork, and collaboration to foster a cooperative work environment and build trust among team members.",
          "Use competition strategically, aligning it with organisational goals, to motivate and inspire excellence while maintaining a supportive and cohesive team dynamic."
        ],
        tipsTitle: "Tips for balancing cooperation and competition"
      },
      slightRight: {
        heading: "Competition over cooperation",
        text: "Most of the time team members see each other as competitors for scare resources or customers. The main focus is on self-interests and self-oriented behaviours between members. Rarely do team members cooperate or adopt a 'serve\u2019 mentality.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly competitive work environment",
        consTitle: "Pitfalls of a mostly competitive work environment",
        learnMoreTitle: "Mostly competitive work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Increased urgency and performance: High competition fosters a sense of urgency, risk-taking, and personal accountability, leading to heightened performance levels.",
          "Personal accomplishment and satisfaction: Competing against others generates a greater sense of personal achievement and satisfaction when individuals succeed or outperform their peers.",
          "Drive for personal growth and innovation: Intense competition encourages personal motivation, fosters innovation, and provides opportunities for growth and development."
        ],
        fullCons: [
          "Increased stress and well-being impact: High competition leads to stress, burnout, and reduced job satisfaction, negatively affecting mental and physical health.",
          "Decreased collaboration and teamwork: Emphasis on individual success hinders teamwork, collaboration, and problem-solving capabilities.",
          "Risk of toxic environment and disengagement: Excessive competition creates a toxic work culture, eroding trust, communication, and employee engagement."
        ],
        tips: [
          "Clearly define goals and objectives to focus the team on a common cause and minimise unnecessary competition.",
          "Encourage open communication, teamwork, and collaboration to foster a cooperative work environment and build trust among team members.",
          "Use competition strategically, aligning it with organisational goals, to motivate and inspire excellence while maintaining a supportive and cohesive team dynamic."
        ],
        tipsTitle: "Tips for balancing cooperation and competition"
      },
      right: {
        heading: "Competition above all",
        text: "Team members consider each other as competitors for scarce resources or customers at all times. The focus is on competition, self-interests, and self-oriented behaviours between members. Team members do not cooperate or adopt a 'serve\u2019 mentality.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly competitive work environment",
        consTitle: "Pitfalls of a highly competitive work environment",
        learnMoreTitle: "Highly competitive work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Enhanced purpose, achievement, and satisfaction: Winning competitions fosters a sense of accomplishment, job satisfaction, and personal fulfilment.",
          "Improved performance and self-improvement: High-level competition pushes individuals to reach their full potential and strive for better results.",
          "Identification of leaders and growth opportunities: Intense competition identifies top performers and provides growth and advancement opportunities."
        ],
        fullCons: [
          "Increased stress and burnout: Excessive competition leads to elevated stress levels and burnout, impacting individuals' well-being.",
          "Decreased teamwork and collaboration: Intense focus on individual competition hinders trust, cooperation, and effective communication among team members.",
          "Limited creativity and innovation: Excessive competition discourages idea-sharing, collaboration, and risk-taking, stifling creativity and hindering innovation."
        ],
        tips: [
          "Clearly define goals and objectives to focus the team on a common cause and minimise unnecessary competition.",
          "Encourage open communication, teamwork, and collaboration to foster a cooperative work environment and build trust among team members.",
          "Use competition strategically, aligning it with organisational goals, to motivate and inspire excellence while maintaining a supportive and cohesive team dynamic."
        ],
        tipsTitle: "Tips for balancing cooperation and competition"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$external|internal",
    messages: {
      left: {
        heading: "Customers above all",
        text: "Customers are at the centre of everything the business does. Customer satisfaction and service quality are always prioritised over operational improvement and cost reduction initiatives.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly customer-centric work environment",
        consTitle: "Pitfalls of a highly customer-centric work environment",
        learnMoreTitle: "Highly customer-centric work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Increased customer loyalty: Prioritising customer satisfaction fosters loyalty, leading to repeat business and positive recommendations.",
          "Enhanced brand reputation: Excellent customer service improves the overall brand image.",
          "Improved employee morale: A customer-centric environment motivates and engages employees, boosting their morale."
        ],
        fullCons: [
          "Higher costs: Prioritising customer satisfaction requires additional investments in resources and training, increasing expenses.",
          "Reduced operational efficiency: Emphasising customer satisfaction can hinder operational efficiency.",
          "Limited decision-making flexibility: A customer-centric approach restricts the company's ability to make changes that might affect the customer experience."
        ],
        tips: [
          "Foster continuous improvement: Encourage team members to contribute ideas for improving internal processes and customer service. Recognise and reward successful changes to foster innovation.",
          "Promote cross-functional collaboration: Optimise internal processes and enhance customer service by breaking down silos and fostering collaboration between teams.",
          "Prioritise customer-centricity: Clearly define your target customer, actively seek and act upon customer feedback, and equip employees with the tools to provide exceptional service."
        ],
        tipsTitle: "Tips on balancing customer needs with internal effectiveness needs"
      },
      slightLeft: {
        heading: "Customers over internal effectiveness",
        text: "Customer satisfaction and service quality are generally prioritised over operational improvement and cost reduction initiatives.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly customer-centric work environment",
        consTitle: "Pitfalls of a mostly customer-centric work environment",
        learnMoreTitle: "Mostly customer-centric work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Improved customer experience: Prioritising customer satisfaction creates a positive experience, fostering customer loyalty and repeat business.",
          "Enhanced employee morale: Delivering high-quality service and witnessing its impact on customers boosts employee motivation and engagement.",
          "Effective problem resolution: Prioritising customer satisfaction leads to quick and efficient resolution of customer issues, resulting in happier customers and reduced complaints."
        ],
        fullCons: [
          "Higher costs: Prioritising customer satisfaction requires significant investments in resources, training, and technology, increasing expenses.",
          "Balancing priorities: Finding the right balance between customer satisfaction and operational efficiency can be challenging, as companies must navigate competing priorities.",
          "Measurement challenges: Quantifying the success of a customer-centric culture can be difficult due to subjective customer satisfaction metrics and the complexity of measuring its impact on the business."
        ],
        tips: [
          "Foster continuous improvement: Encourage team members to contribute ideas for improving internal processes and customer service. Recognise and reward successful changes to foster innovation.",
          "Promote cross-functional collaboration: Optimise internal processes and enhance customer service by breaking down silos and fostering collaboration between teams.",
          "Prioritise customer-centricity: Clearly define your target customer, actively seek and act upon customer feedback, and equip employees with the tools to provide exceptional service."
        ],
        tipsTitle: "Tips on balancing customer needs with internal effectiveness needs"
      },
      middle: {
        heading: "Balancing customers with internal effectiveness",
        text: "Improved operational effectiveness and efficiency and increased customer satisfaction and service quality are important to the business.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of both a customer focused and internally effective work environment",
        consTitle: "Pitfalls of both a customer focused and internally effective work environment",
        learnMoreTitle: "Customer focused and internally effective work environments",
        learnMoreLink: "Learn more",
        fullPros: [
          "Enhanced customer satisfaction: Prioritising both customer satisfaction and operational efficiency ensures superior service, fostering loyalty and positive word-of-mouth.",
          "Improved efficiency: Optimising processes reduces costs and enhances productivity for better financial outcomes.",
          "Boosted employee engagement: Valuing customer satisfaction and operational effectiveness inspires higher morale and commitment to exceptional service."
        ],
        fullCons: [
          "Balancing priorities: Balancing customer satisfaction and operational efficiency is challenging, requiring careful consideration to meet both customer and business needs.",
          "Increased pressure on employees: Prioritising customer satisfaction and operational efficiency can stress employees, leading to burnout and turnover.",
          "Measurement challenges: Measuring success in a customer-centric culture is complex, with subjective customer satisfaction metrics and interpreting operational efficiency metrics."
        ],
        tips: [
          "Foster continuous improvement: Encourage team members to contribute ideas for improving internal processes and customer service. Recognise and reward successful changes to foster innovation.",
          "Promote cross-functional collaboration: Optimise internal processes and enhance customer service by breaking down silos and fostering collaboration between teams.",
          "Prioritise customer-centricity: Clearly define your target customer, actively seek and act upon customer feedback, and equip employees with the tools to provide exceptional service."
        ],
        tipsTitle: "Tips on balancing customer needs with internal effectiveness needs"
      },
      slightRight: {
        heading: "Internal effectiveness over customers",
        text: "Operational improvement and cost reduction initiatives are generally prioritised over customer satisfaction and service quality.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly internal effectiveness focused work environments",
        consTitle: "Pitfalls of a mostly internal effectiveness focused work environments",
        learnMoreTitle: "Mostly internal effectiveness focused work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Increased operational efficiency: Prioritising improvement and cost reduction streamlines processes, reduces waste, and controls costs, improving efficiency.",
          "Improved financial performance: Focusing on internal effectiveness and cost control increases profitability, enabling resource allocation for growth and innovation.",
          "Clarity of goals and focus: Emphasising internal effectiveness defines clear objectives, facilitating cohesive teamwork and priority alignment."
        ],
        fullCons: [
          "Decreased customer satisfaction: Neglecting customer needs leads to lower satisfaction, loyalty, and negative word-of-mouth.",
          "Diminished employee morale: Disconnect from customer service lowers engagement, productivity, and job satisfaction.",
          "Poor customer service reputation: Prioritising internal efficiency harms customer service image and long-term success."
        ],
        tips: [
          "Foster continuous improvement: Encourage team members to contribute ideas for improving internal processes and customer service. Recognise and reward successful changes to foster innovation.",
          "Promote cross-functional collaboration: Optimise internal processes and enhance customer service by breaking down silos and fostering collaboration between teams.",
          "Prioritise customer-centricity: Clearly define your target customer, actively seek and act upon customer feedback, and equip employees with the tools to provide exceptional service."
        ],
        tipsTitle: "Tips on balancing customer needs with internal effectiveness needs"
      },
      right: {
        heading: "Internal-effectiveness above all",
        text: "Operational improvement and cost reduction initiatives are at the centre of everything the business does. Internal effectiveness and efficiency are always prioritised over customer satisfaction and service quality.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly internal effectiveness focused work environments",
        consTitle: "Pitfalls of a highly internal effectiveness focused work environments",
        learnMoreTitle: "Highly internal effectiveness focused work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Improved operational efficiency: Prioritising efficiency reduces waste and costs, improving financial performance and sustainability.",
          "Enhanced financial performance: Emphasising effectiveness and cost control increases profitability, enabling growth and innovation.",
          "Clear goals and focus: Prioritising internal effectiveness defines objectives, aiding employee focus and effective teamwork."
        ],
        fullCons: [
          "Resistance to change and limited innovation: Prioritising internal efficiency can lead to resistance to change, limiting growth and competitiveness.",
          "Decreased customer satisfaction and reputation: Neglecting customer needs results in lower satisfaction, loyalty, and negative brand reputation.",
          "Diminished employee morale and missed opportunities: Employees disengage when customer needs are not prioritised, leading to reduced productivity and missed growth opportunities."
        ],
        tips: [
          "Foster continuous improvement: Encourage team members to contribute ideas for improving internal processes and customer service. Recognise and reward successful changes to foster innovation.",
          "Promote cross-functional collaboration: Optimise internal processes and enhance customer service by breaking down silos and fostering collaboration between teams.",
          "Prioritise customer-centricity: Clearly define your target customer, actively seek and act upon customer feedback, and equip employees with the tools to provide exceptional service."
        ],
        tipsTitle: "Tips on balancing customer needs with internal effectiveness needs"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$formalised|informal",
    messages: {
      left: {
        heading: "Formal rules drive all decision-making",
        text: "For every decision and action there is a formal rule or process that employees have to follow.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a very formal policy and procedure driven work environment",
        consTitle: "Pitfalls of a very formal policy and procedure driven work environment",
        learnMoreTitle: "Very formal policy and procedure driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Consistency and trust: Formal rules and processes provide a consistent framework for decision-making, fostering trust and confidence among employees.",
          "Efficiency and streamlined processes: Formal rules help streamline workflows, saving time and effort in decision-making and task execution.",
          "Accountability and clarity: Formality clarifies responsibilities and promotes accountability by clearly expectations, reducing errors and misunderstandings."
        ],
        fullCons: [
          "Inflexibility: Rigid adherence to formal rules and procedures limits adaptability and responsiveness to unforeseen circumstances or opportunities.",
          "Bureaucracy: Excessive rules impede decision-making, stifle innovation, and create bureaucratic bottlenecks.",
          "Lack of autonomy and resistance to change: A culture driven by formal rules restricts employee autonomy, hinders problem-solving, and fosters resistance to change."
        ],
        tips: [
          "Identify key areas and prioritise: Determine which areas of your organisation require formal policies and procedures, focusing on critical functions like finance, HR, customer service, and safety.",
          "Develop clear guidelines: Create well-defined and supportive guidelines for these key areas, providing employees with clear direction and expectations for decision-making and actions.",
          "Regularly review and update: Continuously assess the effectiveness of your policies and procedures, updating them to remain relevant and aligned with organisational needs."
        ],
        tipsTitle: "Tips on balancing formal and informal policies and procedures"
      },
      slightLeft: {
        heading: "Formal rules drive most decision-making",
        text: "For most decisions and actions there is a formal rule or process that employees have to follow.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly formal policy and procedure driven work environment",
        consTitle: "Pitfalls of a mostly formal policy and procedure driven work environment",
        learnMoreTitle: "Mostly formal policy and procedure driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Consistency and trust: Having formal rules and processes in place ensures consistent decision-making and fosters trust among employees.",
          "Efficiency and effectiveness: Established rules and procedures streamline decision-making, leading to increased efficiency and effectiveness in work processes.",
          "Accountability and compliance: Formality promotes clear responsibilities, accountability, and compliance with legal and regulatory requirements, reducing the risk of penalties and legal consequences."
        ],
        fullCons: [
          "Reduced flexibility and inefficiency: A reliance on formal rules and processes can hinder adaptability and lead to delays or confusion when faced with unique situations.",
          "Limited innovation and creativity: Rigid adherence to formal processes can stifle innovation and limit employees' ability to think outside the box.",
          "Lack of ownership and bureaucracy: Excessive rules and procedures can create a bureaucratic environment, reducing employee engagement and hindering decision-making."
        ],
        tips: [
          "Identify key areas and prioritise: Determine which areas of your organisation require formal policies and procedures, focusing on critical functions like finance, HR, customer service, and safety.",
          "Develop clear guidelines: Create well-defined and supportive guidelines for these key areas, providing employees with clear direction and expectations for decision-making and actions.",
          "Regularly review and update: Continuously assess the effectiveness of your policies and procedures, updating them to remain relevant and aligned with organisational needs."
        ],
        tipsTitle: "Tips on balancing formal and informal policies and procedures"
      },
      middle: {
        heading: "Formal and informal decision-making",
        text: "There are some formal rules and processes that employees have to follow to make decisions or take action.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of formal and informal policies and procedures in the workplace",
        consTitle: "Pitfalls of formal and informal policies and procedures in the workplace",
        learnMoreTitle: "Formal and informal policies and procedures in the workplace",
        learnMoreLink: "Learn more",
        fullPros: [
          "Consistency and clarity: Core rules provide clear guidelines for important decisions, ensuring consistent and standardised approaches.",
          "Effective risk management: Formal policies and actions mitigate risks, ensuring compliance and avoiding negative consequences.",
          "Encouragement of innovation and ownership: Employee autonomy fosters innovation, empowerment, and personal responsibility."
        ],
        fullCons: [
          "Inconsistency and bias: The combination of formal and informal decision-making can lead to inconsistent outcomes and the potential for bias in decision-making processes.",
          "Lack of clarity and limited structure: Employees may struggle to navigate the balance between following formal rules and making informal decisions, leading to confusion and a lack of clear guidance.",
          "Increased risk and potential for unethical decisions: Allowing for informal decision-making can introduce a higher risk of inappropriate decisions and unethical behaviour, which can have negative consequences for the organisation."
        ],
        tips: [
          "Identify key areas and prioritise: Determine which areas of your organisation require formal policies and procedures, focusing on critical functions like finance, HR, customer service, and safety.",
          "Develop clear guidelines: Create well-defined and supportive guidelines for these key areas, providing employees with clear direction and expectations for decision-making and actions.",
          "Regularly review and update: Continuously assess the effectiveness of your policies and procedures, updating them to remain relevant and aligned with organisational needs."
        ],
        tipsTitle: "Tips on balancing formal and informal policies and procedures"
      },
      slightRight: {
        heading: "Informality drives most decision-making",
        text: "There are few formal rules and processes that employees have to follow to make decisions or take action.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly informal policy and procedure driven work environment",
        consTitle: "Pitfalls of a mostly informal policy and procedure driven work environment",
        learnMoreTitle: "Mostly informal policy and procedure driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Creativity: Employees have the freedom to explore new ideas and solutions, fostering creativity and innovation.",
          "Ownership: Employees develop a sense of ownership over their work, leading to higher commitment and quality.",
          "Responsiveness: Organisations can quickly adapt to change as employees make decisions tailored to the situation."
        ],
        fullCons: [
          "Compliance risks: Without formal rules and processes, there is a higher chance of non-compliance with laws and regulations, exposing the organisation to legal and regulatory risks.",
          "Inconsistency: Employee autonomy in decision-making can lead to inconsistent approaches and conflicting outcomes, causing confusion and conflicts within the organisation.",
          "Accountability gaps: In an informal environment, establishing clear lines of responsibility and holding individuals accountable becomes challenging, resulting in a lack of accountability and difficulty addressing performance issues."
        ],
        tips: [
          "Identify key areas and prioritise: Determine which areas of your organisation require formal policies and procedures, focusing on critical functions like finance, HR, customer service, and safety.",
          "Develop clear guidelines: Create well-defined and supportive guidelines for these key areas, providing employees with clear direction and expectations for decision-making and actions.",
          "Regularly review and update: Continuously assess the effectiveness of your policies and procedures, updating them to remain relevant and aligned with organisational needs."
        ],
        tipsTitle: "Tips on balancing formal and informal policies and procedures"
      },
      right: {
        heading: "Informality drives all decision-making",
        text: "There are no formal rules and processes that employees have to follow to make decisions or take action.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a very informal policy and procedure driven work environment",
        consTitle: "Pitfalls of a very informal policy and procedure driven work environment",
        learnMoreTitle: "Very informal policy and procedure driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Flexibility: Employees have the freedom to make decisions based on their judgment, allowing for greater flexibility in adapting to different situations.",
          "Innovation: The absence of formal rules encourages employees to take risks and explore new ideas, fostering a culture of innovation and creativity.",
          "Agility: Without rigid processes, the organisation can respond quickly to changing circumstances, making it more agile and adaptable."
        ],
        fullCons: [
          "Lack of clarity and efficiency: Without formal rules and processes, employees may struggle with understanding expectations, leading to confusion and inefficiency.",
          "Inconsistency and limited accountability: In a completely informal culture, inconsistent decision-making and a lack of formal processes can make it challenging to hold employees accountable for their actions.",
          "Compliance and legal risks: A lack of formal guidelines may make it difficult to comply with legal and regulatory requirements, exposing the organisation to potential risks and consequences."
        ],
        tips: [
          "Identify key areas and prioritise: Determine which areas of your organisation require formal policies and procedures, focusing on critical functions like finance, HR, customer service, and safety.",
          "Develop clear guidelines: Create well-defined and supportive guidelines for these key areas, providing employees with clear direction and expectations for decision-making and actions.",
          "Regularly review and update: Continuously assess the effectiveness of your policies and procedures, updating them to remain relevant and aligned with organisational needs."
        ],
        tipsTitle: "Tips on balancing formal and informal policies and procedures"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$hierarchical structure|horizontal structure",
    messages: {
      left: {
        heading: "Vertical organisation structure",
        text: "The workplace has a long 'chain of command' from top to bottom and has multiple layers of management with a narrow 'span of control'. There is a clear division of labour at all times and employees have specialised roles to get work done.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly hierarchical work environment",
        consTitle: "Pitfalls of a highly hierarchical work environment",
        learnMoreTitle: "Highly hierarchical work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Strong management oversight and clear reporting lines.",
          "Clear roles and responsibilities.",
          "Career advancement: Hierarchical structures provide employees with opportunities for growth and progression within the organisation, motivating them to perform well.",
          "Specialisation and expertise: Hierarchical organisations allow employees to develop specialised skills and knowledge in their respective roles, becoming experts in their field."
        ],
        fullCons: [
          "Bureaucracy and communication barriers: Multiple management layers can create bureaucratic processes and impede decision-making and communication.",
          "Limited collaboration and innovation: Siloed departments hinder cross-functional collaboration and innovation.",
          "Reduced agility: Rigid lines of authority and specialised workforce make it challenging to adapt and implement new ideas."
        ],
        tips: [
          "Assess organisation size: Consider the size of the organisation to determine the suitable structure. Larger organisations may benefit from a hierarchical approach, while smaller organisations may thrive with a flatter structure.",
          "Evaluate task complexity: Analyse the complexity of tasks and decisions. More complex organisations may require a hierarchical structure, while simpler organisations may function well with a flatter structure.",
          "Consider collaboration needs and employee preferences: Determine the level of collaboration needed and consider employee preferences. Organisations valuing collaboration may benefit from a flatter structure, while others may prefer a more hierarchical approach."
        ],
        tipsTitle: "Tips for designing organisational structures"
      },
      slightLeft: {
        heading: "Vertical over horizontal organisation structure",
        text: "The workplace is mostly hierarchical in structure with many layers of management and a narrow \u2018span of control\u2019. Employees typically have specialised roles with a clear division of labour to get work done. Middle management layers typically exist.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly hierarchical work environment",
        consTitle: "Pitfalls of a mostly hierarchical work environment",
        learnMoreTitle: "Mostly hierarchical work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Clear chain of command and management levels: Maintains a clear reporting structure with management levels for effective communication and accountability.",
          "Balanced oversight and employee autonomy: Provides management oversight while empowering employees with autonomy for initiative and decision-making.",
          "Centralised and decentralised decision-making: Combines centralised decision-making for strategic matters and decentralised decision-making for local and job-level decisions."
        ],
        fullCons: [
          "Communication barriers: With multiple layers of management, communication becomes siloed and hampers collaboration and information sharing.",
          "Slow decision-making: Bureaucracy and rigid authority lines in a hierarchical structure lead to slower decision-making processes, hindering innovation and adaptability.",
          "Lack of agility: The rigid nature of a hierarchical structure makes it difficult to quickly adapt to market changes and implement new ideas or strategies, resulting in missed opportunities and reduced responsiveness."
        ],
        tips: [
          "Assess organisation size: Consider the size of the organisation to determine the suitable structure. Larger organisations may benefit from a hierarchical approach, while smaller organisations may thrive with a flatter structure.",
          "Evaluate task complexity: Analyse the complexity of tasks and decisions. More complex organisations may require a hierarchical structure, while simpler organisations may function well with a flatter structure.",
          "Consider collaboration needs and employee preferences: Determine the level of collaboration needed and consider employee preferences. Organisations valuing collaboration may benefit from a flatter structure, while others may prefer a more hierarchical approach."
        ],
        tipsTitle: "Tips for designing organisational structures"
      },
      middle: {
        heading: "Mixed organisation structure",
        text: "Some parts of the business is hierarchical in structure with many layers of management, a narrow \u2018span of control\u2019 and a clear division of labour with specialised roles. Whilst other parts of the business is flat, with middle management removed and a 'broad span of control with unspecialised roles that require employees to wear multiple hats to get work done.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a matrix structure work environment",
        consTitle: "Pitfalls of a matrix structure work environment",
        learnMoreTitle: "Matrix structure work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Flexibility: A matrix structure enables quick adaptation to market changes and diverse circumstances, ensuring organisational agility.",
          "Improved decision-making: Decentralisation empowers employees to make informed decisions based on local expertise, enhancing decision-making effectiveness.",
          "Cross-functional collaboration: Matrix structure encourages effective collaboration across departments, enabling efficient communication, cooperation, and productivity."
        ],
        fullCons: [
          "Lack of consistency: Varied approaches and decision-making methods across teams and departments hinder organisational consistency.",
          "Power struggles and conflicting priorities: Multiple reporting lines can lead to power struggles and conflicting priorities among managers and teams.",
          "Coordination and communication costs: The matrix structure requires extensive coordination and communication, resulting in increased time and expenses."
        ],
        tips: [
          "Assess organisation size: Consider the size of the organisation to determine the suitable structure. Larger organisations may benefit from a hierarchical approach, while smaller organisations may thrive with a flatter structure.",
          "Evaluate task complexity: Analyse the complexity of tasks and decisions. More complex organisations may require a hierarchical structure, while simpler organisations may function well with a flatter structure.",
          "Consider collaboration needs and employee preferences: Determine the level of collaboration needed and consider employee preferences. Organisations valuing collaboration may benefit from a flatter structure, while others may prefer a more hierarchical approach."
        ],
        tipsTitle: "Tips for designing organisational structures"
      },
      slightRight: {
        heading: "Horizontal over vertical organisation structure",
        text: "The workplace is mostly flat in structure with few layers of management and a wide \u2018span of control\u2019. Rarely do middle management layers exist and employees are mostly generalists that have to \u2018wear multiple hats\u2019 to get work done.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly flat structure work environment",
        consTitle: "Pitfalls of a mostly flat structure work environment",
        learnMoreTitle: "Mostly flat structure work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Agility and adaptability: A flat structure enables quick decision-making and rapid response to market changes, maintaining accountability and structure.",
          "Transparency and line of sight: Limited bureaucracy and fewer management layers promote transparency, streamlined communication, and clear alignment between employees and organisational goals.",
          "Cost savings: Eliminating middle management positions reduces budget costs, making a flat structure cost-effective."
        ],
        fullCons: [
          "Lack of oversight and clear chain of command: With fewer managers, there may be less oversight and a lack of clear reporting lines, leading to potential issues with quality control and conflict resolution.",
          "Lack of structure and direction: The flat structure may result in a lack of clear structure and direction, leading to confusion and inefficiency in decision-making and work processes.",
          "Limited career advancement and specialisation: With fewer levels of management, there may be limited opportunities for career growth and specialisation, potentially impacting employee development and satisfaction."
        ],
        tips: [
          "Assess organisation size: Consider the size of the organisation to determine the suitable structure. Larger organisations may benefit from a hierarchical approach, while smaller organisations may thrive with a flatter structure.",
          "Evaluate task complexity: Analyse the complexity of tasks and decisions. More complex organisations may require a hierarchical structure, while simpler organisations may function well with a flatter structure.",
          "Consider collaboration needs and employee preferences: Determine the level of collaboration needed and consider employee preferences. Organisations valuing collaboration may benefit from a flatter structure, while others may prefer a more hierarchical approach."
        ],
        tipsTitle: "Tips for designing organisational structures"
      },
      right: {
        heading: "Horizontal organisation structure",
        text: "The workplace has a short 'chain of command' from top to bottom and has few or no layers of management and a wide 'span of control'. Middle management layers do not exist and employees are all generalists that have to \u2018wear multiple hats\u2019 to get work done.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a very flat structure work environment",
        consTitle: "Pitfalls of a very flat structure work environment",
        learnMoreTitle: "Very flat structure work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Speed and adaptability: Minimal layers of management allow for quick decision-making and rapid response to market changes and customer needs.",
          "Increased employee engagement: Giving employees autonomy and decision-making power fosters higher levels of engagement and motivation.",
          "Streamlined communication and reduced bureaucracy: With minimal management, communication channels are more direct and there is less bureaucracy and red tape, leading to more efficient operations."
        ],
        fullCons: [
          "Lack of direction and accountability: Without clear management and hierarchy, employees may lack guidance and struggle to understand their roles and responsibilities.",
          "Inconsistent decision-making: With decentralised decision-making, there may be variations in approaches and lack of alignment across teams and departments.",
          "Limited career growth and oversight: Minimal management can result in limited opportunities for career advancement and potential gaps in oversight and quality control."
        ],
        tips: [
          "Assess organisation size: Consider the size of the organisation to determine the suitable structure. Larger organisations may benefit from a hierarchical approach, while smaller organisations may thrive with a flatter structure.",
          "Evaluate task complexity: Analyse the complexity of tasks and decisions. More complex organisations may require a hierarchical structure, while simpler organisations may function well with a flatter structure.",
          "Consider collaboration needs and employee preferences: Determine the level of collaboration needed and consider employee preferences. Organisations valuing collaboration may benefit from a flatter structure, while others may prefer a more hierarchical approach."
        ],
        tipsTitle: "Tips for designing organisational structures"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$innovative|cautious",
    messages: {
      left: {
        heading: "Innovation above all",
        text: "Employees take risks, innovate, and challenge the status quo at all times. No topic is off limits when it comes to business transformation and thinking outside-the-box.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly innovative work environment",
        consTitle: "Pitfalls of a highly innovative work environment",
        learnMoreTitle: "Highly innovative cultures",
        learnMoreLink: "Learn more",
        fullPros: [
          "Rapid transformation of work processes and the business.",
          "Enhanced adaptability, agility, and exploration of new markets and opportunities.",
          "Empowered employees, inclusive environment, and increased competitive advantage."
        ],
        fullCons: [
          "Change fatigue and disruption: Continuous innovation can lead to change fatigue among employees and disrupt normal operations, causing a lack of operational continuity.",
          "Risk of wasting resources: The pursuit of doing things differently without proper evaluation can result in wasting resources on unproductive endeavours.",
          "Potential risks and non-compliance: Engaging in new, untested, or unproven approaches without a risk-based approach can lead to risks and potential violations of regulatory requirements."
        ],
        tips: [
          "Disciplined approach to innovation: Evaluate your business, identify inefficiencies, and focus on the 4 Ps of Profit models, Processes, Products, and Policies. Prioritise and tackle each area individually for faster and more agile progress.",
          "Strategic risk assessment: Identify critical elements requiring tried and tested approaches, comply with regulations, and consider incremental improvements where possible.",
          "Prioritisation and resource allocation: Avoid overwhelming changes by selecting initiatives wisely and dedicating adequate resources, skills, time, and space to support innovation."
        ],
        tipsTitle: "Tips for balancing risk taking and risk avoiding"
      },
      slightLeft: {
        heading: "Innovation with elements of risk avoidance",
        text: "Employees generally challenge the status quo, innovate, and think outside-the-box. Few work situations exist where they are required to use tried-and-tested ways of work.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of an incrementally innovative work environment",
        consTitle: "Pitfalls of an incrementally innovative work environment",
        learnMoreTitle: "Incrementally innovative cultures",
        learnMoreLink: "Learn more",
        fullPros: [
          "Sustained business positioning through ongoing improvement efforts.",
          "Enhanced organisational effectiveness through the identification of new work methods and opportunities.",
          "Fostered inclusivity by welcoming diverse ideas."
        ],
        fullCons: [
          "Insufficient adaptation to environmental factors and missed opportunities due to a slow pace of change.",
          "Risk aversion hindering the balance between innovation and risk-taking, limiting the exploration of new ideas and potential breakthroughs.",
          "Change fatigue and resistance among employees due to frequent incremental changes, leading to decreased motivation and productivity."
        ],
        tips: [
          "Disciplined approach to innovation: Evaluate your business, identify inefficiencies, and focus on the 4 Ps of Profit models, Processes, Products, and Policies. Prioritise and tackle each area individually for faster and more agile progress.",
          "Strategic risk assessment: Identify critical elements requiring tried and tested approaches, comply with regulations, and consider incremental improvements where possible.",
          "Prioritisation and resource allocation: Avoid overwhelming changes by selecting initiatives wisely and dedicating adequate resources, skills, time, and space to support innovation."
        ],
        tipsTitle: "Tips for balancing risk taking and risk avoiding"
      },
      middle: {
        heading: "Concern for change, Concern for risk",
        text: "This work environment has elements of both risk-taking and risk-avoidance. In some instances employees must use tried-and-tested ways of work and in other they are empowered to innovate and challenge the status quo.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a balanced risk-taking and risk-avoiding work environment",
        consTitle: "Pitfalls of a balanced risk-taking and risk-avoiding work environment",
        learnMoreTitle: "Risk taking and risk avoiding cultures",
        learnMoreLink: "Learn more",
        fullPros: [
          "Maximises opportunities and strategic focus by combining risk management with innovation.",
          "Stimulates innovation by pinpointing areas for improvement and addressing blind spots.",
          "Ensures effective change management, compliance, and empowers employees within a structured framework."
        ],
        fullCons: [
          "Ineffective innovation and change: Slow adaptation, missed opportunities, and limited employee empowerment for challenging the status quo.",
          "Balancing efficiency and adaptability: Overemphasis on new projects without sufficient evaluation, potentially leading to negative outcomes.",
          "Limited agility and potential for poor decisions: Lack of flexibility, outdated practices, and misguided innovation, risking suboptimal outcomes."
        ],
        tips: [
          "Disciplined approach to innovation: Evaluate your business, identify inefficiencies, and focus on the 4 Ps of Profit models, Processes, Products, and Policies. Prioritise and tackle each area individually for faster and more agile progress.",
          "Strategic risk assessment: Identify critical elements requiring tried and tested approaches, comply with regulations, and consider incremental improvements where possible.",
          "Prioritisation and resource allocation: Avoid overwhelming changes by selecting initiatives wisely and dedicating adequate resources, skills, time, and space to support innovation."
        ],
        tipsTitle: "Tips for balancing risk taking and risk avoiding"
      },
      slightRight: {
        heading: "Risk avoidance with elements of innovation",
        text: "Employees generally use tried-&-tested ways of work. Few work situations exist where they are able to innovate and challenge the status quo.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a predominantly risk-avoiding work environment",
        consTitle: "Pitfalls of a predominantly risk-avoiding work environment",
        learnMoreTitle: "Predominantly risk avoiding cultures",
        learnMoreLink: "Learn more",
        fullPros: [
          "Ensures regulatory compliance and uninterrupted business operations by preventing deviance or non-compliance.",
          "Utilises risk-based approaches and standardised processes to ensure compliance.",
          "Establishes clear rules and consequences for non-compliance, fostering accountability among team members."
        ],
        fullCons: [
          "Limited adaptability and collaboration: Overly bureaucratic environments hinder cross-functional collaboration, stifle improvement, and limit diversity of thought, impeding the company's ability to explore new opportunities.",
          "Employee disengagement and growth limitations: Risk-avoidance leads to unproductive workplaces, resulting in dissatisfaction, limited growth, and reduced competitiveness.",
          "Inhibited innovation and change: Strict rule adherence and fear-based approach hinder market exploration and effective adaptation, hampering workplace dynamics and efficiency."
        ],
        tips: [
          "Disciplined approach to innovation: Evaluate your business, identify inefficiencies, and focus on the 4 Ps of Profit models, Processes, Products, and Policies. Prioritise and tackle each area individually for faster and more agile progress.",
          "Strategic risk assessment: Identify critical elements requiring tried and tested approaches, comply with regulations, and consider incremental improvements where possible.",
          "Prioritisation and resource allocation: Avoid overwhelming changes by selecting initiatives wisely and dedicating adequate resources, skills, time, and space to support innovation."
        ],
        tipsTitle: "Tips for balancing risk taking and risk avoiding"
      },
      right: {
        heading: "Tight control & risk avoidance above all",
        text: "Employees use tried-&-tested ways of work at all times. Employees cannot challenge the status quo, take risks, or innovate.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly risk-avoiding work environment",
        consTitle: "Pitfalls of a highly risk-avoiding work environment",
        learnMoreTitle: "Highly risk avoiding cultures",
        learnMoreLink: "Learn more",
        fullPros: [
          "Ensures ongoing business operations through risk and compliance-focused activities, reducing ambiguity.",
          "Promotes a high level of rule following, conformity, and fosters a timely response to emerging risks.",
          "Risk analyses are embedded into all decision-making processes and risk management into all operations."
        ],
        fullCons: [
          "Limited productivity and destructiveness: Risk-avoidance, without strong compliance needs, can lead to unproductive or destructive workplaces.",
          "Employee disengagement, growth limitations, and reduced collaboration: Highly bureaucratic environments hinder satisfaction, growth, collaboration, and competitive advantage.",
          "Inadequate response to market changes: Slow adaptation to feedback and ideas hampers responsiveness and innovation."
        ],
        tips: [
          "Disciplined approach to innovation: Evaluate your business, identify inefficiencies, and focus on the 4 Ps of Profit models, Processes, Products, and Policies. Prioritise and tackle each area individually for faster and more agile progress.",
          "Strategic risk assessment: Identify critical elements requiring tried and tested approaches, comply with regulations, and consider incremental improvements where possible.",
          "Prioritisation and resource allocation: Avoid overwhelming changes by selecting initiatives wisely and dedicating adequate resources, skills, time, and space to support innovation."
        ],
        tipsTitle: "Tips for balancing risk taking and risk avoiding"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$process|outcome",
    messages: {
      left: {
        heading: "Process above all",
        text: "Employees must follow all company processes and procedures step-by-step, even if deadlines are missed or profits constrained. Taking shortcuts are not tolerated.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly process-driven work environment",
        consTitle: "Pitfalls of a highly process driven work environment",
        learnMoreTitle: "Highly process driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Efficient knowledge management and accessibility: Organisational knowledge is captured, well-documented, and resides within the system, allowing for transparency and easy access to information.",
          "Clarity, efficiency, and waste reduction: Clearly defined roles and responsibilities, along with standardised processes, lead to greater efficiency and the elimination of waste.",
          "Predictability, consistency, and scalability: Results are predictable and consistent as the system operates based on pre-determined rules and policies. Additionally, process-driven organisations can be easily replicated, enabling scalability and expansion."
        ],
        fullCons: [
          "Overemphasis on process: Narrow focus on individual roles, detachment from the bigger picture, and limited achievement orientation.",
          "Lack of alignment and understanding: Employees lack knowledge of organisational goals, hindering their contribution.",
          "Rigidity and limited adaptability: Unable to adapt to change or external factors for goal achievement."
        ],
        tips: [
          "Clear knowledge and strategies: Ensure understanding of goals and environment. Develop clear strategies and tactics to guide behaviour towards outcomes.",
          "Use the OKR methodology: Adopt Objectives and Key Results for actionable strategy. Set and update OKRs for transparency and accountability.",
          "Measurement and course-correction: Maintain a rhythm of measurement and adjustments for targeted outcomes.",
          "Recognise aligned behaviours: Reward employees reflecting company values and objectives.",
          "Embed regulatory compliance: Integrate compliance into ways of work to avoid negative consequences."
        ],
        tipsTitle: "Tips for balancing process and outcome orientation"
      },
      slightLeft: {
        heading: "Process over outcomes",
        text: "Employees must follow most company processes and procedures step-by-step, even if deadlines are missed or profits constrained. Only when given explicit directives can employees alter processes to suit the situation or take shortcuts.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly process-driven work environment",
        consTitle: "Pitfalls of a mostly process driven work environment",
        learnMoreTitle: "Mostly process driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Clarity, precision, and efficiency: Employees understand the importance of following processes, fostering precision and an analytical approach.",
          "Effective knowledge management and reduced risk: Organisational knowledge is captured and documented, minimising reliance on individuals and reducing inconsistency.",
          "Predictability, consistency, and scalability: Results are predictable and consistent with behaviour governed by pre-determined rules. Process-driven organisations are easily replicable for scalability."
        ],
        fullCons: [
          "Limited understanding of goals: Employees lack effective understanding of how to achieve team and organisational goals.",
          "Rigidity and disregard for goals: The work environment is rigid and disregards organisational goals and objectives.",
          "Reactive approach and limited autonomy: Mitigation actions are mostly reactive and employees have limited autonomy."
        ],
        tips: [
          "Clear knowledge and strategies: Ensure understanding of goals and environment. Develop clear strategies and tactics to guide behaviour towards outcomes.",
          "Use the OKR methodology: Adopt Objectives and Key Results for actionable strategy. Set and update OKRs for transparency and accountability.",
          "Measurement and course-correction: Maintain a rhythm of measurement and adjustments for targeted outcomes.",
          "Recognise aligned behaviours: Reward employees reflecting company values and objectives.",
          "Embed regulatory compliance: Integrate compliance into ways of work to avoid negative consequences."
        ],
        tipsTitle: "Tips for balancing process and outcome orientation"
      },
      middle: {
        heading: "Process meets outcomes",
        text: "Employees can use personal discretion to alter some processes or take short-cuts where important deadlines could be missed or profits constrained. ",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a process and outcomes driven work environment",
        consTitle: "Pitfalls of process and outcomes driven work environment",
        learnMoreTitle: "Process and outcomes driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Clarity and alignment: Employees understand high-level goals and procedures, connecting their actions to company success. They have flexibility with structure and compliance.",
          "Analytical approach and adaptability: The environment fosters an analytical approach, allowing employees to proactively adapt to environmental pressures.",
          "Line of sight and management focus: Employees see the connection between their tasks and organisational outcomes. Management systems prioritise delivering defined goals."
        ],
        fullCons: [
          "Cognitive dissonance and role confusion: Employees face uncertainty regarding process versus outcomes and unclear role requirements.",
          "Misalignment and autonomy challenges: Lack of clarity on goals and boundaries leads to misaligned behaviour and accountability issues.",
          "Inconsistent processes and knowledge gaps: Inadequate documentation, waste, and reliance on individual knowledge result in inconsistent approaches."
        ],
        tips: [
          "Clear knowledge and strategies: Ensure understanding of goals and environment. Develop clear strategies and tactics to guide behaviour towards outcomes.",
          "Use the OKR methodology: Adopt Objectives and Key Results for actionable strategy. Set and update OKRs for transparency and accountability.",
          "Measurement and course-correction: Maintain a rhythm of measurement and adjustments for targeted outcomes.",
          "Recognise aligned behaviours: Reward employees reflecting company values and objectives.",
          "Embed regulatory compliance: Integrate compliance into ways of work to avoid negative consequences."
        ],
        tipsTitle: "Tips for balancing process and outcome orientation"
      },
      slightRight: {
        heading: "Outcomes over process",
        text: "It is more important for employees to ensure deadlines are not missed and profits are not constrained than to follow company processes and procedures step-by-step. Employees can use personal discretion to alter processes or take short-cuts to achieve outcomes.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly outcomes driven work environment",
        consTitle: "Pitfalls of a mostly outcomes driven work environment",
        learnMoreTitle: "Mostly outcomes driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Clarity and alignment: Employees prioritise outcomes, understanding organisational, functional, and individual goals. Customer value and on-time delivery are emphasised.",
          "Accountability and empowerment: Employees take ownership of their actions, contributing to goal achievement. Increased personal freedom and responsibility foster forward thinking and growth.",
          "Efficient management and empowerment: Empowering employees to determine delivery methods reduces overhead, allowing more time for feedback, coaching, and strategic thinking about team objectives."
        ],
        fullCons: [
          "Lack of supervision and inconsistency: Limited oversight and inconsistent approaches across individuals and teams.",
          "Clash of priorities and objectives: Conflicting priorities and objectives among individuals, teams, and departments.",
          "Negative impact on operational viability: Increase in incidents, accidents, or errors in regulated or compliance-driven workplaces, jeopardising business operations."
        ],
        tips: [
          "Clear knowledge and strategies: Ensure understanding of goals and environment. Develop clear strategies and tactics to guide behaviour towards outcomes.",
          "Use the OKR methodology: Adopt Objectives and Key Results for actionable strategy. Set and update OKRs for transparency and accountability.",
          "Measurement and course-correction: Maintain a rhythm of measurement and adjustments for targeted outcomes.",
          "Recognise aligned behaviours: Reward employees reflecting company values and objectives.",
          "Embed regulatory compliance: Integrate compliance into ways of work to avoid negative consequences."
        ],
        tipsTitle: "Tips for balancing process and outcome orientation"
      },
      right: {
        heading: "Outcomes above all",
        text: "Employees must focus on achieving deadlines and profits, and not the manner by which they get there in the end. There is no defined standard or correct manner in which work is conducted.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly outcomes driven work environment",
        consTitle: "Pitfalls of a highly outcomes driven work environment",
        learnMoreTitle: "Highly outcomes driven work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Clarity and motivation: Employees prioritise outcomes and understand organisational goals.",
          "Customer value and accountability: Emphasis on on-time delivery and customer value. Employees see the impact of their actions on goal achievement.",
          "Autonomy and future focus: Employees have autonomy and deliver objectives, fostering forward thinking. Empowerment reduces management overhead for feedback and coaching."
        ],
        fullCons: [
          "Destructive competition and self-serving behaviour: 'Win at all costs' mentality fosters destructive cultures, hindering collaboration and adherence to rules.",
          "Inconsistent processes and decision-making: Lack of standardisation and a goal-centric approach lead to poor decisions, delays, and unpredictable outcomes.",
          "Knowledge loss and role ambiguity: Individual knowledge dominates, causing loss of company knowledge, inconsistencies, and unclear responsibilities."
        ],
        tips: [
          "Clear knowledge and strategies: Ensure understanding of goals and environment. Develop clear strategies and tactics to guide behaviour towards outcomes.",
          "Use the OKR methodology: Adopt Objectives and Key Results for actionable strategy. Set and update OKRs for transparency and accountability.",
          "Measurement and course-correction: Maintain a rhythm of measurement and adjustments for targeted outcomes.",
          "Recognise aligned behaviours: Reward employees reflecting company values and objectives.",
          "Embed regulatory compliance: Integrate compliance into ways of work to avoid negative consequences."
        ],
        tipsTitle: "Tips for balancing process and outcome orientation"
      }
    }
  },
  {
    pk: "STD$1",
    sk: "OBS$task centred|employee centred",
    messages: {
      left: {
        heading: "Task accomplishment above all",
        text: "Task accomplishment is prioritised over the social and personal needs of employees at all times. It is believed that sustained competitive advantage is achieved through the products and services the company sells and not the people doing the work.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly task-centred work environment",
        consTitle: "Pitfalls of a highly task-centred work environment",
        learnMoreTitle: "Highly task centred work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Efficient work completion: Clear delivery expectations ensure tasks are accomplished.",
          "Strong management direction: Top-down guidance provides clear structure and role clarity.",
          "Focus on achievement and alignment: Embracing pressure and prioritising Key Result Areas drives business bottom-line, encouraging task-based discussions and search for alignment."
        ],
        fullCons: [
          "At extremes, the workplace can lose sight of the importance of showing consideration for employee needs.",
          "Lack of collaboration.",
          "Low psychological safety and high employee turnover.",
          "Management seen as dictating and authoritarian.",
          "Micromanaging.",
          "Burnout and people feeling undervalued.",
          "Work environment perceived as 'tough'."
        ],
        tips: [
          "Foster collaboration: Prioritise task completion and a collaborative work environment. Involve employees in defining requirements and success metrics, promoting teamwork and trust.",
          "Maintain discipline and accountability: Enforce task completion and deadlines. Hold regular status update meetings to address employee needs and ensure progress.",
          "Support employee development: Emphasise team building. Implement a fair performance management system and align individual growth with business objectives."
        ],
        tipsTitle: "Tips for balancing task and people needs"
      },
      slightLeft: {
        heading: "Task accomplishment over social needs",
        text: "Task accomplishment is generally prioritised over the personal and social needs of employees. It is believed that sustained competitive advantage is predominately achieved through the products and services the company sells and to a lesser extent the people doing the work.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly task-centred work environment",
        consTitle: "Pitfalls of a mostly task-centred work environment",
        learnMoreTitle: "Mostly task centred work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Efficient work completion: Clear delivery expectations drive task accomplishment.",
          "Strong management direction: Top-down guidance establishes clear structure and roles.",
          "Achievement focus and alignment: Embracing pressure and prioritising Key Result Areas fosters an achievement-oriented mindset, facilitating productive task-based discussions and seeking alignment over agreement."
        ],
        fullCons: [
          "The workplace can lose sight of the importance of showing consideration for employee needs.",
          "Lack of collaboration.",
          "Low psychological safety and high employee turnover.",
          "Management seen as dictating and authoritarian.",
          "Micromanaging.",
          "Burnout and people feeling undervalued.",
          "Work environment perceived as 'tough' or 'unfair' or 'unjust'."
        ],
        tips: [
          "Foster collaboration: Prioritise task completion and a collaborative work environment. Involve employees in defining requirements and success metrics, promoting teamwork and trust.",
          "Maintain discipline and accountability: Enforce task completion and deadlines. Hold regular status update meetings to address employee needs and ensure progress.",
          "Support employee development: Emphasise team building. Implement a fair performance management system and align individual growth with business objectives."
        ],
        tipsTitle: "Tips for balancing task and people needs"
      },
      middle: {
        heading: "Concern for task and people",
        text: "The work environment demonstrates concern for both task accomplishment and the personal and social needs of employees. Where possible consideration is given to both.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a task and people centred work environment",
        consTitle: "Pitfalls of a task and people-centred work environment",
        learnMoreTitle: "Task and people centred work environments",
        learnMoreLink: "Learn more",
        fullPros: [
          "Comprehensive management perspective: Management considers tasks, outcomes, relationships, and organisational dynamics.",
          "Integration of mission, goals, and values: The organisation balances its mission, goals, tasks, and values with a focus on both tasks and relationships.",
          "Needs analysis and balanced concern: Management evaluates team and individual needs alongside task requirements, demonstrating equal importance for task completion and showing care for people."
        ],
        fullCons: [
          "Confusion over priorities: Dual concerns result in unclear focus and confusion around business priorities.",
          "Inconsistent objectives and behaviours: Lack of clear delineation leads to inconsistent behaviours and objectives within the organisation.",
          "Uncertainty in company values: Unclear emphasis on either tasks or people creates uncertainty regarding the organisation's values and direction."
        ],
        tips: [
          "Foster collaboration: Prioritise task completion and a collaborative work environment. Involve employees in defining requirements and success metrics, promoting teamwork and trust.",
          "Maintain discipline and accountability: Enforce task completion and deadlines. Hold regular status update meetings to address employee needs and ensure progress.",
          "Support employee development: Emphasise team building. Implement a fair performance management system and align individual growth with business objectives."
        ],
        tipsTitle: "Tips for balancing task and people needs"
      },
      slightRight: {
        heading: "Social needs over task accomplishment",
        text: "Employees' personal and social needs are generally prioritised over task accomplishment. The workplace is mostly relationship focused and it is predominately believed that sustained competitive advantage is achieved by the people doing the work and to a lesser extent the products and services the company sells.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a mostly people-centred work environment",
        consTitle: "Pitfalls of a mostly people-centred work environment",
        learnMoreTitle: "Mostly people centred work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Workplace harmony and well-being: Fostering a democratic and inclusive atmosphere that promotes teamwork, collaboration, and employee well-being.",
          "Supportive and empathetic leadership: Leaders prioritise psychological safety, show genuine care for employees, and encourage pro-social behaviour.",
          "Motivation and human capital focus: Creating an environment that values and supports employee motivation, while recognising the importance of human capital in driving organisational success."
        ],
        fullCons: [
          "Accountability challenges: Difficulty in holding people accountable for tasks and outcomes, leading to missed deadlines and failures.",
          "Emphasis on agreement over alignment: Focus on employee agreement rather than business alignment, hindering decision-making and task effectiveness.",
          "Prioritisation of feelings over tasks: Excessive focus on employee happiness, neglecting task completion and business priorities, impacting results."
        ],
        tips: [
          "Foster collaboration: Prioritise task completion and a collaborative work environment. Involve employees in defining requirements and success metrics, promoting teamwork and trust.",
          "Maintain discipline and accountability: Enforce task completion and deadlines. Hold regular status update meetings to address employee needs and ensure progress.",
          "Support employee development: Emphasise team building. Implement a fair performance management system and align individual growth with business objectives."
        ],
        tipsTitle: "Tips for balancing task and people needs"
      },
      right: {
        heading: "Social needs above all",
        text: "Employees' personal, motivational and social needs are at all times prioritised over task accomplishment. Employees are considered the most important resource for sustained competitive advantage.",
        summaryPros: null,
        summaryCons: null,
        prosTitle: "Benefits of a highly people-centred work environment",
        consTitle: "Pitfalls of a highly people-centred work environment",
        learnMoreTitle: "Highly people centred work environment",
        learnMoreLink: "Learn more",
        fullPros: [
          "Workplace harmony and well-being: Cultivating a democratic and inclusive atmosphere that promotes collaboration, teamwork, and employee well-being.",
          "Psychological safety and empathy: Prioritizing the psychological safety of employees, creating an environment where they feel safe to express themselves, and demonstrating genuine care and empathy.",
          "Human capital focus and motivation: Recognising the value of employees as key assets, fostering their development, and promoting motivation, engagement, and pro-social behaviours."
        ],
        fullCons: [
          "Emphasis on agreement over alignment: Overemphasis on seeking agreement among employees, which can hinder decision-making and alignment with business objectives.",
          "Sensitivity and entitlement: Over-sensitivity to minor disagreements and misalignments, resulting in an entitlement culture and a need to constantly please employees.",
          "Accountability challenges and oversight of task failures: Difficulty holding people accountable for their actions, potentially leading to a lack of urgency, missed deadlines, and overlooked task failures."
        ],
        tips: [
          "Foster collaboration: Prioritise task completion and a collaborative work environment. Involve employees in defining requirements and success metrics, promoting teamwork and trust.",
          "Maintain discipline and accountability: Enforce task completion and deadlines. Hold regular status update meetings to address employee needs and ensure progress.",
          "Support employee development: Emphasise team building. Implement a fair performance management system and align individual growth with business objectives."
        ],
        tipsTitle: "Tips for balancing task and people needs"
      }
    }
  }
];

// src/utils/workPersonalityDistribution.ts
var DISTRIBUTION_PATTERNS = [
  "spreadout",
  "alternating",
  "1 small group",
  "1 big group",
  "opposing",
  "2 groups",
  "3 groups",
  "random"
];
var ROLE_NAMES = [
  "evaluator",
  "coordinator",
  "doer",
  "auditor",
  "helper",
  "advisor",
  "pioneer",
  "campaigner"
];
var findDistributionPattern = (distribution, useZero = true) => {
  const { occupiedIndices, segments } = findOccupiedIndices(
    distribution,
    useZero
  );
  const occupiedCount = occupiedIndices.length;
  const occupiedSegments = occupiedIndices.map((i) => ROLE_NAMES[i]).join(", ");
  if (occupiedCount >= 6) {
    return {
      pattern: "spreadout",
      segments: `(${occupiedSegments})`
    };
  }
  if (isAlternatingPattern(segments)) {
    return {
      pattern: "alternating",
      segments: `(${occupiedSegments})`
    };
  }
  const adjacentGroups = findAdjacentGroups(occupiedIndices);
  const adjacentResult = checkAdjacentPattern(occupiedIndices, adjacentGroups);
  if (adjacentResult) {
    return adjacentResult;
  }
  const opposingResult = checkOpposingPattern(adjacentGroups);
  if (opposingResult) {
    return opposingResult;
  }
  const threeGroupsResult = checkGroupPatterns(adjacentGroups);
  if (threeGroupsResult) {
    return threeGroupsResult;
  }
  return { pattern: "random", segments: `(${occupiedSegments})` };
};
var isAlternatingPattern = (segments) => {
  const occupied = segments.map((count) => count > 0);
  const firstOccupied = occupied.findIndex((o) => o);
  if (firstOccupied === -1)
    return false;
  for (let i = 0; i < 8; i++) {
    const index = (firstOccupied + i) % 8;
    const expectedOccupied = i % 2 === 0;
    if (occupied[index] !== expectedOccupied) {
      return false;
    }
  }
  return true;
};
var checkAdjacentPattern = (occupiedIndices, adjacentGroups) => {
  if (occupiedIndices.length === 0)
    return null;
  if (adjacentGroups.length === 1) {
    const groupSize = adjacentGroups[0].length;
    if (groupSize >= 1 && groupSize <= 5) {
      const segmentNames = adjacentGroups[0].map((i) => ROLE_NAMES[i]).join("-");
      return {
        pattern: groupSize > 2 ? "1 big group" : "1 small group",
        segments: `Group1: ${segmentNames}`
      };
    }
  }
  return null;
};
var checkOpposingPattern = (adjacentGroups) => {
  if (adjacentGroups.length === 2) {
    const group1 = adjacentGroups[0];
    const group2 = adjacentGroups[1];
    if (areGroupsOpposing(group1, group2)) {
      const group1Names = group1.map((i) => ROLE_NAMES[i]).join("-");
      const group2Names = group2.map((i) => ROLE_NAMES[i]).join("-");
      return {
        pattern: "opposing",
        segments: `Group1: ${group1Names}, Group2: ${group2Names}`
      };
    }
  }
  return null;
};
var checkGroupPatterns = (adjacentGroups) => {
  if (adjacentGroups.length === 3) {
    const groupSizes = adjacentGroups.map((group) => group.length);
    const singleSegments = groupSizes.filter((size) => size === 1).length;
    const groups = groupSizes.filter((size) => size === 2 || size === 3).length;
    if (singleSegments === 2 && groups === 1 || singleSegments === 1 && groups === 2 || singleSegments === 3) {
      const groupNames = adjacentGroups.map(
        (group, index) => group.length === 1 ? `Group${index}: ${ROLE_NAMES[group[0]]}` : `Group${index}: ${group.map((i) => ROLE_NAMES[i]).join("-")}`
      ).join(", ");
      return { pattern: "3 groups", segments: `${groupNames}` };
    }
  }
  if (adjacentGroups.length === 2) {
    const group1 = adjacentGroups[0];
    const group2 = adjacentGroups[1];
    const group1Names = group1.map((i) => ROLE_NAMES[i]).join("-");
    const group2Names = group2.map((i) => ROLE_NAMES[i]).join("-");
    return {
      pattern: "2 groups",
      segments: `Group1: ${group1Names}, Group2: ${group2Names}`
    };
  }
  return null;
};
var findAdjacentGroups = (occupiedIndices) => {
  if (occupiedIndices.length === 0)
    return [];
  const groups = [];
  const visited = /* @__PURE__ */ new Set();
  for (const index of occupiedIndices) {
    if (visited.has(index))
      continue;
    const group = [index];
    visited.add(index);
    let changed = true;
    while (changed) {
      changed = false;
      for (const groupIndex of [...group]) {
        const prev = (groupIndex - 1 + 8) % 8;
        const next = (groupIndex + 1) % 8;
        if (occupiedIndices.includes(prev) && !visited.has(prev)) {
          group.push(prev);
          visited.add(prev);
          changed = true;
        }
        if (occupiedIndices.includes(next) && !visited.has(next)) {
          group.push(next);
          visited.add(next);
          changed = true;
        }
      }
    }
    group.sort((a, b) => a - b);
    groups.push(group);
  }
  return groups;
};
var areAdjacent = (index1, index2) => {
  const diff = Math.abs(index1 - index2);
  return diff === 1 || diff === 7;
};
var areGroupsOpposing = (group1, group2) => {
  const opposites = [
    [0, 4],
    [1, 5],
    [2, 6],
    [3, 7]
  ];
  for (const [seg1, seg2] of opposites) {
    if (group1.includes(seg1) && group2.includes(seg2) || group1.includes(seg2) && group2.includes(seg1)) {
      return true;
    }
  }
  return false;
};
var significantHighNumbers = (distribution) => {
  const roleScores = ROLE_NAMES.map((key, index) => ({
    key,
    score: distribution[key],
    index
  }));
  const positiveScores = roleScores.filter((item) => item.score > 0);
  const scores = positiveScores.map((item) => item.score);
  const mean = scores.reduce((sum, val) => sum + val, 0) / scores.length;
  const variance = scores.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / (scores.length - 1 || 1);
  const std = Math.sqrt(variance);
  const threshold = mean - 0.5 * std;
  return roleScores.filter((item) => item.score >= threshold).map((item) => item.index);
};
var calculatePercentageDistribution = (distribution) => {
  const total = Object.values(distribution).reduce(
    (sum, value) => sum + value,
    0
  );
  if (total === 0) {
    return Object.keys(distribution).reduce(
      (acc, key) => {
        acc[key] = 0;
        return acc;
      },
      {}
    );
  }
  const expectedNumber = total / 8;
  return Object.keys(distribution).reduce(
    (acc, key) => {
      acc[key] = 50 / expectedNumber * distribution[key];
      return acc;
    },
    {}
  );
};
var findPatternOnPercentages = (distribution) => {
  const percentageDistribution = calculatePercentageDistribution(distribution);
  const segments = [
    percentageDistribution.evaluator,
    percentageDistribution.coordinator,
    percentageDistribution.doer,
    percentageDistribution.auditor,
    percentageDistribution.helper,
    percentageDistribution.advisor,
    percentageDistribution.pioneer,
    percentageDistribution.campaigner
  ];
  return segments.map((count, index) => count > 83 ? index : -1).filter((i) => i >= 0);
};
var findOccupiedIndices = (distribution, useZero = false) => {
  const segments = [
    distribution.evaluator,
    distribution.coordinator,
    distribution.doer,
    distribution.auditor,
    distribution.helper,
    distribution.advisor,
    distribution.pioneer,
    distribution.campaigner
  ];
  const occupiedIndices = useZero ? segments.map((count, index) => count > 0 ? index : -1).filter((i) => i >= 0) : significantHighNumbers(distribution);
  return { occupiedIndices, segments };
};

// src/utils/leadershipStyle.ts
var LEADERSHIP_STYLES = [
  "Directive",
  "Democratic",
  "Non-Directive"
];
var STYLE_TYPES = {
  Directive: ["evaluator", "coordinator", "doer"],
  Democratic: ["campaigner", "helper", "advisor"],
  "Non-Directive": ["pioneer", "auditor", "advisor"]
};
var describeLeadershipStyles = (personalityTypes) => {
  const placements = personalityTypes.map(stylesForPersonalityType).filter((styles) => styles.length > 0);
  if (!placements.length)
    return [];
  return withShares(LEADERSHIP_STYLES.map(countStyle(placements)));
};
var stylesForPersonalityType = (personalityType) => personalityType ? LEADERSHIP_STYLES.filter(
  (style) => typesLeadingBy(style).includes(personalityType)
) : [];
var countStyle = (placements) => (style) => {
  const here = placements.filter((styles) => styles.includes(style));
  const anchored = here.filter((styles) => styles.length === 1).length;
  const flexing = here.length - anchored;
  return { style, anchored, flexing, weight: anchored + flexing / 2 };
};
var withShares = (counted) => {
  const total = counted.reduce((sum, { weight }) => sum + weight, 0);
  const exact = counted.map(({ weight }) => weight / total * 100);
  const floors = exact.map(Math.floor);
  const short = 100 - floors.reduce((sum, share) => sum + share, 0);
  const roundedUp = new Set(byRemainder(exact, floors).slice(0, short));
  return counted.map((share, index) => ({
    ...share,
    sharePct: floors[index] + (roundedUp.has(index) ? 1 : 0)
  }));
};
var byRemainder = (exact, floors) => exact.map((share, index) => ({ index, remainder: share - floors[index] })).sort(
  (one, other) => other.remainder - one.remainder || exact[other.index] - exact[one.index]
).map(({ index }) => index);
var typesLeadingBy = (style) => STYLE_TYPES[style];

// src/utils/observationBand.ts
var OBSERVATION_BAND_CEILINGS = [
  [1.8, "left"],
  [2.6, "slightLeft"],
  [3.4, "middle"],
  [4.2, "slightRight"],
  [5, "right"]
];
var SCALE_FLOOR = 1;
var observationBandFor = (score) => {
  if (!Number.isFinite(score) || score < SCALE_FLOOR)
    return null;
  const band = OBSERVATION_BAND_CEILINGS.find(([ceiling]) => score <= ceiling);
  return band ? band[1] : null;
};

// src/cultureReport/reportDocument.ts
import { z } from "zod";
var gapBand = z.enum(["none", "small", "moderate", "large"]);
var gapSignal = z.enum(["aligned", "small", "moderate", "large"]);
var credibilitySignal = z.enum(["strong", "moderate", "directional"]);
var engagementSignal = z.enum(["positive", "neutral", "poor"]);
var roleCounts = z.object(
  Object.fromEntries(ROLE_NAMES.map((role) => [role, z.number()]))
).partial();
var leadershipStyleShare = z.object({
  style: z.enum(LEADERSHIP_STYLES),
  anchored: z.number(),
  flexing: z.number(),
  weight: z.number(),
  sharePct: z.number()
});
var cultureReading = z.object({
  reading: z.string(),
  notEstablished: z.string()
});
var entityType = z.enum(CULTURE_ENTITY_TYPES);
var CULTURE_UNMEASURED_REASONS = ["not asked", "no answers"];
var unmeasuredReason = z.enum(CULTURE_UNMEASURED_REASONS);
var respondentSplit = z.object({
  pairedCount: z.number(),
  wantingHigherCount: z.number(),
  wantingLowerCount: z.number(),
  wantingNoChangeCount: z.number(),
  /**
   * Of those asking each way, how many asked to move by more than half a point. Nullish on a
   * report stored before the strong asks were counted, which states the split without them.
   */
  strongHigherCount: z.number().nullish(),
  strongLowerCount: z.number().nullish()
});
var dimensionFigures = z.object({
  dimension: z.string(),
  /**
   * Where the answers averaged, or null where there were none.
   *
   * Nullable because the alternative was zero, which on a one-to-five scale is a position rather
   * than an absence: an area nobody answered scored zero against a desired 3.4 and reported a
   * demand for change that nobody had made.
   */
  current: z.number().nullable(),
  desired: z.number().nullable(),
  /** Desired minus current, and null unless both were measured: a distance needs two readings. */
  gap: z.number().nullable(),
  gapBand: gapBand.nullable(),
  /** Null where the reading beside it is a number. Absent on a report written before either. */
  currentUnmeasured: unmeasuredReason.nullish(),
  desiredUnmeasured: unmeasuredReason.nullish(),
  /**
   * Which way the people asking for change on this area were asking, one person at a time.
   *
   * The only reading in the document that evidences two positions inside one group. A gap is a
   * distance between two means and cancels where people want opposite things; a spread says how
   * far apart the answers got and never how they were arranged. This pairs each person's own two
   * answers, so `opposite ways` is counted rather than inferred.
   *
   * Absent wherever it could not be read: fewer than three of these people asked for anything
   * here, the people asking were fewer than half of those who answered, or the two halves of the
   * assessment could not be matched up per person. Absent is not
   * `same way`, and a report written before engage paired them carries none of these.
   */
  respondentDirection: z.enum(["same way", "opposite ways"]).nullish(),
  /**
   * The same reading counted out, which is what the page states under the area's own name.
   *
   * `respondentDirection` is a verdict and this is what it was read from, so an area split three
   * against three and an area where five asked together and a sixth did not stop reading alike.
   * Four reports made a false claim about how the people split, each in a different wording of
   * roughly, broadly, almost equally or close to even, and each over several areas at once where
   * only one of them was level. The prompts answered it four times and the fifth answer would
   * have been prose as well, so the figures are here and the page writes the sentence.
   *
   * Counts and no shares. A share is the page dividing one of these by `pairedCount`, and the
   * sentence it is drawn into says "eight of fourteen" rather than a percentage, so the division
   * would only round something the reader can already see. `wantingHigher` is toward the pole
   * after the bar, the same way a positive gap is.
   *
   * Absent wherever `respondentDirection` is, and on any report written before the page drew it.
   */
  respondentSplit: respondentSplit.nullish(),
  /**
   * Where this cohort sits against the organisation on the same area, on both readings.
   *
   * Only present where the figures belong to a team: the organisation has nothing to be compared
   * with. It is what lets a page label the organisation's own line as a comparator rather than
   * leaving a reader to assume the two numbers beside each other describe the same people.
   */
  differenceFromOverall: z.number().nullish(),
  desiredDifferenceFromOverall: z.number().nullish(),
  /**
   * Whether this cohort sits far enough from the business around it for the report to say so.
   *
   * Banded on the distance from the rest of the business rather than on the two figures above,
   * which are the distance from all of it. A team is inside the organisation's own mean, so the
   * larger it is the closer to average it comes out — a division holding half the company was
   * being measured against a number it had largely written. The figures stay as the distance from
   * the organisation, because that is the comparator the page draws and names.
   *
   * The current one is charged for the campaign having asked the same question of every team, so
   * a business with a dozen of them does not turn one up whether or not anything is there. The
   * desired one is not: nothing asks it of everybody at once.
   */
  differenceBand: gapBand.nullish(),
  desiredDifferenceBand: gapBand.nullish()
});
var satisfactionRating = z.enum([
  "very dissatisfied",
  "dissatisfied",
  "neutral",
  "satisfied",
  "very satisfied"
]);
var SATISFACTION_THRESHOLDS = [
  { below: 1.9, rating: "very dissatisfied" },
  { below: 2.7, rating: "dissatisfied" },
  { below: 3.5, rating: "neutral" },
  { below: 4.3, rating: "satisfied" },
  { below: Infinity, rating: "very satisfied" }
];
var satisfactionRatingFor = (score) => (SATISFACTION_THRESHOLDS.find(({ below }) => score < below) ?? SATISFACTION_THRESHOLDS[SATISFACTION_THRESHOLDS.length - 1]).rating;
var engagementScore = z.object({
  dimension: z.string(),
  score: z.number(),
  rating: satisfactionRating
});
var respondentBreakdown = z.object({
  entityName: z.string(),
  /**
   * The `$`-delimited division path, or the group's name.
   *
   * A division is nested under its parent by matching paths rather than by splitting
   * `entityName` on `/`, which would read a division whose own name holds a slash as two.
   */
  entityFilter: z.string(),
  respondentCount: z.number(),
  invitedCount: z.number(),
  completionRatePct: z.number()
});
var CULTURE_EXCLUSION_REASONS = [
  "too few responses",
  "protects a smaller group"
];
var excludedGroup = z.object({
  entityType,
  entityName: z.string(),
  reason: z.enum(CULTURE_EXCLUSION_REASONS)
});
var CULTURE_REPORT_SOURCES = [
  "culture",
  "feedback",
  "job satisfaction",
  "work personality"
];
var source = z.enum(CULTURE_REPORT_SOURCES);
var CULTURE_WRITTEN_EVIDENCE_SOURCES = [
  "culture",
  "feedback",
  "work personality"
];
var CULTURE_SOURCE_LABELS = {
  culture: "Culture",
  feedback: "Feedback",
  "job satisfaction": "Job satisfaction",
  "work personality": "Work personality"
};
var GOING_WELL = "going_well";
var NEEDS_FOCUS = "needs_focus";
var CULTURE_INSIGHT_DIRECTIONS = [GOING_WELL, NEEDS_FOCUS];
var CULTURE_INSIGHT_PRIORITIES = [
  "maintain",
  "high",
  "medium",
  "low"
];
var CULTURE_STRATEGIC_RELEVANCE = [
  "critical",
  "relevant",
  "limited"
];
var CULTURE_INSIGHT_WHOLE_ORGANISATION = "whole organisation";
var CULTURE_INSIGHT_LEADERSHIP_TEAM = "leadership team";
var feedbackTheme = z.object({
  themeName: z.string(),
  body: z.string(),
  sentiment: z.string(),
  commentCount: z.number(),
  /**
   * How many people wrote them, which is a different unit from the count above it.
   *
   * One person writing four times about the same thing is four comments and one voice, and
   * the cuts below are counted in people already — engage names a division only where three
   * of the theme's people share it. Printing only the comments put two denominators on one
   * card and labelled them both as size.
   */
  contributorCount: z.number(),
  divisions: z.array(z.string()),
  groups: z.array(z.string())
}).partial().required({ themeName: true });
var insightWhere = z.object({
  name: z.string(),
  entityType: entityType.nullable(),
  /**
   * How this place selects its respondents, which is what makes it an identity rather than a word.
   *
   * A division path (`Engineering$Platform$`) or the value itself, the same form
   * `respondentBreakdown` carries. Null for the two reserved places, which select nobody.
   */
  entityFilter: z.string().nullable(),
  /**
   * The culture areas the finding named, measured on THIS place's answers.
   *
   * It sat on the insight and held the organisation's twelve, so a finding about one division was
   * drawn beside the whole business's chart: Engineering could be described as wanting substantial
   * change above a near-zero organisation gap, and two divisions pulling opposite ways both showed
   * the average that cancelled them out. A finding naming two teams carries two sets now, each
   * under the name it belongs to, and `whole organisation` is one place among them rather than the
   * answer for all of them.
   */
  dimensions: z.array(dimensionFigures),
  /**
   * The job satisfaction questions the finding named, as THIS place rated them.
   *
   * The page writes the finding's job satisfaction evidence from these. The stage wrote that line
   * itself once, and it is where "every team satisfied or better" was written beside a team rating
   * neutral: nothing on the card drew the ratings, so a reader had only the sentence. Empty where
   * the finding named none, and on `leadership team`, which has no answers of its own. Absent on
   * a report written before the page drew them, whose own sentence stands instead.
   */
  engagement: z.array(engagementScore).nullish()
});
var insightExplanation = z.object({
  possibleExplanation: z.string().nullable(),
  alternativeExplanation: z.string().nullable(),
  howToCheck: z.string().nullable()
});
var insight = z.object({
  insight: z.string(),
  direction: z.enum(CULTURE_INSIGHT_DIRECTIONS),
  where: z.array(insightWhere),
  priority: z.enum(CULTURE_INSIGHT_PRIORITIES),
  strategicRelevance: z.enum(CULTURE_STRATEGIC_RELEVANCE),
  sources: z.array(source),
  evidence: z.array(z.object({ source, text: z.string() })),
  whyItExists: insightExplanation,
  ifNothingChanges: z.string().nullable(),
  questions: z.array(z.string()).nullable()
}).partial().required({ insight: true });
var CULTURE_VALUE_ALIGNMENTS = [
  "supports",
  "partially_supports",
  "tensions_with"
];
var valueRow = z.object({
  value: z.string(),
  note: z.string(),
  alignment: z.enum(CULTURE_VALUE_ALIGNMENTS)
}).partial().required({ value: true });
var CULTURE_THEMES_SHOWN_OPEN = 3;
var CULTURE_SENTIMENT_SIGNALS = [
  "positive",
  "mixed",
  "negative"
];
var sentimentSignal = z.enum(CULTURE_SENTIMENT_SIGNALS);
var sentimentCounts = z.object({
  positive: z.number(),
  neutral: z.number(),
  negative: z.number()
});
var CultureReportDocumentSchema = z.object({
  /**
   * What the organisation says about itself, as the report was read against it.
   *
   * Nothing here is written. It is the business profile, flattened: the report is generated
   * against that profile, and the only trace of it a reader used to see was the values it is
   * checked on and the leadership team named on it. It opened on a written paragraph until the
   * report stopped introducing the business to the person who runs it.
   *
   * Stored rather than queried live, the way every other section is. The profile is standing
   * context that a business edits between campaigns, so a card reading it fresh would describe
   * an organisation the sections under it were not written about.
   *
   * Flat rather than nested the way `BusinessProfile` is: the section draws one list of
   * labelled rows, and two levels of optionality to reach a row buys nothing. The stated values
   * are deliberately not here — a whole section is about them.
   *
   * `reach` and `lifecycleStage` are strings rather than enums for the reason a feedback
   * theme's sentiment is: the vocabulary is the business profile's, and a stage added there
   * should reach the page as its own word rather than fail to compile.
   */
  organisation: z.object({
    website: z.string().nullable(),
    industry: z.string().nullable(),
    founded: z.string().nullable(),
    scale: z.string().nullable(),
    workModel: z.string().nullable(),
    locations: z.string().nullable(),
    reach: z.string().nullable(),
    mission: z.string().nullable(),
    vision: z.string().nullable(),
    /** The priorities the business set for the year, most important first. At most three. */
    goals: z.array(z.string()),
    lifecycleStage: z.string().nullable(),
    /** The organisation's own description of its stage, set only where the stage is `OTHER`. */
    lifecycleStageOther: z.string().nullable(),
    /** How the leadership team is arranged: reporting lines, direct reports, team leads. */
    structure: z.string().nullable()
  }).partial(),
  /** The one section with no narrative: the page reads it as tiles, and the model writes none. */
  participation: z.object({
    totalInvited: z.number(),
    totalCompleted: z.number(),
    completionRatePct: z.number(),
    credibilitySignal,
    excludedGroups: z.array(excludedGroup),
    personalityCoveragePct: z.number(),
    personalityCoverageSufficient: z.boolean(),
    /** Who answered, division by division, already in tree order. */
    divisions: z.array(respondentBreakdown),
    /** The same by group, largest first. */
    groups: z.array(respondentBreakdown),
    /**
     * The same again by the three cuts that neither nest nor overlap, largest first.
     *
     * Absent on a report written before engage broke the campaign down by them. A person
     * sits in one office, one length of service and one seniority, so unlike the groups
     * these shares cannot add to more than the whole — and unlike the divisions they
     * routinely add to rather less, since a respondent with no start date or no office on
     * file is in none of the rows.
     */
    locations: z.array(respondentBreakdown),
    tenureBands: z.array(respondentBreakdown),
    jobLevels: z.array(respondentBreakdown)
  }).partial(),
  /**
   * The four readings engage measured over the whole campaign, and nothing written about them.
   *
   * Every one is arithmetic, so there was never anything here for a model to say — and each was
   * carried on the section that reported its own instrument, under prose that said in sixty
   * words what a tile says in one word and a bar. Those sections are gone and the readings are
   * not: they are what the summary card opens the appendix on.
   *
   * A key of its own rather than a home on the summary, because `participation` set the
   * precedent for figures nobody writes, and because the summary is a page's arrangement of
   * them rather than the place they live.
   */
  signals: z.object({
    /**
     * Null where there is no verdict to give, which is a campaign with nothing to read
     * rather than an aligned business. `aligned` is a verdict, and it was the default.
     *
     * Two campaigns reach it. One measured no area on both halves. The other measured them
     * and found every gap too thinly answered to stand behind, which is a business that
     * asked for things and a report that cannot say how much. Neither is alignment, and the
     * twelve bands under the tile are what a reader is owed instead of the word.
     */
    gapSignal: gapSignal.nullable(),
    /**
     * How the five questions about somebody's own job read, which is what sets the pace.
     *
     * Null where the campaign carried no job satisfaction questions, and also where it
     * carried them and `withheldEngagement` held them back: the five that go are every
     * question about a person's own job, so there is nothing left to read a pace off.
     */
    personalEngagementSignal: engagementSignal.nullable(),
    /**
     * How the four questions about the company read, which is a separate construct.
     *
     * One verdict over all nine put pessimism about the company's finances and an intention
     * to resign in the same word, and only one of those says the business is running out of
     * time. Never withheld: these are beliefs about a shared subject rather than about the
     * person answering, so they are averaged however few answered.
     */
    companyPerceptionSignal: engagementSignal.nullable(),
    /** Empty for the same campaign, which is a tile the summary leaves out. */
    engagement: z.array(engagementScore),
    /**
     * The job satisfaction questions the campaign asked and engage held back.
     *
     * Carried so the page can say why the tile is not there. A question missing from
     * `engagement` is missing for one of two reasons — never asked, or answered by too few
     * people to report without describing them — and a reader shown neither the figure nor
     * the reason is left to assume the survey never covered it.
     *
     * Absent on a report written before engage told the two apart.
     */
    withheldEngagement: z.array(z.string()),
    /**
     * All twelve areas, because `gapSignal` alone is the widest of them.
     *
     * The word is a worst case with no sense of how much of the business is in it, so the
     * tile bands the twelve underneath it. Not the chart that used to draw them: that was a
     * section of its own, and the areas a finding rests on now reach the reader on the
     * finding, in `insights[].where[].dimensions`.
     */
    dimensions: z.array(dimensionFigures)
  }).partial(),
  /** No narrative: the themes are the section, and a paragraph above them only restated them. */
  employeeFeedback: z.object({
    note: z.string().nullable(),
    /** Every comment the campaign collected, which the themes and the bar are shares of. */
    commentCount: z.number(),
    unclassifiedCount: z.number(),
    /**
     * How many of those comments had their sentiment extracted when the report was written.
     *
     * Extraction is queued per response and can still be running when a campaign closes, so
     * `sentimentCounts` is a reading of this many comments rather than of all of them. The
     * page says so where the two differ, instead of heading a partial count "the feedback".
     */
    extractedCommentCount: z.number(),
    /** Absent where nothing has had its sentiment extracted yet, which is no bar rather than an empty one. */
    sentimentCounts,
    sentimentSignal,
    themes: z.array(feedbackTheme)
  }).partial(),
  /**
   * The wheel the whole business makes, and the one reading taken off it.
   *
   * It carried a headline and a summary until the report stopped reporting an instrument at a
   * time, and for a while it carried neither. What that left out is what this block says now:
   * leadership, systems, incentives and expectations all sit between this mix and the culture,
   * which makes the whole-business shape a weak explanation and not no explanation, and nothing
   * else in the report was saying what it may be contributing. What dominates and what is thin
   * is still the wheel's to say.
   *
   * Absent below engage's coverage rule, along with the figures: a mix read off a third of the
   * respondents describes whoever has a profile rather than the people who answered.
   */
  organisationWorkPersonality: z.object({
    included: z.boolean(),
    pattern: z.string().nullable(),
    patternSegments: z.string().nullable(),
    counts: roleCounts,
    dominantTypes: z.array(z.string()),
    underrepresentedTypes: z.array(z.string()),
    /**
     * What this mix may be contributing to the culture the campaign measured, and what the
     * survey did not measure about it.
     */
    cultureImpact: cultureReading
  }).partial(),
  /**
   * The leadership team, the shape their work personalities make, and what it is likely to mean.
   *
   * It was figures alone: the team is named on the business profile and the wheel counted off
   * it, so nothing was asked of a stage. What that left out is the reading — a small group whose
   * mix propagates outward through decisions, priorities and what gets rewarded is the strongest
   * explanation the survey has for why the business works the way it does, and eight rows of
   * counts do not say it.
   *
   * `pattern` is still engage's own reading with no descriptor after it. An entity summary's is
   * qualified by the card stage; this one nobody was asked to qualify.
   */
  leadership: z.object({
    members: z.array(
      z.object({
        name: z.string().nullable(),
        jobTitle: z.string().nullable(),
        personalityType: z.string().nullable(),
        /**
         * The most senior leader being evaluated, who may not be the chief executive. At most
         * one member carries it, and a profile that names a team and no leader carries none.
         */
        isMostSenior: z.boolean()
      })
    ),
    memberCount: z.number(),
    profileCount: z.number(),
    included: z.boolean(),
    pattern: z.string().nullable(),
    patternSegments: z.string().nullable(),
    counts: roleCounts,
    /**
     * How the team spreads across the three default ways of leading, which is engage's own
     * count off `members` rather than anything a stage was asked for.
     *
     * Empty below the profile gate, for the reason `counts` is emptied there: a spread read
     * off two people is a spread of two people, and the chart would draw it as the team.
     */
    styleSpread: z.array(leadershipStyleShare),
    headline: z.string(),
    strengths: z.string(),
    dynamics: z.string(),
    gaps: z.string(),
    /**
     * How this mix may be showing up in the culture the campaign measured, and what the survey
     * did not measure about it.
     */
    cultureImpact: cultureReading,
    /**
     * What the spread above is good at and where it is likely to cost them.
     *
     * Null where there is no spread to read. Below the profile gate the whole reading is
     * absent, this and the prose above it, because it would be a reading of one or two people.
     */
    leadershipStyle: z.object({
      note: z.string(),
      whatItGivesYou: z.string(),
      whatToWatch: z.string()
    }).nullable()
  }).partial(),
  /**
   * Every finding the report made, going well or needing focus, wherever it occurs.
   *
   * One flat list rather than a block per place. The summary groups it by direction and orders
   * it by priority, so a finding cannot be filed under two headings and written twice. Only the
   * ones needing focus are argued below it in a card.
   */
  insights: z.array(insight),
  /**
   * The stated values and what the survey says about each, or null where none were stated.
   *
   * Rows and nothing else. A closing line under them said what they added up to, and it was
   * written for a section of its own that the summary already carried: the rows are read there
   * as a list with a count over it, and a paragraph summarising a list beside its own tally is
   * the same thing said twice.
   */
  values: z.object({ rows: z.array(valueRow) }).partial().nullable()
}).partial();

// src/cultureReport/gapDirection.ts
var describeGapDirection = (dimension, gap, gapBand2) => {
  const movement = gapBand2 ? MOVEMENT_BY_BAND[gapBand2] : void 0;
  if (!movement || !gap)
    return null;
  const { low, high } = culturePoleLabels(dimension);
  return `${movement} ${gap < 0 ? low : high}`;
};
var MOVEMENT_BY_BAND = {
  small: "wants to move slightly toward",
  moderate: "wants to move toward",
  large: "wants to move a long way toward"
};

// src/cultureReport/respondentSplit.ts
var describeRespondentSplit = (dimension, split) => {
  if (!split?.pairedCount)
    return null;
  const { low, high } = culturePoleLabels(dimension);
  const asks = [
    {
      count: split.wantingLowerCount,
      strong: split.strongLowerCount,
      towards: low
    },
    {
      count: split.wantingHigherCount,
      strong: split.strongHigherCount,
      towards: high
    }
  ].filter(({ count }) => count > 0);
  if (!asks.length)
    return noneAsked(split.pairedCount);
  const [first, ...rest] = asks;
  return [
    `${first.count} of ${split.pairedCount} asked to move toward ${first.towards}${byMuch(first)}`,
    ...rest.map((ask) => `${ask.count} toward ${ask.towards}${byMuch(ask)}`),
    ...noChange(split.wantingNoChangeCount)
  ].join(", ");
};
var byMuch = ({
  count,
  strong
}) => strong ? ` (${strong === count ? "all" : strong} by more than half a point)` : "";
var noneAsked = (pairedCount) => `none of the ${pairedCount} who answered asked to move`;
var noChange = (count) => count > 0 ? [`${count} for no change`] : [];

// src/cultureReport/entitySummary.ts
import { z as z2 } from "zod";
var entityType2 = z2.enum(CULTURE_ENTITY_TYPES);
var alignmentGap = z2.object({
  dimension: z2.string(),
  teamCurrent: z2.number(),
  teamDesired: z2.number(),
  teamGap: z2.number(),
  orgCurrent: z2.number(),
  orgGap: z2.number(),
  currentVsOrg: z2.number(),
  desiredVsOrg: z2.number(),
  gapBand,
  priority: z2.enum(["high", "moderate"])
});
var splitArea = z2.object({
  dimension: z2.string(),
  /** The average size of one person's ask, which is what the cancelled average hides. */
  meanAbsoluteChange: z2.number(),
  respondentSplit
});
var feedbackTheme2 = z2.object({
  themeName: z2.string(),
  description: z2.string().optional(),
  sentiment: z2.string().nullable(),
  commentCount: z2.number(),
  /**
   * How many of this team wrote them, counted off this team's comments rather than inherited.
   *
   * The unit the floor is applied in — a theme reaches a card only where three of the team
   * raised it — and on a team of six it is the number a reader needs, because three people
   * writing four times each is twelve comments from half the team.
   */
  contributorCount: z2.number()
});
var engagementDifference = z2.object({
  dimension: z2.string(),
  teamScore: z2.number(),
  satisfactionRating,
  deltaFromOrg: z2.number(),
  signal: z2.enum(["positive", "neutral", "concern"])
});
var insightThread = z2.object({
  threadName: z2.string(),
  sources: z2.array(source),
  description: z2.string(),
  possibleExplanation: z2.string().nullable()
});
var CultureEntitySummaryCardSchema = z2.object({
  entityType: entityType2,
  entityName: z2.string(),
  /** How the team selects its respondents: a `$`-delimited division path, or a group name. */
  entityFilter: z2.string(),
  respondentCount: z2.number(),
  personalityCoveragePct: z2.number(),
  headline: z2.string(),
  executiveSummary: z2.string(),
  insights: z2.object({ threads: z2.array(insightThread) }).partial(),
  /** Empty below the coverage threshold, where the wheel would describe the wrong group. */
  workPersonality: z2.object({
    included: z2.boolean(),
    coverageNote: z2.string().nullable(),
    pattern: z2.string().nullable(),
    counts: roleCounts,
    dominantTypes: z2.array(z2.string()),
    underrepresentedTypes: z2.array(z2.string()),
    narrative: z2.string().nullable()
  }).partial(),
  culture: z2.object({
    /**
     * Null where no area of this team's culture was measured on both halves.
     *
     * `true` is the claim that a team wants what it already has, and it was what a team with
     * no figures at all got: nothing to report read as nothing to change.
     */
    broadlyAligned: z2.boolean().nullable(),
    narrative: z2.string(),
    alignmentGaps: z2.array(alignmentGap),
    /**
     * The areas with no established gap that this team asked for change on anyway.
     *
     * Empty on most teams and the whole culture section on a few. A card written before the
     * page drew them has no such array, which reads the same as a team with none.
     */
    splitAreas: z2.array(splitArea)
  }).partial(),
  feedback: z2.object({
    included: z2.boolean(),
    note: z2.string().nullable(),
    /** Null where the team formed no theme, which the page says in its own words. */
    narrative: z2.string().nullable(),
    themes: z2.array(feedbackTheme2)
  }).partial(),
  engagement: z2.object({
    narrative: z2.string(),
    differences: z2.array(engagementDifference)
  }).partial(),
  alignment: z2.object({ mustAlign: z2.string(), canDiffer: z2.string() }).partial(),
  leaderQuestions: z2.array(z2.string())
}).partial();

// src/cultureReport/modelInput.ts
import { z as z3 } from "zod";
var CULTURE_ENTITY_TYPE_WORDS = {
  DIVISION: "division",
  GROUP: "group",
  LOCATION: "location",
  TENURE_BAND: "tenure band",
  JOB_LEVEL: "job level"
};
var teamTypeWord = z3.enum([
  CULTURE_ENTITY_TYPE_WORDS.DIVISION,
  CULTURE_ENTITY_TYPE_WORDS.GROUP
]);
var sameOrOpposite = z3.enum(["same way", "opposite ways"]);
var CULTURE_MIDDLE_POSITION = "middle";
var CULTURE_SLIGHT_LEAN = "slightly";
var cultureSlightLean = (pole) => `${CULTURE_SLIGHT_LEAN} ${pole}`;
var CULTURE_LIFECYCLE_STAGES = [
  "seed",
  "startup",
  "growth",
  "maturity",
  "decline",
  "turnaround",
  "exit"
];
var code = (value) => `\`${value}\``;
var orList = (values) => `${values.slice(0, -1).map(code).join(", ")} or ${code(values[values.length - 1])}`;
var pattern = z3.enum(DISTRIBUTION_PATTERNS);
var CULTURE_HOW_MANY_ASKED = [
  "everyone",
  "most",
  "half",
  "fewer than half",
  "nobody"
];
var CULTURE_RESPONDENT_SPLITS = ["about even", "lopsided"];
var CULTURE_ALL_ONE_WAY = "all one way";
var CULTURE_MINORITY_COUNTS = [
  "at least one",
  "one",
  "a few",
  "a sizeable minority",
  "half or more"
];
var minorityCount = z3.enum(CULTURE_MINORITY_COUNTS).describe(
  "How many of the people it is read over, in words: `one`, `a few` where under a quarter of them, `a sizeable minority` where a quarter or more and under half, `half or more`, or `at least one` where the reading rests on three people and any other word would count them."
);
var pairedChange = z3.object({
  howManyAsked: z3.enum(CULTURE_HOW_MANY_ASKED).describe(
    "How many of the people who answered this area on both halves asked to move it by more than a fifth of a point, either way: `everyone`, `most` where more than half did, `half` where exactly half did, `fewer than half`, or `nobody`."
  ),
  askBand: gapBand.describe(
    "How far the average person asked to move, whichever way, so asks in opposite directions do not cancel. Banded as `gapBand` is."
  )
}).strict();
var area = z3.object({
  dimension: z3.string().describe(
    "The area's key, its two poles either side of the bar: `ad-hoc|planned` is ad-hoc at 1 and planned at 5."
  ),
  gapBand: gapBand.nullable().describe(
    "How far where people want the area to run sits from where it runs today, on the 1 to 5 scale, in words: `none` within a fifth of a point, `small` up to half a point, `moderate` up to a whole point and `large` beyond. `moderate` and `large` are reportable on their own; `small` can support a finding and never carry one. Which way is `askedDirection`'s. Null unless both halves were measured."
  ),
  respondentDirection: z3.enum([CULTURE_ALL_ONE_WAY, "same way", "opposite ways"]).optional().describe(
    "Which way the people asking for change here asked, taken one at a time: `all one way` where every one of them asked toward the same pole, `same way` where fewer than a quarter of them asked toward the other, and `opposite ways` where at least a quarter did. Absent where fewer than three asked for anything, where those asking were fewer than half of those who answered both halves, or where the halves could not be matched per person."
  ),
  split: z3.enum(CULTURE_RESPONDENT_SPLITS).optional().describe(
    "How the two sides of an `opposite ways` area compare: `lopsided` where the larger is at least twice the smaller, and `about even` otherwise. Present only where `respondentDirection` is `opposite ways`."
  ),
  pairedChange: pairedChange.optional().describe(
    "What each person who answered both halves asked for, taken together. Absent where fewer than three people answered both halves, or the halves could not be matched per person."
  ),
  currentUnmeasured: unmeasuredReason.optional().describe(
    "Why there is no reading of how work runs today, and present only where there is none: `not asked` where the campaign never carried that half of the assessment, and `no answers` where it did and these people left it blank."
  ),
  desiredUnmeasured: unmeasuredReason.optional().describe(
    "Why there is no reading of how people want it to run, in the same two words."
  ),
  currentPosition: z3.string().optional().describe(
    `The pole the answers on how work runs today lean toward, by its word in the key, and how far: the word alone where they averaged 1.8 or below, or above 4.2; ${code(cultureSlightLean("<pole>"))} where they averaged between 1.81 and 2.6, or between 3.41 and 4.2; and ${code(CULTURE_MIDDLE_POSITION)} where they averaged between 2.61 and 3.4. These are the bands the Dimensions page describes a score in. Absent where there is no reading of today.`
  ),
  askedDirection: z3.string().optional().describe(
    "The pole people asked to move toward, by its word in the key. Present only where `gapBand` is `small` or wider."
  ),
  strongAsks: z3.array(
    z3.object({
      toward: z3.string().describe("The pole, by its word in the key."),
      howMany: minorityCount
    }).strict()
  ).optional().describe(
    "The people who each asked to move this area by more than half a point, under the pole each asked toward, read one person at a time so an average cannot hide them. Only poles somebody asked toward. Absent where nobody did, and where saying so could point to who they are."
  )
}).strict().describe("One of the 12 culture areas.");
var organisationArea = area.extend({
  teamDirection: sameOrOpposite.optional().describe(
    "Whether the teams whose own gap here is `moderate` or `large` point the `same way` or `opposite ways`. Absent where fewer than two teams do, which is not the same as their agreeing."
  ),
  teamsAsking: z3.array(
    z3.object({
      toward: z3.string().describe("The pole, by its word in the key."),
      teams: z3.array(z3.string()).describe(
        "The teams whose own `askedDirection` here is that pole."
      )
    }).strict()
  ).optional().describe(
    "The teams behind `teamDirection`, one entry for each pole any of them is asking toward. Present wherever `teamDirection` is."
  ),
  teamsApart: z3.array(
    z3.object({
      toward: z3.string().describe("The pole, by its word in the key."),
      teams: z3.array(z3.string()).describe(
        "The teams whose `differenceDimensions` name this area and whose `differenceDirection` here is that pole."
      )
    }).strict()
  ).optional().describe(
    "The teams that already work differently from the rest of the business on this area, one entry for each pole any of them sits toward. Two teams under opposite poles differ from each other here; two under one pole sit apart from the rest the same way. Absent where no team's `differenceDimensions` names the area."
  )
});
var teamArea = area.extend({
  differenceBand: gapBand.nullable().describe(
    "How far the team's answers on how work runs today sit from those of everybody the team does not hold, banded as `gapBand` is. Null where the team holds everyone, and on a team with `sameTeamAs`."
  ),
  desiredDifferenceBand: gapBand.nullable().describe(
    "The same for how they want it to run. Null where `differenceBand` is."
  ),
  differenceDirection: z3.string().optional().describe(
    "The pole the team sits toward against the rest of the business today, by its word in the key. The same pole against the whole business. Present only where `differenceBand` is `moderate` or `large`: a narrower difference is too small to write in either direction."
  ),
  desiredDifferenceDirection: z3.string().optional().describe(
    "Which side of where the rest want to be the team's own wish falls, by the pole's word in the key. It compares two wishes, not a wish with today: a team asking to move toward one pole falls on the other side when the rest ask to move further, so it never says what the team asks for. That is `askedDirection`. Present only where `desiredDifferenceBand` is `moderate` or `large`."
  )
});
var engagementScore2 = z3.object({
  dimension: z3.string().describe("The question."),
  rating: satisfactionRating.describe(
    "Where its answers averaged, read as a rating."
  ),
  dissatisfiedAnswers: minorityCount.optional().describe(
    "How many of the people who answered it answered dissatisfied or very dissatisfied, read one person at a time so an average cannot hide them. Absent where nobody did, and where saying so could point to who they are."
  )
}).strict().describe("One job satisfaction question.");
var mixFields = {
  pattern: pattern.describe("The shape the types make, by name."),
  patternSegments: z3.string().describe(
    "The clusters the pattern was read from, as `Group1: evaluator-pioneer, Group2: doer`, or every type present in brackets, as `(doer, helper, coordinator)`, where the pattern is a spread rather than clusters. Which types cluster, never how many people are in a cluster."
  ),
  dominantTypes: z3.array(z3.string()).describe("The types the pattern rests on."),
  underrepresentedTypes: z3.array(z3.string()).describe(
    "The types hardly anybody holds: under about 7.5% of the profiles. Every type in `absentTypes` is here too."
  ),
  absentTypes: z3.array(z3.string()).describe("The types nobody holds at all."),
  singlePersonTypes: z3.array(z3.string()).optional().describe(
    "The types exactly one person holds: a way of thinking that rests on one person. Absent for the leadership team, and for a mix of fewer than five profiles, where every type can be one person."
  )
};
var personality = z3.discriminatedUnion("included", [
  z3.object({
    included: z3.literal(false).describe(
      "Whether the mix describes them: at least half have a profile and, for a team, at least three. Where false, there is no mix to read."
    ),
    profileCount: z3.number().describe(
      "How many of the people it describes have a work personality profile."
    )
  }).strict(),
  z3.object({
    included: z3.literal(true),
    ...mixFields
  }).strict()
]).describe("The work personality types of the people it sits under.");
var organisation = z3.object({
  dimensions: z3.array(organisationArea).describe("The 12 culture areas, read across everyone who answered."),
  alignmentGapDimensions: z3.array(z3.string()).describe(
    "The areas whose `gapBand` is `moderate` or `large`, widest band first, then the larger gap."
  ),
  cancelledAreas: z3.array(z3.string()).describe(
    "The areas whose `gapBand` is `none` while their `askBand` is `moderate` or `large`: a great deal asked for in both directions, and netted away by the average. Widest ask first."
  ),
  engagement: z3.array(engagementScore2).describe(
    "The job satisfaction questions reported for the business. One that is absent was either not asked or withheld."
  ),
  gapSignal: gapSignal.nullable().describe(
    "The widest `gapBand` across the areas, or `aligned` where every band is `none`. Null where nothing could be banded."
  ),
  personalEngagementSignal: engagementSignal.optional().describe(
    "How the five questions about people's own jobs read: `poor` where any is rated dissatisfied or very dissatisfied, `positive` where more than half are rated satisfied or very satisfied, and `neutral` otherwise. Absent wherever `withheldEngagement` names anything, because the withheld questions are exactly those five."
  ),
  companyPerceptionSignal: engagementSignal.optional().describe(
    "The same reading over the four questions about what people believe about the company. Never withheld."
  ),
  contentmentReadable: z3.boolean().describe(
    "Whether an area whose `gapBand` is `none` may be written as people being content, rather than as people who have stopped asking. False where any job satisfaction question is rated dissatisfied or very dissatisfied, or where the five about people's own jobs were withheld."
  ),
  withheldEngagement: z3.array(z3.string()).describe(
    "The job satisfaction questions that were asked and answered, and answered too few times to report without describing the people who gave them."
  ),
  personality
}).strict().describe("The whole business's figures.");
var cardOrganisation = organisation.omit({ alignmentGapDimensions: true, cancelledAreas: true }).extend({
  dimensions: z3.array(area).describe("The 12 culture areas, read across everyone who answered.")
});
var CULTURE_TEAM_CALL_OUT_REASONS = [
  "low response",
  "dissatisfied",
  "company concern",
  "feedback concern",
  "neutral spread",
  "satisfied",
  "alignment gap",
  "culture difference",
  "minority ask",
  "minority dissatisfied"
];
var qualification = z3.object({
  reasons: z3.array(z3.enum(CULTURE_TEAM_CALL_OUT_REASONS)).describe(
    "Why, or empty where it does not: `low response` where the team's completion falls in a weaker band than the campaign's (60% or more, 40% or more, or fewer), `dissatisfied` and `company concern` where the lists below them hold anything, `feedback concern` where `concernThemes` does, `neutral spread` where `neutralCount` is three or more, `satisfied` where three or more questions are in `satisfiedDimensions`, `alignment gap` and `culture difference` where their lists hold anything, `minority ask` and `minority dissatisfied` where theirs do."
  ),
  dissatisfiedDimensions: z3.array(z3.string()).describe(
    "The questions about people's own jobs the team rated dissatisfied or very dissatisfied."
  ),
  companyConcernDimensions: z3.array(z3.string()).describe(
    "The questions about the company it rated dissatisfied or very dissatisfied."
  ),
  satisfiedDimensions: z3.array(z3.string()).describe(
    "The questions about people's own jobs it rated satisfied or very satisfied."
  ),
  concernThemes: z3.array(z3.string()).describe(
    "The feedback themes at least three of this team raised and read negative in their own comments, or mixed where the whole business did not read it positive, by `themeName`. How the whole business read a theme never puts it here on its own."
  ),
  neutralCount: z3.number().nullable().describe(
    "How many of the five questions about people's own jobs it answered neutrally. Null where those five were withheld, which is not none of them sitting on the fence."
  ),
  alignmentGapDimensions: z3.array(z3.string()).describe(
    "The areas where the team's own `gapBand` is `moderate` or `large`, widest band first, then the larger gap."
  ),
  differenceDimensions: z3.array(z3.string()).describe(
    "The areas where the team sits apart from everybody it does not hold, its `differenceBand` `moderate` or `large`, widest band first. Empty under two of them: one area apart is a team doing one thing differently rather than one that works differently. Always empty on a team with `sameTeamAs`."
  ),
  minorityAskDimensions: z3.array(z3.string()).describe(
    "The areas where some of the team asked to move by more than half a point toward a pole the team's own `askedDirection` does not already name. Their `strongAsks` says which way and how many."
  ),
  minorityDissatisfiedDimensions: z3.array(z3.string()).describe(
    "The job satisfaction questions some of the team answered dissatisfied or very dissatisfied, where the team's own rating is not. Their `dissatisfiedAnswers` says how many."
  ),
  singleAreaApart: z3.string().nullable().describe(
    "The one area where the team sits `moderate` or `large` apart from everybody it does not hold, where it is the only one and so not in `differenceDimensions`. The team does this one thing differently: a reader will see it on the Subcultures page, so the report never says this team works like the rest. Null where it sits apart on no area, or on enough to be in `differenceDimensions`, and on a team with `sameTeamAs`."
  )
}).strict();
var team = z3.object({
  entityType: teamTypeWord.describe(
    "`division`, a branch of the business, or `group`, which cuts across them."
  ),
  entityName: z3.string().describe(
    "The team's name. A division inside another is written with its parent's, as `Engineering/Platform`."
  ),
  respondentBase: z3.enum(["at the reporting floor", "above the reporting floor"]).describe(
    "How many people answered from it, in words: `at the reporting floor` at three, the fewest any team is described from, and `above the reporting floor` beyond that."
  ),
  sameTeamAs: z3.object({
    entityType: teamTypeWord.describe("Its kind."),
    entityName: z3.string().describe("Its name.")
  }).strict().optional().describe(
    "The team that already holds almost everybody this one does, such as the division a division sits inside or a division under another name. Present only where the two are one set of people, and so this team is compared with the rest of the business nowhere: every comparison field on its areas is null, and how these people sit against the rest is that team's reading."
  ),
  dimensions: z3.array(teamArea).describe(
    "The 12 culture areas, read across this team's own answers, with how each compares with the rest of the business."
  ),
  engagement: z3.array(engagementScore2).describe("The job satisfaction questions reported for this team."),
  withheldEngagement: z3.array(z3.string()).describe("The questions this team answered too few times to report."),
  personality,
  qualification: qualification.describe(
    "Whether the organisation-wide report calls this team out, and why."
  )
}).strict().describe("A division or group with enough people behind it to describe.");
var CULTURE_LEADERSHIP_LEANS = {
  Directive: "leans directive",
  Democratic: "leans democratic",
  "Non-Directive": "leans non-directive"
};
var CULTURE_LEADERSHIP_SPREAD = "spread";
var leadership = z3.object({
  ...mixFields,
  styleSpread: z3.enum([
    CULTURE_LEADERSHIP_LEANS.Directive,
    CULTURE_LEADERSHIP_LEANS.Democratic,
    CULTURE_LEADERSHIP_LEANS["Non-Directive"],
    CULTURE_LEADERSHIP_SPREAD
  ]).optional().describe(
    "How they spread across the three default ways of leading: leaning toward the style that holds at least half their weight, or `spread` where none does. An advisor counts half in democratic and half in non-directive. Absent where none of them can be placed."
  ),
  advisorsFlex: z3.boolean().optional().describe(
    "Whether advisors, who move between democratic and non-directive, are a quarter of them or more. Present wherever `styleSpread` is."
  )
}).strict().describe(
  "The leadership team named on the business profile, with nobody on it named. Absent where the business has named nobody, or where fewer than three of them have a profile, too few to read as a team."
);
var themeSentiment = z3.enum(["positive", "negative", "mixed"]);
var largestTheme = z3.enum(["alone", "joint"]).optional().describe(
  "Present where no theme here covers more comments: `alone` where no other covers as many, `joint` where it ties with another. Absent on every other theme."
);
var themeStanding = {
  largest: largestTheme,
  shownOpen: z3.boolean().describe(
    `Whether the page lists it open, among the ${CULTURE_THEMES_SHOWN_OPEN} covering the most comments. The rest sit behind a fold.`
  )
};
var EARLY_INDICATION_DESCRIPTION = "Whether fewer than five comments were written, so the themes are an early indication rather than a reading.";
var themeTeams = (namedIn) => z3.array(
  z3.object({
    entityType: teamTypeWord.describe("Its kind."),
    entityName: z3.string().describe(`Its name${namedIn}.`),
    sentiment: themeSentiment.nullable().describe(
      "How that team's own comments on it read, which can differ from the theme's. Null where they carried neither a positive nor a negative mention."
    )
  }).strict()
).describe(
  `The teams${namedIn} at least three of the people behind it belong to: the only teams it may be cited for. Empty where no three share one, which is the absence of a named team rather than a reading that nobody looked.`
);
var feedbackTheme3 = z3.object({
  themeName: z3.string().describe("The name to use for it."),
  description: z3.string().describe("What the theme captures."),
  sentiment: themeSentiment.describe("How its comments read."),
  teams: themeTeams(" in `entities`"),
  fewContributors: z3.boolean().describe(
    "Whether fewer than three people wrote it. Then `teams` is empty however they were spread, and it is what one or two people said."
  ),
  largest: largestTheme,
  needsBody: z3.boolean().describe(
    `Whether it gets a \`body\`: each of the ${CULTURE_THEMES_SHOWN_OPEN} the page lists open, and where none of those reads positive, the positive one covering the most comments, which the page folds away.`
  )
}).strict();
var feedback = z3.object({
  earlyIndication: z3.boolean().describe(EARLY_INDICATION_DESCRIPTION),
  themes: z3.array(feedbackTheme3).describe("The themes the comments were grouped into."),
  sentimentReadOverPart: z3.boolean().describe(
    "Whether sentiment was read over only some of the comments, so nothing about how the feedback reads is a claim about all of it."
  ),
  sentimentSignal: sentimentSignal.optional().describe(
    "How the feedback reads overall, the label the page prints above it: `negative` where negative mentions outnumber positive, `positive` only where positive mentions are at least twice the negative, and `mixed` otherwise. Absent where no sentiment was read."
  )
}).strict().describe("The written feedback, grouped into themes.");
var businessFields = {
  identity: z3.object({
    industry: z3.string().optional().describe("Its industry."),
    founded: z3.string().optional().describe("When it was founded."),
    scale: z3.string().optional().describe("How big it says it is."),
    workModel: z3.string().optional().describe("How and where its people work."),
    locations: z3.string().optional().describe("Where it operates."),
    reach: z3.enum(["local", "national", "international"]).optional().describe("How far its market reaches.")
  }).strict().optional().describe("Who the business is."),
  purpose: z3.object({
    mission: z3.string().optional().describe("Its mission."),
    vision: z3.string().optional().describe("Its vision."),
    values: z3.array(
      z3.object({
        name: z3.string().optional().describe("The value."),
        meaning: z3.string().optional().describe("What the business means by it.")
      }).strict()
    ).optional().describe("The values it states.")
  }).strict().optional().describe("Why it exists."),
  goals: z3.array(z3.string()).optional().describe("What it is working toward."),
  structure: z3.object({
    leadershipStructure: z3.string().optional().describe(
      "How the leadership team is arranged, in the business's words."
    )
  }).strict().optional().describe("How the business is organised.")
};
var businessDescription = "What the organisation says about itself. Absent where it has said nothing, and any field in it may be absent or hold a placeholder.";
var reportBusiness = z3.object({
  ...businessFields,
  lifecycleStage: z3.string().optional().describe(
    `Where the business sits in its life: ${orList(CULTURE_LIFECYCLE_STAGES)}, or its own words where none of those fit.`
  ),
  whatIsHelping: z3.string().optional().describe(
    "What the person asking for this report says is helping right now, in their own words."
  ),
  whatIsHindering: z3.string().optional().describe("What they say is hindering, in their own words.")
}).strict().describe(businessDescription);
var campaign = z3.object({
  name: z3.string().describe("The name the business gave the campaign."),
  purpose: z3.string().optional().describe("What it was run for, where that was set.")
}).strict().describe("The campaign the answers came from.");
var CultureReportGenerationInputSchema = z3.object({
  organisation,
  entities: z3.array(
    team.extend({
      /**
       * In place of the filter paths the model was told to compare: a team called out beside
       * the division holding it is the same people counted twice, and which one holds which
       * is a prefix engage can check and a model had to spot.
       */
      withinDivision: z3.string().optional().describe(
        "The division this one sits inside, where that division is a team here too."
      ),
      wantsOppositeTo: z3.array(
        z3.object({
          entityName: z3.string().describe("The other team."),
          dimensions: z3.array(z3.string()).describe("The areas they want opposite things on.")
        }).strict()
      ).describe(
        "The other teams that want to end up on the opposite side of the rest of the business from this one: on each area named, both teams' `desiredDifferenceBand` is `moderate` or `large` and their `desiredDifferenceDirection` names opposite poles. Empty where there are none, and always on a team with `sameTeamAs`."
      )
    })
  ).describe(
    "Every division and group with enough people behind it to describe. These are the teams somebody runs, and the only cuts a finding may rest on. Ordered by the widest gap or difference each carries, then by how many people answered, so the biggest findings on the most people come first."
  ),
  leadership: leadership.optional(),
  feedback,
  business: reportBusiness.optional(),
  valuesProvided: z3.boolean().describe(
    "Whether the business states any values, and so whether `values` is written at all."
  ),
  campaign
}).strict();
var teamFeedbackTheme = z3.object({
  themeName: z3.string().describe("The name to use for it."),
  description: z3.string().describe(
    "What the theme captures across the business. It reads the same wherever it was raised."
  ),
  sentiment: themeSentiment.nullable().describe(
    "How this team's own comments on it read. Null where they carried neither a positive nor a negative mention."
  ),
  commentCount: z3.number().describe("How many of this team's comments it covers."),
  contributorCount: z3.number().describe("How many of this team wrote them."),
  ...themeStanding
}).strict();
var cultureOrgWideInsightInput = z3.object({
  insight: z3.string(),
  direction: z3.enum(CULTURE_INSIGHT_DIRECTIONS).optional(),
  dimensions: z3.array(z3.string()),
  priority: z3.enum(CULTURE_INSIGHT_PRIORITIES).optional(),
  strategicRelevance: z3.enum(CULTURE_STRATEGIC_RELEVANCE).optional(),
  sources: z3.array(source).optional(),
  whyItExists: z3.object({
    possibleExplanation: z3.string().nullable(),
    alternativeExplanation: z3.string().nullable()
  }).strict().optional()
}).strict();
var CultureEntitySummaryInputSchema = z3.object({
  entity: team.extend({
    feedback: z3.object({
      commentCount: z3.number().describe("How many comments this team wrote."),
      earlyIndication: z3.boolean().describe(EARLY_INDICATION_DESCRIPTION),
      contributorCount: z3.number().describe("How many of this team wrote them."),
      themes: z3.array(teamFeedbackTheme).describe(
        "The themes three or more of this team raised, counted for this team alone."
      )
    }).strict().describe("What this team wrote.")
  }).describe("The team this card is about."),
  organisation: cardOrganisation,
  findings: z3.object({
    orgWideInsights: z3.array(cultureOrgWideInsightInput).optional().describe(
      "Its findings about the whole business: the `insight`, its `direction`, `priority` and `strategicRelevance`, the `sources` behind it, `dimensions` naming the areas it rests on, and in `whyItExists` the `possibleExplanation` and `alternativeExplanation` the report offered for it. Those two are readings the report put forward, not causes it found."
    )
  }).strict().describe("What the organisation-wide report concluded."),
  business: z3.object(businessFields).strict().optional().describe(businessDescription)
}).strict();
var CultureReportFindingsInputSchema = CultureReportGenerationInputSchema.extend({
  leadership: leadership.omit({ styleSpread: true, advisorsFlex: true }).optional(),
  feedback: feedback.extend({
    themes: z3.array(feedbackTheme3.omit({ needsBody: true })).describe("The themes the comments were grouped into.")
  })
});
var writingFeedbackTheme = feedbackTheme3.extend({ teams: themeTeams("") });
var reportInsightInput = z3.object({
  insight: z3.string(),
  direction: z3.enum(CULTURE_INSIGHT_DIRECTIONS),
  where: z3.array(z3.string()),
  sources: z3.array(source),
  dimensions: z3.array(z3.string()),
  evidence: z3.array(z3.object({ source, text: z3.string() }).strict()),
  whyItExists: z3.object({
    possibleExplanation: z3.string().nullable(),
    alternativeExplanation: z3.string().nullable()
  }).strict()
}).strict();
var CultureWorkPersonalityInputSchema = z3.object({
  leadership: leadership.optional(),
  organisation: cardOrganisation.pick({
    dimensions: true,
    personality: true,
    contentmentReadable: true
  }),
  feedback: z3.object({
    themes: z3.array(
      writingFeedbackTheme.pick({
        themeName: true,
        description: true,
        sentiment: true,
        teams: true,
        fewContributors: true
      })
    ).describe("The themes the comments were grouped into.")
  }).strict().describe("The written feedback, grouped into themes."),
  business: reportBusiness.optional(),
  findings: z3.object({
    insights: z3.array(reportInsightInput).describe(
      "The report's findings: each `insight`, its `direction`, the places in `where` it holds, the `sources` and the areas in `dimensions` it rests on, the `evidence` line for each source, and in `whyItExists` the `possibleExplanation` and `alternativeExplanation` it offered. Those two are readings, not causes the survey found."
    )
  }).strict().describe("What the report already concluded.")
}).strict();
var CultureFeedbackWritingInputSchema = z3.object({
  feedback: feedback.extend({
    themes: z3.array(writingFeedbackTheme).describe("The themes the comments were grouped into.")
  })
}).strict();
var CULTURE_MODEL_INPUT_SHARED = [
  { name: "an area", schema: area },
  { name: "a team", schema: team },
  { name: "a work personality mix", schema: personality },
  { name: "a satisfaction score", schema: engagementScore2 }
];
var CULTURE_MODEL_INPUT_COLLAPSED = [
  cultureOrgWideInsightInput,
  reportInsightInput
];

// src/cultureReport/reportClaims.ts
var reviewInsightClaims = (insight2, input) => {
  const claims = [];
  const note = (claim) => claims.push(claim);
  const reviewed = [
    withSourcesForNamedFields,
    withQualifiedPlaces,
    withoutDividedAreas,
    withSupportedAreas,
    withReadableContentment,
    withGoingWellRatings,
    withPositiveClimate,
    withPriorityForDirection,
    withoutEmptySources
  ].reduce(
    (current, review) => current && review(current, input, note),
    { ...insight2 }
  );
  return { insight: reviewed, claims };
};
var withQualifiedPlaces = (insight2, input, note) => {
  const where = (insight2.where ?? []).filter((place) => {
    const teams = teamsNamed(place, input);
    if (!teams.length)
      return true;
    if (!teams.some(isCalledOut)) {
      note({
        rule: "unqualified team",
        subject: place,
        reason: `${place} carries no reason to be named, so it cannot be in \`where\``
      });
      return false;
    }
    if (insight2.direction === "going_well" && !teams.some(isSatisfied)) {
      note({
        rule: "going well without satisfied",
        subject: place,
        reason: `${place} does not carry \`satisfied\`, so a \`going_well\` finding cannot name it`
      });
      return false;
    }
    return true;
  });
  return leftSomewhere({ ...insight2, where }, note);
};
var leftSomewhere = (insight2, note) => {
  if (insight2.where?.length)
    return insight2;
  note({
    rule: "nowhere left",
    subject: "where",
    reason: "no place it names may carry it"
  });
  return null;
};
var withoutDividedAreas = (insight2, input, note) => {
  if (!insight2.where?.includes(CULTURE_INSIGHT_WHOLE_ORGANISATION)) {
    return insight2;
  }
  const dimensions = (insight2.dimensions ?? []).filter((dimension) => {
    const reason = whyDivided(dimension, input);
    if (!reason)
      return true;
    note({
      rule: "whole organisation on a divided area",
      subject: dimension,
      reason
    });
    return false;
  });
  return { ...insight2, dimensions };
};
var whyDivided = (dimension, { organisation: organisation2, entities }) => {
  const area2 = organisation2.dimensions.find(
    (row) => row.dimension === dimension
  );
  if (area2?.teamDirection === "opposite ways") {
    return `the teams asking on \`${dimension}\` point \`opposite ways\`, so the business-wide figure is the midpoint of their disagreement: name the teams instead`;
  }
  const apart = entities.filter(
    ({ qualification: qualification2 }) => qualification2.differenceDimensions.includes(dimension)
  ).map(({ entityName }) => entityName);
  return apart.length ? `${apart.join(", ")} already work differently on \`${dimension}\`, so it is not a finding about the whole business: name the team instead` : void 0;
};
var withSupportedAreas = (insight2, input, note) => {
  if (insight2.direction !== "needs_focus" || !cites(insight2, "culture")) {
    return insight2;
  }
  const readings = (dimension) => placesOf(insight2, input).flatMap((place) => place.areaReadings(dimension));
  const dimensions = (insight2.dimensions ?? []).filter((dimension) => {
    if (readings(dimension).some(isSupporting))
      return true;
    note({
      rule: "area nothing supports",
      subject: dimension,
      reason: `\`${dimension}\` bands \`none\` wherever this finding holds, with no \`opposite ways\` and no \`strongAsks\`, so it cannot sit on a \`needs_focus\` finding`
    });
    return false;
  });
  if (!dimensions.length || dimensions.some((dimension) => readings(dimension).some(isCarrying))) {
    return { ...insight2, dimensions };
  }
  note({
    rule: "culture carries nothing",
    subject: "culture",
    reason: "none of its areas is `moderate` or `large`, `opposite ways` or carrying `strongAsks` anywhere it holds, so the culture data cannot carry it"
  });
  return { ...insight2, dimensions: [] };
};
var withReadableContentment = (insight2, input, note) => {
  if (insight2.direction !== "going_well" || !cites(insight2, "culture")) {
    return insight2;
  }
  const readable = input.organisation.contentmentReadable;
  const dimensions = (insight2.dimensions ?? []).filter((dimension) => {
    const settled = placesOf(insight2, input).flatMap((place) => place.areaReadings(dimension)).filter(({ gapBand: gapBand2 }) => gapBand2 === "none");
    const reason = whyNotContent(dimension, settled, readable);
    if (!reason)
      return true;
    note({ rule: "contentment it cannot claim", subject: dimension, reason });
    return false;
  });
  return { ...insight2, dimensions };
};
var whyNotContent = (dimension, settled, readable) => {
  if (!settled.length)
    return void 0;
  if (!readable) {
    return `\`${dimension}\` is settled and \`contentmentReadable\` is false, so it may be people who stopped asking`;
  }
  return settled.some(isAskedOf) ? `people asked to move \`${dimension}\`, in opposite ways, by more than a little, or a few of them by a lot, so it is not contentment` : void 0;
};
var withGoingWellRatings = (insight2, input, note) => {
  if (insight2.direction !== "going_well")
    return insight2;
  const engagementDimensions = (insight2.engagementDimensions ?? []).filter(
    (question) => {
      const below = placesOf(insight2, input).flatMap(
        (place) => place.ratings(question).filter((rating) => !SATISFIED.has(rating))
      );
      if (!below.length)
        return true;
      note({
        rule: "going well below satisfied",
        subject: question,
        reason: `\`${question}\` is rated ${below[0]} where this finding holds, and a \`going_well\` finding never rests on that`
      });
      return false;
    }
  );
  return { ...insight2, engagementDimensions };
};
var withPositiveClimate = (insight2, input, note) => {
  if (insight2.direction !== "going_well")
    return insight2;
  if (!insight2.where?.includes(CULTURE_INSIGHT_WHOLE_ORGANISATION)) {
    return insight2;
  }
  if (input.organisation.personalEngagementSignal === "positive") {
    return insight2;
  }
  const engagementDimensions = (insight2.engagementDimensions ?? []).filter(
    (question) => {
      if (!isAboutTheirOwnJob(question))
        return true;
      note({
        rule: "going well on a climate that is not",
        subject: question,
        reason: `\`${question}\` is one of the five questions about people's own jobs, and across the business those five do not read positive, so a business-wide \`going_well\` finding never rests on one of them`
      });
      return false;
    }
  );
  return { ...insight2, engagementDimensions };
};
var isAboutTheirOwnJob = (question) => PERSONAL_CLIMATE_QUESTIONS.includes(question);
var withPriorityForDirection = (insight2, _input, note) => {
  if (insight2.direction === "going_well") {
    return insight2.priority === "maintain" ? insight2 : { ...insight2, priority: "maintain" };
  }
  if (insight2.direction !== "needs_focus" || insight2.priority !== "maintain") {
    return insight2;
  }
  note({
    rule: "maintain on a finding needing focus",
    subject: "priority",
    reason: "`maintain` is only for findings going well, so set `priority` to `high`, `medium` or `low` from the finding's evidence"
  });
  return { ...insight2, priority: "low" };
};
var withSourcesForNamedFields = (insight2, _input, note) => {
  const missing = NAMED_FIELDS.filter(({ source: source2, named, rule }) => {
    const keys = named(insight2);
    if (!keys.length || cites(insight2, source2))
      return false;
    note({
      rule,
      subject: source2,
      reason: `it names ${keys.map((key) => `\`${key}\``).join(", ")} without \`${source2}\` among its sources`
    });
    return true;
  });
  return missing.length ? {
    ...insight2,
    sources: [
      ...missing.map(({ source: source2 }) => source2),
      ...insight2.sources ?? []
    ]
  } : insight2;
};
var withoutEmptySources = (insight2, _input, note) => {
  const sources = withoutUnnamedSources(insight2, note);
  if (sources.length) {
    return insight2.evidence ? { ...insight2, sources, evidence: evidenceFor(insight2, sources) } : { ...insight2, sources };
  }
  note({
    rule: "nothing left behind it",
    subject: "sources",
    reason: "no source it names has anything behind it"
  });
  return null;
};
var withoutUnnamedSources = (insight2, note) => (insight2.sources ?? []).filter((source2) => {
  const field = NAMED_FIELDS.find((named) => named.source === source2);
  if (!field || field.named(insight2).length)
    return true;
  note({
    rule: "source with nothing behind it",
    subject: source2,
    reason: `it names \`${source2}\` as a source with nothing named behind it`
  });
  return false;
});
var evidenceFor = (insight2, kept) => {
  const removed = (insight2.sources ?? []).filter(
    (source2) => !kept.includes(source2)
  );
  return insight2.evidence?.filter(
    ({ source: source2 }) => !source2 || !removed.includes(source2)
  );
};
var NAMED_FIELDS = [
  {
    source: "culture",
    named: ({ dimensions }) => dimensions ?? [],
    rule: "areas without their source"
  },
  {
    source: "job satisfaction",
    named: ({ engagementDimensions }) => engagementDimensions ?? [],
    rule: "questions without their source"
  }
];
var cites = ({ sources }, source2) => Boolean(sources?.includes(source2));
var placesOf = (insight2, input) => {
  const named = (insight2.where ?? []).flatMap(
    (place) => placeNamed(place, input)
  );
  return insight2.where?.includes(CULTURE_INSIGHT_WHOLE_ORGANISATION) ? [...named, ...teamsAskingAlong(insight2, input).map(teamPlace)] : named;
};
var placeNamed = (place, input) => {
  if (place === CULTURE_INSIGHT_WHOLE_ORGANISATION) {
    return [organisationPlace(input)];
  }
  if (place === CULTURE_INSIGHT_LEADERSHIP_TEAM)
    return [];
  return teamsNamed(place, input).filter(isCalledOut).map(teamPlace);
};
var organisationPlace = ({ organisation: organisation2 }) => ({
  areaReadings: (dimension) => organisation2.dimensions.filter((area2) => area2.dimension === dimension).map((area2) => ({ gapBand: area2.gapBand, area: area2 })),
  ratings: (question) => ratingsOf(organisation2.engagement, question)
});
var teamPlace = (team2) => ({
  areaReadings: (dimension) => team2.dimensions.filter((area2) => area2.dimension === dimension).map((area2) => ({ gapBand: area2.gapBand, area: area2, team: team2 })),
  ratings: (question) => ratingsOf(team2.engagement, question)
});
var ratingsOf = (engagement, question) => engagement.filter(({ dimension }) => dimension === question).map(({ rating }) => rating);
var teamsAskingAlong = ({ dimensions }, { organisation: organisation2, entities }) => entities.filter(
  (team2) => isCalledOut(team2) && (dimensions ?? []).some((dimension) => {
    const direction = organisation2.dimensions.find(
      (area2) => area2.dimension === dimension
    )?.askedDirection;
    return Boolean(direction) && team2.dimensions.some(
      (area2) => area2.dimension === dimension && isReportable(area2.gapBand) && area2.askedDirection === direction
    );
  })
);
var teamsNamed = (place, { entities }) => entities.filter(({ entityName }) => entityName === place);
var isCalledOut = ({ qualification: qualification2 }) => qualification2.reasons.length > 0;
var isSatisfied = ({ qualification: qualification2 }) => qualification2.reasons.includes("satisfied");
var isCarrying = ({ gapBand: gapBand2, area: area2, team: team2 }) => isReportable(gapBand2) || area2.respondentDirection === "opposite ways" || Boolean(area2.strongAsks?.length) || Boolean(team2 && isTeamApart(team2, area2.dimension));
var isTeamApart = (team2, dimension) => team2.qualification.differenceDimensions.includes(dimension) || team2.wantsOppositeTo.some(({ dimensions }) => dimensions.includes(dimension));
var isSupporting = (reading) => reading.gapBand === "small" || isCarrying(reading);
var isAskedOf = ({ area: area2 }) => area2.pairedChange !== void 0 && area2.pairedChange.askBand !== "none" || area2.respondentDirection === "opposite ways" || Boolean(area2.strongAsks?.length);
var isReportable = (band) => band === "moderate" || band === "large";
var SATISFIED = /* @__PURE__ */ new Set(["satisfied", "very satisfied"]);

// src/cultureReport/reportCoverage.ts
var findUncoveredFindings = (insights, figures) => requiredFindings(figures).filter(
  (finding) => !insights.some((insight2) => carries(insight2, finding))
);
var requiredFindings = ({ entities }) => entities.filter(({ sameTeamAs }) => !sameTeamAs).flatMap(({ entityName, qualification: qualification2 }) => [
  ...findingsOf(
    "minority ask",
    entityName,
    qualification2.minorityAskDimensions
  ),
  ...findingsOf(
    "dissatisfied",
    entityName,
    qualification2.dissatisfiedDimensions
  ),
  ...findingsOf(
    "company concern",
    entityName,
    qualification2.companyConcernDimensions
  )
]);
var findingsOf = (kind, team2, subjects = []) => subjects.map((subject) => ({ kind, team: team2, subject }));
var carries = (insight2, finding) => Boolean(insight2.where?.includes(finding.team)) && Boolean(subjectsOf(insight2, finding.kind)?.includes(finding.subject));
var subjectsOf = (insight2, kind) => kind === "minority ask" ? insight2.dimensions : insight2.engagementDimensions;

// src/cultureReport/contextAnswers.ts
var CULTURE_REPORT_CONTEXT_ANSWER_LIMIT = 600;
export {
  COMPANY_CLIMATE_QUESTIONS,
  CULTURE_ALL_ONE_WAY,
  CULTURE_DIMENSIONS,
  CULTURE_ENTITY_TYPES,
  CULTURE_ENTITY_TYPE_WORDS,
  CULTURE_EXCLUSION_REASONS,
  CULTURE_FIT_QUESTIONS,
  CULTURE_HOW_MANY_ASKED,
  CULTURE_INSIGHT_DIRECTIONS,
  CULTURE_INSIGHT_LEADERSHIP_TEAM,
  CULTURE_INSIGHT_PRIORITIES,
  CULTURE_INSIGHT_WHOLE_ORGANISATION,
  CULTURE_LEADERSHIP_LEANS,
  CULTURE_LEADERSHIP_SPREAD,
  CULTURE_LIFECYCLE_STAGES,
  CULTURE_MIDDLE_POSITION,
  CULTURE_MINORITY_COUNTS,
  CULTURE_MODEL_INPUT_COLLAPSED,
  CULTURE_MODEL_INPUT_SHARED,
  CULTURE_REPORT_CONTEXT_ANSWER_LIMIT,
  CULTURE_REPORT_SOURCES,
  CULTURE_RESPONDENT_SPLITS,
  CULTURE_SENTIMENT_SIGNALS,
  CULTURE_SLIGHT_LEAN,
  CULTURE_SOURCE_LABELS,
  CULTURE_STRATEGIC_RELEVANCE,
  CULTURE_TEAM_CALL_OUT_REASONS,
  CULTURE_THEMES_SHOWN_OPEN,
  CULTURE_UNMEASURED_REASONS,
  CULTURE_VALUE_ALIGNMENTS,
  CULTURE_WRITTEN_EVIDENCE_SOURCES,
  CultureEntitySummaryCardSchema,
  CultureEntitySummaryInputSchema,
  CultureFeedbackWritingInputSchema,
  CultureReportDocumentSchema,
  CultureReportFindingsInputSchema,
  CultureReportGenerationInputSchema,
  CultureWorkPersonalityInputSchema,
  DISTRIBUTION_PATTERNS,
  ENGAGEMENT_DIMENSIONS,
  GOING_WELL,
  JOB_FIT_QUESTIONS,
  LEADERSHIP_STYLES,
  NEEDS_FOCUS,
  PERSONALITY_FIT_1_QUESTIONS,
  PERSONALITY_FIT_2_QUESTIONS,
  PERSONAL_CLIMATE_QUESTIONS,
  ROLE_NAMES,
  areAdjacent,
  areGroupsOpposing,
  calculatePercentageDistribution,
  calculatePersonalityType,
  checkAdjacentPattern,
  checkGroupPatterns,
  checkOpposingPattern,
  credibilitySignal,
  cultureOrgWideInsightInput,
  culturePoleLabels,
  cultureSlightLean,
  describeGapDirection,
  describeLeadershipStyles,
  describeRespondentSplit,
  engagementSignal,
  findAdjacentGroups,
  findDistributionPattern,
  findOccupiedIndices,
  findPatternOnPercentages,
  findUncoveredFindings,
  gapBand,
  gapSignal,
  groupPreferences,
  individualPreferences,
  isAlternatingPattern,
  leadershipStyleShare,
  observationBandFor,
  observations,
  personalityFit,
  respondentSplit,
  reviewInsightClaims,
  roleCounts,
  satisfactionRating,
  satisfactionRatingFor,
  sentimentCounts,
  sentimentSignal,
  significantHighNumbers,
  source,
  stylesForPersonalityType,
  unmeasuredReason,
  workPreferenceTypes,
  workPreferences
};
